export default {
  locale: 'es',
  messages: {
    accountMy: 'Mi cuenta',
    actions: 'Acciones',
    add: 'Añadir',
    addressAddNew: 'Añadir una nueva dirección',
    addressCity: 'Ciudad',
    addressCountries: 'Países',
    addressCountry: 'País',
    addressDeleteConfirmTitle: 'Eliminar una dirección',
    addressDeleteConfirmMessage: '¿Seguro que quieres eliminar esta dirección?',
    addressDeleteSuccess: '¡Dirección eliminada con éxito!',
    addressEdit: 'Modificar dirección',
    addressFlags: 'Banderas',
    addressInvoice: 'Dirección de facturación',
    addressInvoiceDifferentAsShippingLabel: '¿Los datos de facturación son diferentes a la dirección de envío?',
    addressInvoiceSelectionTitle: 'Selecciona tu dirección de facturación',
    addressInvoiceUsedFor: 'Utilizado para la factura',
    addressInvoiceUse: 'Usar para la factura',
    addressLabel: 'Nombre de la dirección (ej: Casa, Trabajo)',
    addressLegalInformation: 'Información legal',
    addressMy: 'Mis direcciones',
    addressName: 'Nombre y apellidos del destinatario',
    addressNoItems: '¡Aún no has guardado ninguna dirección!',
    addressPhone: 'Teléfono (necesario para la entrega)',
    addressPostalCode: 'Código postal',
    addressRegion: 'Estado / provincia',
    addressShipping: 'Dirección de envío',
    addressShippingSelectionTitle: 'Selecciona tu dirección de envío',
    addressStreet1: 'Dirección',
    addressStreetNumberHint: 'No olvides el número: sin él el transportista no suele encontrar la dirección.',
    addressPostalCodeInvalid: 'Este código postal no corresponde al país seleccionado.',
    addressPhoneInvalid: 'Este número parece incorrecto. El transportista lo usa para contactarte.',
    addressPhoneMobileHint: 'Se recomienda un móvil: el transportista envía el aviso de entrega por SMS.',
    addressIssueTitle: 'Esta dirección debe completarse antes del envío',
    addressIssueIncomplete: 'Faltan campos obligatorios.',
    addressIssuePostalCode: 'Revisa el código postal para el país seleccionado.',
    addressIssuePhone: 'Se necesita un teléfono localizable: el transportista te llama o envía el aviso de entrega.',
    addressIssueRegion: 'Selecciona el estado o la provincia que exige el transportista.',
    addressIssueTaxId: 'La aduana exige un identificador fiscal para este destino.',
    addressIssueComplete: 'Completar esta dirección',
    addressStreet2: 'Complemento de dirección (piso, puerta, escalera...)',
    administrationTitle: 'Administración',
    affiliationComment: 'Comentario',
    affiliationCommission: 'Comisión',
    affiliationCommissionMultiplePendingAlert: 'Esta lista es una estimación: ¡Los pedidos y comisiones aún no están consolidados!',
    affiliationCommissionPendingAlert: 'Este pedido está pendiente de validación',
    affiliationDeleteConfirmMessage: '¿Seguro que quieres eliminar esta afiliación?',
    affiliationInvoiceTotalTitle: 'Total a cobrar (IVA incl.)',
    affiliationKey: 'Clave de afiliado',
    affiliationLegalApplyVAT: '¿Aplicar IVA?',
    affiliationLegalInformations: 'Información legal (facturación, NIF/CIF...)',
    affiliationMy: 'Mis afiliaciones',
    affiliationOptionValidityDays: 'Validez del enlace de afiliado (días)',
    affiliationSince: 'Miembro desde',
    affiliationViewResultsMy: 'Ver ingresos de afiliación',
    affiliations: 'Afiliaciones',
    alertContactError: '¡Imposible enviar tu mensaje! Por favor, inténtalo de nuevo...',
    alertContactSuccess: '¡Recibido!',
    alertConversationNoExists: '¡Este chat no existe!',
    alertFetchApiError: 'El servidor no está disponible actualmente...',
    alertFormRequiredFieldsError: '¡Por favor, rellena todos los campos obligatorios!',
    alertGenericError: '¡Ha ocurrido un error! Por favor, inténtalo más tarde...',
    alertInstitutionAlreadyExists: '¡Esta institución ya existe!',
    alertJsonParseError: 'El servidor ha devuelto una respuesta no válida...',
    alertOrderValid: '¡Tu pedido está listo para ser preparado!',
    alertUnauthorized: '¡Tu sesión ha caducado! Por favor, vuelve a conectarte.',
    alertUserAlreadyExists: '¡Ya existe una cuenta con este correo electrónico!',
    alertUserRegisterSuccess: '¡Te damos la bienvenida!',
    app404ErrorText: '¡No encontramos lo que buscas! Vuelve a la página de inicio o a tu cuenta.',
    app404ErrorTitle: 'Camino equivocado...',
    appAccessButton: 'Acceder a {app}',
    appAgreementAcceptButton: 'Leer los términos y condiciones de uso',
    appAgreementAcceptHelp: 'Puedes leer las condiciones haciendo clic en este enlace',
    appAgreementAcceptClickHint: 'Haz clic aquí para marcar y aceptar',
    appAgreementAcceptLabel: 'He leído y acepto los términos y condiciones',
    appApplication: 'Aplicación',
    appBackHomeButton: 'Volver al inicio',
    appBackHomeTitle: 'Te has perdido...',
    appBugErrorText: 'Ha ocurrido un problema... ¡LO SENTIMOS! Por favor, haz clic en el enlace de abajo para recargar esta página...',
    appConditionsAcceptTitle: 'Términos y condiciones de uso',
    appConditionsCheckError: '¡Por favor, marca la casilla confirmando que has leído los términos y condiciones de uso!',
    appConditionsCheckLabel: 'He leído y acepto los términos y condiciones de uso',
    appConditionsCheckSuccess: '¡Entendido!',
    appConditionsUpdateDate: 'Actualizado el {date}',
    appConfig: 'Config',
    appConfiguration: 'Configuración',
    appCookieConsentPrivacyLink: 'Consulta nuestra política de privacidad',
    appCookieConsentText: 'Al continuar navegando por esta web, aceptas el uso de cookies para el correcto funcionamiento del servicio y con fines estadísticos. No compartiremos ningún dato personal sin tu consentimiento previo.',
    appCreateIndexButton: 'Crear índice de la base de datos',
    appDataPrivacyCheckButton: 'Lee nuestra política de protección de datos',
    appDatabase: 'Base de datos',
    appErrorAlertText: 'Algo inesperado ha ocurrido... ¡Que no cunda el pánico! Contáctanos y resolveremos tu problema lo antes posible.',
    appErrorAlertTitle: '¡Se ha producido un error!',
    appForceUpdateApp: 'Forzar actualización de la App',
    appForceUpdateAppWeb: 'Forzar actualización de la Web App',
    appHome: 'Inicio',
    appMaintenanceModeText: 'Por favor, espera un momento y vuelve a intentarlo en unos instantes...',
    appMaintenanceModeTitle: 'Estamos en mantenimiento',
    appProcessLaunch: 'Proceso de lanzamiento',
    appQuestionLink: '¿Tienes dudas?',
    appRewiewsHeaderText: 'Fabricado en Francia 🇫🇷 con Amor ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ +500 opiniones en Trustpilot',
    appShopOrderHistory: 'Seguimiento del pedido',
    appStart: 'Crea tu libro',
    appVersion: 'Versión',
    appVersionCurrent: 'Versión actual de la aplicación: {version}',
    appWebsiteAboutUs: 'Nuestra historia',
    appWebsiteBlog: 'Blog',
    appWebsiteBook: 'El libro',
    appWebsiteConversationAndroid: 'Imprimir SMS de Android',
    appWebsiteConversationInstagram: 'Imprimir mensajes de Instagram',
    appWebsiteConversationIos: 'Imprimir iMessages/SMS de iPhone',
    appWebsiteConversationMessenger: 'Imprimir mensajes de Messenger',
    appWebsiteConversationWhatsapp: 'Imprimir mensajes de WhatsApp',
    appWebsiteConversations: 'Elige tu mensajería',
    appWebsiteFaq: 'Preguntas Frecuentes',
    appFooterQuestion: '¿Tienes una pregunta?',
    appFooterTerms: 'Condiciones de uso',
    appWebsitePrices: 'Precios',
    appWelcomeTitle: 'Bienvenido a {name}',
    apply: 'Aplicar',
    back: 'Volver',
    by: 'por',
    cancel: 'Cancelar',
    cartAddTo: 'Añadir al carrito',
    cartAuthInfo: 'Por favor, introduce tu email para continuar...',
    cartContinuePurchase: 'Seguir comprando',
    cartEmptyError: 'Tu carrito está vacío...',
    cartItemsRemoveAll: 'Eliminar todo',
    cartMy: 'Mi carrito',
    cartMyEdit: 'Modificar mi carrito',
    cartNextStepButton: 'Pasar al siguiente paso',
    cartNoItems: 'No hay ningún artículo en tu carrito.',
    cartNote: 'Nota',
    cartProgression: 'Progreso del carrito',
    cartSalesConditionsAccept: 'Al confirmar tu pedido, aceptas nuestras condiciones de venta.',
    cartSee: 'Ver mi carrito',
    cartShipping: 'Envío',
    cartShippingFeeError: '¡No podemos realizar envíos a esta dirección! Por favor, introduce otra dirección.',
    cartStepConfirmationTitle: 'Confirmación',
    cartStepInvoiceTitle: 'Facturación',
    cartStepPaymentTitle: 'Pago',
    cartStepPreviewTitle: 'Carrito',
    cartStepShippingTitle: 'Envío',
    cartTotalShipping: 'Gastos de envío',
    cartTotalSubTotal: 'Subtotal',
    cartTotalTax: 'IVA',
    cartTotalTotal: 'Total',
    cartValidButton: 'Confirmar mi pedido',
    checkoutEyebrow: 'Tu pedido',
    checkoutStepUpsellTitle: '¿Un ejemplar, o dos?',
    checkoutStepUpsellTitleGroup: '¿Un ejemplar, dos? ¿O más?',
    checkoutStepUpsellHint: 'Quédate uno, regala otro a un ser querido, o ambos.',
    checkoutStepUpsellHintGroup: 'Uno para cada uno: descuento desde el segundo ejemplar.',
    checkoutStepShippingTitle: '¿Dónde recibir tu libro?',
    checkoutStepShippingHint: 'Lo imprimimos con cuidado y lo enviamos a todo el mundo.',
    checkoutStepInvoiceTitle: 'Tus datos',
    checkoutStepInvoiceHint: 'Para tu factura y el seguimiento de tu pedido.',
    checkoutStepPaymentTitle: 'Paga con total seguridad',
    checkoutStepPaymentHint: 'Tarjeta, Apple Pay, Google Pay: pago cifrado.',
    checkoutPdfReadyTitle: 'Tu eBook está listo',
    checkoutPdfReadyHint: 'Sin envío necesario, finaliza tu pedido.',
    checkoutSummaryEyebrow: 'Resumen',
    cartReassuranceSecure: 'Pago seguro',
    cartReassuranceReturn: 'Satisfacción garantizada',
    cartReassuranceSupport: 'Atención al cliente',
    checkoutPromoEyebrow: 'Código promocional',
    checkoutGiftEyebrow: 'Tarjeta regalo',
    checkoutGiftCodeLabel: 'Código regalo',
    checkoutGiftCodePlaceholder: 'Introduce tu código regalo',
    checkoutGiftCodeHint: '¿Has recibido una tarjeta regalo? Introduce tu código aquí.',
    checkoutGiftToggle: '¿Tienes una tarjeta regalo?',
    checkoutAddCopy: 'Añadir un ejemplar',
    checkoutSecondCopyKicker: 'Para ti, o para regalar',
    checkoutSecondCopyKickerGroup: 'Uno para cada uno',
    checkoutSecondCopyTitle: 'El ejemplar de más, a mitad de precio',
    checkoutSecondCopyTitlePercent: 'El ejemplar de más',
    checkoutSecondCopyFor: 'este ejemplar',
    checkoutSecondCopyForGroup: 'el 2.º',
    checkoutSecondCopyChip: '2.º a mitad de precio',
    checkoutSecondCopyChipPercent: '2.º al −{percent} %',
    checkoutSecondCopySet: 'Los {count} tomos, juntos',
    checkoutSecondCopyPerBook: 'cada libro',
    checkoutSecondCopySetPrice: '{price} los {count} tomos',
    checkoutExtraBooksChip: 'libros de más a mitad de precio',
    checkoutExtraBooksChipPercent: 'libros de más al −{percent} %',
    checkoutGroupQtyHint: 'El tercero también: cada libro de más, al −{percent} %.',
    productExtraCopyRate: 'Libros de más, en % del precio de un libro',
    productExtraCopyRateHelp: 'Cada libro a partir del segundo ejemplar vale este porcentaje del precio de un libro. Vacío: 50 %. 0: tramos por cantidad.',
    checkoutGroupPicksLabel: 'Ejemplares',
    checkoutGroupAddSecond: '2.º',
    checkoutGroupAddThird: '3',
    checkoutGroupAddSecondAria: 'Añadir el segundo ejemplar a mitad de precio',
    checkoutGroupAddThirdAria: 'Pasar a tres ejemplares',
    checkoutQtyGroupHint: 'Uno para cada uno: el descuento empieza en el segundo ejemplar.',
    checkoutQtyPdfSingle: '1 eBook',
    checkoutQtyMoreAriaLabel: 'Otra cantidad',
    checkoutQtyVolumeBreakdown: '{copies} ejemplares × {volumes} tomos = {total} libros',
    checkoutOfferBookCount: '{count, plural, one {# libro} other {# libros}}',
    checkoutUpsellTwoHint: 'Ideal para regalar: añade un segundo ejemplar, el descuento se aplica automáticamente.',
    checkoutEmptyTitle: 'Ningún pedido en curso',
    checkoutEmptyHint: 'Vuelve a tu libro para elegir tu edición.',
    checkoutEmptyCta: 'Ver mis conversaciones',
    checkoutBookAsideEyebrow: 'Tu libro',
    checkoutBookAsideEyebrowPlural: 'Tus libros',
    checkoutBookAsideVolume: 'tomo',
    checkoutBookAsideVolumes: 'tomos',
    checkoutBookAsideShelfLabel: 'Los {count} tomos de tu pedido',
    checkoutBookAsideEbook: 'eBook',
    checkoutBookAsidePaper: 'Libro impreso',
    checkToggler: 'Seleccionar/Deseleccionar todo',
    choose: 'Elegir',
    close: 'Cerrar',
    cmsDeleteConfirmTitle: 'Eliminar el contenido',
    cmsDeleteConfirmMessage: '¿Seguro que quieres eliminar este contenido?',
    companyShippingEdit: 'Modificar transporte',
    conditions: 'Condiciones',
    configMissingKeyAlert: '¡Falta la clave de configuración!',
    configuration: 'Configuración',
    confirm: 'Confirmar',
    confirmMessage: 'Por favor, confirma tu acción.',
    confirmTitle: '¿Seguro?',
    contactButton: 'Contáctanos',
    contactMessage: 'Mensaje',
    contactPageButton: 'Enviar',
    contactPageText1: '¿Necesitas ayuda? ¿Información? ¡Estamos aquí para ti!',
    contactPageTitle: 'Contáctanos',
    contactSend: 'Enviar',
    continue: 'Continuar',
    conversationActionContinue: 'Continuar',
    conversationActionRestart: 'Empezar de nuevo',
    conversationAddTitle: 'Añadir un chat',
    conversationAdminDeleteConfirmTitle: 'Eliminar el chat',
    conversationAdminDeleteConfirmMessage: 'Este chat y todos sus archivos multimedia se eliminarán definitivamente. Esta acción es irreversible.',
    conversationArchiveError: '¡No podemos leer tu archivo! Por favor, contáctanos para resolver el problema...',
    conversationBookOrderTypeBook: 'Libro en papel + eBook(s) de regalo',
    conversationBookOrderTypePdf: 'Solo eBook(s)',
    conversationBookPreview: 'Vista previa',
    conversationBookPreviewSelected: 'Vista previa del libro n°{number}',
    conversationBookSelector: 'Selecciona el libro a modificar',
    conversationBookTypeLabelBook: 'Papel + Ebook',
    conversationBookTypeLabelPdf: 'Solo Ebook',
    conversationBooks: 'Libros',
    conversationCollectorArchiveSelectButton: 'Subir un archivo',
    conversationCollectorInitWaiting: 'Estamos preparando tus datos... Por favor, espera',
    conversationCollectorUseArchive: 'Subir una copia de seguridad (archivo .zip)',
        conversationCoverBookEdit: 'Personalizar la portada',
    conversationCoverBookReset: 'Restablecer la portada de este libro',
    conversationCoverApplyToAllBooks: 'Aplicar esta portada a todos los tomos',
    conversationCoverAutoAppliedToAllBooks: 'Portada aplicada a los demás tomos.',
    conversationCoverApplyToAllBooksTitle: '¿Aplicar esta portada a todos los tomos?',
    conversationCoverApplyToAllBooksMessage: 'Elige los elementos que se aplicarán a todos los demás tomos.',
    conversationCoverApplyOptionColor: 'Color',
    conversationCoverApplyOptionPhoto: 'Foto',
    conversationCoverApplyOptionTitle: 'Título',
    conversationCoverApplyOptionSubtitle: 'Subtítulo',
    conversationCoverBookSwitchAlertMessage: 'Solo se guardará la información de la portada para este libro específico.',
    conversationCoverBookSwitchAlertTitle: '¿Quieres guardar la portada para este libro?',
        conversationCoverColorEditTitle: 'Elige tu portada',
        conversationCoverLuxEyebrow: 'Tu portada',
        conversationCoverLuxHint: 'Elige el modelo y el color, luego personaliza la portada.',
        conversationParticipantsLuxEyebrow: 'Tu conversación',
        conversationParticipantsLuxHint: 'Edita los nombres, los colores de las burbujas y la posición izquierda/derecha de cada participante.',
        conversationParticipantsLuxSavePreview: 'Guardar · volver a la vista previa',
        conversationParticipantsLuxSaved: 'Guardado',
        conversationParticipantsSameSideHint: 'Varios participantes están en el mismo lado. Revisa la posición izquierda/derecha.',
        conversationParticipantColorBlushClair: 'Blush claro',
        conversationParticipantColorCielClair: 'Cielo claro',
        conversationParticipantColorLavandeClaire: 'Lavanda clara',
        conversationParticipantColorPruneClaire: 'Ciruela clara',
        conversationParticipantColorPecheClaire: 'Melocotón claro',
        conversationParticipantColorSaugeClair: 'Salvia clara',
        conversationParticipantColorMiel: 'Miel',
        conversationParticipantColorPerle: 'Perla',
        conversationParticipantNameError: 'El nombre es demasiado largo (máx. {max} caracteres)',
        conversationParticipantPositionLeft: 'Izquierda',
        conversationParticipantPositionRight: 'Derecha',
        conversationDatesLuxEyebrow: 'Tu historia',
        conversationDatesLuxHint: 'Elige la fecha de inicio y de fin del libro. Haz clic en un mensaje para afinar la selección.',
        conversationDatesLuxNextEnd: 'Fecha de fin',
        conversationDatesLuxBackStart: 'Fecha de inicio',
        conversationDatesLuxSavePreview: 'Guardar · volver a la vista previa',
        conversationDatesPresetsLabel: 'Selección rápida de período',
        conversationDatesPreset_all: 'Toda la conversación',
        conversationDatesPreset_year: 'Último año',
        conversationDatesPreset_sixMonths: 'Últimos 6 meses',
        conversationDatesSelectionCount: '{count, number} {count, plural, one {mensaje} other {mensajes}}',
        conversationDatesSelectionPeriod: 'del {start} al {end}',
        conversationDatesStoryDuration: 'Esta selección cubre {duration}',
        conversationDatesStartCaption: 'Tu primer mensaje',
        conversationDatesEndCaption: 'Tu último mensaje',
        conversationDatesBookMessages: '{messages, number} {messages, plural, one {mensaje} other {mensajes}}, {photos, number} {photos, plural, one {foto} other {fotos}} y {medias, number} {medias, plural, one {media} other {medias}} en tu selección',
        conversationDateSelectionEmpty: 'No hay mensajes en este período. Amplía la selección.',
        conversationMessagesLuxEyebrow: 'Tu libro',
        conversationMessagesLuxHint: 'Busca, oculta o edita mensajes. Tus cambios se aplican a tu selección.',
        conversationMessagesLuxSavePreview: 'Guardar · volver a la vista previa',
        conversationMessagesLuxBackPreview: 'Ver la vista previa',
        conversationMessagesLuxCount: '{messages, number} {messages, plural, one {mensaje} other {mensajes}}, {photos, number} {photos, plural, one {foto} other {fotos}} y {medias, number} {medias, plural, one {media} other {medias}} en tu selección',
        conversationMessagesFilterResults: '{count, number} {count, plural, one {resultado} other {resultados}}',
        conversationMessagesOnlyHidden: 'Solo ocultos',
        conversationMessagesResetFilters: 'Restablecer los filtros',
        conversationMessagesShowHidden: 'Mostrar los mensajes ocultos',
        conversationMessagesResetChanges: 'Deshacer todos los cambios',
        conversationMessagesResetChangesButton: 'Deshacer todo',
        conversationMessagesResetChangesConfirm: 'La conversación se restaurará a su estado original importado. Se perderán definitivamente todos tus cambios (mensajes ocultos, editados o añadidos). ¿Continuar?',
        conversationMediaTypePhotos: 'Fotos',
        conversationMediaTypeVideos: 'Vídeos',
        conversationMediaTypeAudios: 'Audios',
        conversationMediaTypeLinks: 'Enlaces',
        conversationMediaTypeOther: 'Otros',
        conversationMessagesToolSearch: 'Buscar',
        conversationMessagesToolMedias: 'Medios',
        conversationMessagesToolDates: 'Fechas',
        conversationMessagesToolHidePeriod: 'Ocultar un periodo',
        conversationMessagesToolHidden: 'Visualización',
        conversationMessagesToolReset: 'Cambios',
        conversationMessagesToolResetNone: 'Ninguno',
        conversationMessagesToolResetCount: '{count, number} {count, plural, one {cambio} other {cambios}}',
        conversationMessagesHiddenViewHint: 'Elige qué mensajes aparecen en la lista de abajo.',
        conversationMessagesHiddenViewAll: 'Todos',
        conversationMessagesHiddenViewVisible: 'Solo visibles',
        conversationMessagesHiddenViewHidden: 'Solo ocultos',
        conversationMessagesResetChangesHint: 'Restaura la conversación a su estado original importado. Se perderán todos tus cambios (mensajes ocultos, editados o añadidos).',
        conversationMessagesToolSearchNone: 'Ninguna',
        conversationMessagesToolMediasAll: 'Todos los mensajes',
        conversationMessagesToolDatesAll: 'Todo el periodo',
        conversationMessagesToolHidePeriodNone: 'Sin periodo',
        conversationMessagesToolHiddenShown: 'Mostrados',
        conversationMessagesToolHiddenMasked: 'Ocultos',
        conversationMessagesBestofCuratedHint: 'Tu Best Of ya está montado: está lleno hasta su número máximo de páginas. Puedes ocultar mensajes y volver a mostrar otros mientras el libro no se alargue.',
        conversationMessagesBestofFullError: 'Tu Best Of ya está completo. Para mostrar estos mensajes, oculta antes unas {pages, number} {pages, plural, one {página} other {páginas}} en otra parte.',
        conversationMessagesHidePeriodHint: 'Oculta (o vuelve a mostrar) todos los mensajes entre dos fechas de una vez.',
        conversationMessagesHidePeriodFrom: 'Desde',
        conversationMessagesHidePeriodTo: 'Hasta',
        conversationMessagesHidePeriodCount: '{count, number} {count, plural, one {mensaje} other {mensajes}} en este periodo ({visible} visibles, {hidden} ocultos)',
        conversationMessagesHidePeriodConfirmHide: '¿Ocultar {count, number} {count, plural, one {mensaje} other {mensajes}} de este periodo?',
        conversationMessagesHidePeriodConfirmShow: '¿Volver a mostrar {count, number} {count, plural, one {mensaje} other {mensajes}} de este periodo?',
        conversationMessagesHidePeriodHide: 'Ocultar este periodo',
        conversationMessagesHidePeriodShow: 'Volver a mostrar este periodo',
        conversationMessagesHidePeriodItem: 'Periodo {index}',
        conversationMessagesHidePeriodAdd: 'Añadir un periodo',
        conversationMessagesHidePeriodInvalid: 'La fecha de fin debe ser posterior a la fecha de inicio.',
        conversationMessagesToolHidePeriodCount: '{count, number} {count, plural, one {periodo} other {periodos}}',
        conversationMessagesSearchPlaceholder: 'Buscar una palabra, un nombre…',
        conversationCoverResumeLuxEyebrow: 'Prefacio',
        conversationCoverResumeLuxHint: 'Opcional: este texto se imprime en la contraportada.',
        conversationCoverBookNumber: 'Tomo {number}',
        conversationCoverFooterPrefaceGuide: 'Vuelve a la vista previa para omitir el prefacio, o continúa para redactarlo (opcional, en la contraportada).',
        conversationCoverFooterNextPreface: 'Prefacio (opcional)',
        conversationCoverFooterSkipPreface: 'Omitir prefacio · volver a la vista previa',
        conversationCoverFooterBackToCover: 'Volver a la portada',
        conversationCoverFooterFinishPreview: 'Terminar · volver a la vista previa',
        conversationCoverFooterGoPreview: 'Volver a la vista previa',
    conversationCoverEditionTypeTitle: 'Tipo de edición del libro',
    conversationCoverEditionTypeBookHelp: 'En la colección completa, personaliza la portada de cada tomo.',
    conversationCoverColorSelectorHelp: 'Selecciona el color de la portada',
    conversationCoverStyleSelectorHelp: 'Elige el modelo de portada',
    conversationCoverStylePhoto: 'Polaroid',
    conversationCoverStyleIncipit: 'Primer mensaje',
    conversationCoverPickMessageTitle: 'Elige un mensaje',
    conversationCoverEditQuote: 'Cambia la frase',
    conversationCoverPickMessageHint: 'Se ve en grande en la portada.',
    conversationCoverPickMessageSearch: 'Buscar un mensaje',
    conversationCoverPickMessageEmpty: 'Ningún mensaje coincide.',
    conversationCoverAddQuote: 'Añadir una frase',
    conversationCoverHourLabel: 'Hora',
    conversationCoverDateLabel: 'Fecha',
    conversationCoverGroupNameLabel: 'Nombre del grupo',
    conversationCoverSpanLabel: 'Fechas del primer y del último mensaje',
    conversationCoverApplyOptionStyle: 'Modelo',
    conversationCoverApplyOptionQuote: 'Frase',
    conversationCoverDragNDropFiles: 'Arrastra y suelta una imagen aquí',
    conversationCoverTapToSelectPhoto: 'Toca para elegir una foto',
    conversationCoverOpenFinder: 'Selecciona una imagen',
    conversationCoverPhotoSelectorTitle: 'Elige una foto',
    conversationCoverPhotoEditHint: 'Haz clic para cambiar la foto',
    conversationCoverPhotoChoose: 'Haz clic para elegir una foto',
    conversationPreviewSwipeHint: 'Desliza para pasar las páginas',
    conversationPreviewOpenBookHint: 'Desliza la portada para abrir el libro',
    conversationPreviewDiscoverBook: 'Descubre mi libro',
    conversationPreviewVolumesLabel: 'Tu colección: {count} libros',
    conversationPreviewVolumesHint: 'Toca una portada para abrir ese tomo.',
    conversationCoverResumeEditTitle: 'Escribe una dedicatoria o prólogo (opcional)',
    conversationCoverResumeError: 'Prólogo demasiado largo para una página: acorta el texto o reduce los saltos de línea.',
    conversationCoverResumeNearLimit: 'Cerca del límite de una página ({lines}/{max} líneas).',
    conversationCoverResumeHelp: 'Este prólogo se imprimirá en la contraportada interior de tu libro.',
    conversationCoverResumePlaceholder: 'Escribe unas palabras para introducir tu historia',
    conversationCoverResumeReset: 'Restablecer el texto de este libro',
    conversationCoverTitleError: 'Título demasiado largo (máx: {max} caracteres)',
    conversationCoverTitleHelp: 'Haz clic para modificar el título del libro',
    conversationCoverTitlePlaceholder: 'Escribe un título...',
    conversationCoverDefaultTitleTwoNames: '{name1} y {name2}',
    conversationCoverDefaultTitleGroup: 'Nuestro grupo',
    conversationCoverDefaultTitleSingle: 'Mis mensajes',
	conversationCoverWaitingForCustomization: 'Podrás personalizar la portada de tu libro en el siguiente paso...',
    conversationCreateInfoText: 'Crea un nuevo libro de mensajes haciendo clic en los iconos de aquí',
    conversationCreateMyBookTitle: 'Crear mi libro',
    conversationCreateTitle: 'Crear un libro',
    conversationDateCreation: 'Fecha de creación',
    conversationDateDownloadedInfo: 'El libro fue descargado el {downloaded}',
    conversationDateEnd: 'Fin del chat',
    conversationDateEndInfo: 'El libro termina el {end}',
    conversationDateEndLabel: 'Seleccionar la fecha de fin',
    conversationDateEndMessageSelection: 'Terminar el libro aquí',
    conversationDateGeneratedInfo: 'El libro fue generado el {generated}',
    conversationDateRange: 'Del {start} al {end}',
    conversationDeleteConfirmation: '¡El chat ha sido eliminado!',
    conversationDateSelectionAlert: 'Parece que tu chat sufrió daños durante la transferencia. Por favor, inténtalo de nuevo permaneciendo en la página y asegurando una buena conexión a internet.',
    conversationDateSimulatedInfo: 'El libro fue previsualizado el {simulated}',
    conversationDateStart: 'Inicio del chat',
    conversationDateStartInfo: 'El libro empieza el {start}',
    conversationDateStartLabel: 'Seleccionar la fecha de inicio',
    conversationDateStartMessageSelection: 'Empezar el libro aquí',
    conversationDatesEditTitle: 'Selección de fechas',
    conversationPreviewPrefaceOptionalBadge: 'Opcional',
    conversationPreviewPrefaceEmptyTitle: 'Un prefacio, si lo deseas',
    conversationPreviewPrefaceEmptyText: 'Unas palabras para abrir tu libro. Puedes saltarte este paso y volver cuando quieras.',
    conversationPreviewPrefaceEmptyButton: 'Añadir un prefacio',
    conversationPreviewEndCta: 'Pedir ahora',
    conversationPreviewEndBodyPaused: 'Valida tus cambios. La versión digital te llega por email justo después, para que la revises.',
    conversationPreviewEndCtaPaused: 'Validar mis cambios',
    conversationDemoAlert: 'Ahora vas a poder descubrir las primeras páginas de tu libro.<br></br>Una vez realizado el pedido, recibirás la versión completa para revisarla antes de la impresión.',
    conversationDemoEndAlert: 'Podrás descubrir el resto de tus mensajes después de confirmar tu compra.',
    conversationPreviewEndTitle: 'El resto te espera',
    conversationPreviewEndBody: 'El resto de tus mensajes te espera. Pide tu libro para verlo entero.',
    conversationPreviewDemoBadge: 'MonLivreSMS',
    conversationPreviewPrefaceEmptyTitle: 'Tu prefacio (opcional)',
    conversationPreviewPrefaceOptionalBadge: 'Opcional',
    conversationPreviewPrefaceEmptyText: 'Unas palabras para abrir tu libro. Puedes saltarte este paso y volver cuando quieras.',
    conversationPreviewPrefaceEmptyButton: 'Escribir mi prefacio',
    conversationPreviewPrefaceEditButton: 'Editar prefacio',

    conversationDisclaimerSubtitle: 'Elige tu formato para acceder a nuestro taller de personalización.',
    conversationDisclaimerTitle: `{count} {count, plural,
      =0 {mensaje}
      =1 {mensaje}
      other {mensajes}
    }: una historia que merece ser leída`,
    conversationDisclaimerSavings: 'Ahorras {value}',
    conversationDisclaimerEBookIncluded: 'Edición Ebook incluida',
    conversationDisclaimerGenerating: 'Generando tu libro...',

    conversationDisclaimerPlanSingleTitle: 'El Volumen 1',
    conversationDisclaimerPlanSingleDescription: 'Lo Esencial',
    conversationDisclaimerPlanSingleButtonText: 'Crear mi libro',
    conversationDisclaimerPlanSingleFeaturePages: 'El libro de tu elección (400 páginas) entregado',
    conversationDisclaimerPlanSingleFeatureQuality: '',
    conversationDisclaimerPlanSingleFeatureEvolutive: 'Evolutivo: completa la colección más adelante',
    conversationDisclaimerPlanSingleFeaturePremiumPaper: 'Papel Premium',
    conversationDisclaimerPlanSingleFeaturePremiumPrint: 'Impresión en Papel Premium',
    conversationDisclaimerPlanSingleFeaturePdfIncluded: 'Versión PDF incluida (Valor: {price})',
    conversationDisclaimerPlanSingleFeatureWorkshop: 'Personalización completa de regalo',
    conversationDisclaimerPlanSingleFeatureMedia: 'Fotos, Vídeos y Audios incluidos',

    conversationDisclaimerPlanCollectionTitle: 'La Colección Completa',
    conversationDisclaimerPlanCollectionDescription: 'La Integral',
    conversationDisclaimerPlanCollectionButtonText: 'Conservar toda nuestra historia',
    conversationDisclaimerPlanCollectionBadge: 'OFERTA PACK -{percentage}%',
    conversationDisclaimerPlanCollectionFeatureBox: 'Tus {count} libros impresos y entregados',
    conversationDisclaimerPlanCollectionFeatureDiscount: 'Tarifa Colección -{percentage}% (-{amount} incluidos)',
    conversationDisclaimerPlanCollectionFeatureDigital: 'Edición digital de regalo',
    conversationDisclaimerPlanCollectionFeatureWorkshop: 'Personalización completa de regalo',
    conversationDisclaimerPlanCollectionFeatureMedia: 'Fotos, Vídeos y Audios incluidos',

    conversationDisclaimerPlanEbookTitle: 'La Edición Ebook',
    conversationDisclaimerPlanEbookDescription: 'El Formato Digital',
    conversationDisclaimerPlanEbookButtonText: 'Guardar en PDF',
    conversationDisclaimerPlanEbookFeaturePdf: 'PDF Alta Definición inmediato',
    conversationDisclaimerPlanEbookFeatureShare: 'Fácil de compartir',
    conversationDisclaimerPlanEbookFeatureMessages: 'La totalidad de tus {count} mensajes',
    conversationDisclaimerPlanEbookFeatureMedia: 'Fotos, Vídeos y Audios incluidos',

    conversationDisclaimerReassuranceGuaranteeTitle: 'Garantía de Satisfacción',
    conversationDisclaimerReassuranceGuaranteeDescription: 'Reembolso garantizado bajo petición hasta la validación final.',
    conversationDisclaimerReassuranceCustomTitle: 'Personalización Libre',
    conversationDisclaimerReassuranceCustomDescription: 'Modifica tu portada y mensajes después del pago',
    conversationDisclaimerReassuranceSecureTitle: 'Pago 100% Seguro',
    conversationDisclaimerReassuranceSecureDescription: 'Tarjeta bancaria, Apple Pay, Google Pay',
    conversationDisclaimerReassuranceDeliveryTitle: 'Entrega Rápida',
    conversationDisclaimerReassuranceDeliveryDescription: 'Entrega en tu domicilio en 5 días laborables',

    conversationDisclaimerReviewSuffix: 'de +{count} libros impresos',

    conversationDowloadUnableAlert: 'Ya no puedes descargar los libros de este chat... Contáctanos para resolver tu problema.',
    conversationDownloadDeadlineInfo: 'Puedes descargar tus archivos hasta el {date}',
    conversationDownloadLink: 'Descargar mi libro N°{index}',
    conversationDownloadFileCoverLink: 'Descargar la portada {name}',
    conversationDownloadFileSourceLink: 'Descargar el archivo fuente {name}',
    conversationDownloadPdfButton: 'Descargar el E-book',
    conversationDownloadPdfWaitingMessage: 'Espera 5 minutos para volver a descargar',
    conversationEditStart: 'Editar el libro',
    conversationEditSuccess: '¡El chat ha sido actualizado!',
    'conversationFormatLabelA4-1': 'Crónicas de tus recuerdos',
    'conversationFormatLabelA4-2': '(álbum A4)',
    'conversationFormatLabelA5-1': 'El pequeño tesoro',
    'conversationFormatLabelA5-2': '(formato A5)',
    conversationGeneratedSuccess: '¡Enhorabuena! <br></br> ¡Tu chat ha sido generado con éxito!',
        conversationGenerationAlert: 'Estamos creando tu libro…',
        conversationGenerationAlert2: 'Quédate con nosotros, solo tarda un momento.',
        conversationGenerationFailed: 'La creación de tu libro se ha interrumpido.',
        conversationGenerationFailedHint: 'Tus mensajes están a salvo. Inténtalo de nuevo y, si se repite, escríbenos: lo revisamos contigo.',
        conversationGenerationRetry: 'Intentar de nuevo',
    conversationHelpBooksText: 'Cambia entre tus libros para modificar la información específica de cada uno',
    conversationHelpBooksTitle: 'Selección del libro',
    conversationHelpCoverColorText: 'Puedes cambiar el color de fondo de la portada haciendo clic en el círculo.',
    conversationHelpCoverColorTitle: 'Color de la portada',
    conversationHelpCoverImageText: 'Puedes arrastrar y soltar cualquier imagen en este espacio para añadirla a tu portada.',
    conversationHelpCoverImageTitle: 'Imagen de portada',
    conversationHelpCoverTitleText: '¡Haz clic en el título para modificarlo! Tienes 2 líneas disponibles: Título y Subtítulo.',
    conversationHelpCoverTitleTitle: 'Título de la portada',
    conversationHelpDatePreviewText: 'Selecciona la fecha de inicio de tu relato.',
    conversationHelpDatePreviewTitle: 'Fecha',
    conversationHelpDateSelectorText: 'Al cambiar la fecha, ¡tus primeros y últimos mensajes se mostrarán aquí!',
    conversationHelpDateSelectorTitle: 'Vista previa del mensaje',
    conversationHelpParticipantColorText: 'Puedes cambiar el color de las burbujas de cada participante para darles un toque único.',
    conversationHelpParticipantColorTitle: 'Color de los participantes',
    conversationHelpParticipantNameText: '¡Modifica el nombre del participante como más te guste!',
    conversationHelpParticipantNameTitle: 'Nombre del participante',
    conversationHelpParticipantPositionText: 'Elige si prefieres mostrar los mensajes de este participante a la izquierda o a la derecha.',
    conversationHelpParticipantPositionTitle: 'Posición del participante',
	conversationHelpMessagesToolsTitle: 'Herramientas',
	conversationHelpMessagesToolsText: 'Toca una ficha para buscar, filtrar por medios o fechas, o ocultar mensajes.',
	conversationHelpMessagesSearchTitle: 'Búsqueda',
	conversationHelpMessagesSearchText: 'Escribe una palabra o un nombre para encontrar un mensaje rápidamente.',
	conversationHelpMessagesMediasTitle: 'Medios',
	conversationHelpMessagesMediasText: 'Filtra los mensajes que contienen fotos, vídeos, audios o enlaces.',
	conversationHelpMessagesDatesTitle: 'Fechas',
	conversationHelpMessagesDatesText: 'Quédate solo con los mensajes entre dos fechas para centrarte en una parte de la conversación.',
	conversationHelpMessagesHidePeriodTitle: 'Ocultar un periodo',
	conversationHelpMessagesHidePeriodText: 'Elige dos fechas para ocultar (o volver a mostrar) todo un periodo de una vez.',
	conversationHelpMessagesHiddenTitle: 'Visualización',
	conversationHelpMessagesHiddenText: 'Muestra todos los mensajes, solo los visibles o solo los ocultos.',
	conversationHelpMessagesListTitle: 'Editar un mensaje',
	conversationHelpMessagesListText: 'En cada burbuja: seleccionar, ocultar, editar el texto o insertar uno nuevo.',
	conversationHelpMessagesFooterTitle: 'Volver a la vista previa',
	conversationHelpMessagesFooterText: 'Cuando esté listo, vuelve a la vista previa para ver tu libro actualizado.',
    conversationHelpPreviewBookCoverText: 'Ponle una portada única. Haz clic para personalizarla.',
    conversationHelpPreviewBookCoverTitle: 'Portada del libro',
    conversationHelpPreviewBookPreviewText: '¡Previsualiza un volumen específico haciendo clic aquí!',
    conversationHelpPreviewBookPreviewTitle: 'Vista previa del libro',
    conversationHelpPreviewBookSelectorText: 'Elige los volúmenes que deseas imprimir.',
    conversationHelpPreviewBookSelectorTitle: 'Selector de libros',
    conversationHelpPreviewBookSplitText: 'Al marcar esta casilla, todos tus libros tendrán el mismo número de páginas para una colección uniforme.',
    conversationHelpPreviewBookSplitTitle: 'Páginas del libro',
        conversationHelpPreviewCopyText: 'Pide más ejemplares: para ti o para regalar. Descuento a partir del segundo.',
        conversationHelpPreviewCopyTitle: 'Regalar un ejemplar',
        conversationHelpPreviewFormatText: 'Libro en papel o ebook: elige lo que más te encaje.',
        conversationHelpPreviewFormatTitle: 'Formato',
        conversationHelpPreviewRenderText: 'Así es tu libro. Personaliza la portada directamente encima, luego hojea las páginas.',
        conversationHelpPreviewRenderTitle: 'Tu libro',
	conversationHelpPreviewMessagesText: 'Toca esta tarjeta para editar el contenido de los mensajes.',
	conversationHelpPreviewMessagesTitle: 'Mensajes',
	conversationHelpPreviewDatesText: 'Toca esta tarjeta para elegir las fechas de inicio y fin de tu libro.',
	conversationHelpPreviewDatesTitle: 'Fechas',
	conversationHelpPreviewParticipantsText: 'Toca esta tarjeta para cambiar los nombres y el aspecto de los participantes.',
	conversationHelpPreviewParticipantsTitle: 'Participantes',
	conversationHelpPreviewCoverTitleText: 'Haz clic en el título o el subtítulo para editarlos.',
	conversationHelpPreviewCoverTitleTitle: 'Título y subtítulo',
	conversationHelpPreviewVolumesTitle: 'Varios volúmenes',
	conversationHelpPreviewVolumesText: 'Tu conversación ocupa varios libros. Toca un número para cambiar de volumen y personalizar cada portada.',
	conversationHelpPreviewCoverImageText: 'Toca la zona de la foto para añadir o cambiar la imagen de portada.',
	conversationHelpPreviewCoverImageTitle: 'Foto',
	conversationHelpPreviewCoverColorText: 'Toca una pastilla para cambiar el color de fondo de la portada.',
	conversationHelpPreviewCoverColorTitle: 'Color',
        conversationHelpPreviewValidText: 'Cuando todo esté listo, confirma. Tu eBook llega por correo, tu libro a casa.',
        conversationHelpPreviewValidTitle: '¡Adelante!',

    conversationHighlightStartDateTitle: 'El primer mensaje',
    conversationHighlightStartDateDescription: 'Ese día salió el primer mensaje. De ahí nació todo lo demás.',
    conversationHighlightDurationTitle: 'Juntos desde',
    conversationHighlightDurationDescription: 'Todos estos días juntos, desde ese primer mensaje.',
    conversationHighlightMessagesCountTitle: 'Mensajes',
    conversationHighlightMessagesCountDescription: 'Todos estos mensajes, intercambiados desde el {date}.',
    conversationHighlightImagesCountTitle: 'Fotos',
    conversationHighlightImagesCountDescription: 'Estas fotos, guardadas de nuestro chat.',
    conversationHighlightMediasCountTitle: 'Vídeos y audios',
    conversationHighlightMediasCountDescription: 'Para volver a oír una voz y revivir un momento.',
    conversationHighlightSpecialDayMessagesCountTitle: 'En un solo día',
    conversationHighlightSpecialDayMessagesCountDescription: 'Nuestro récord: todos estos mensajes en un solo día.',
    conversationHighlightSpecialDayTitle: 'Ese día',
    conversationHighlightSpecialDayDescription: 'El día en que más nos escribimos.',
    conversationHighlightCharsCountReferenceDiffTitle: 'Romeo y Julieta',
    conversationHighlightCharsCountReferenceDiffDescription: 'El texto de Romeo y Julieta, tantas veces.',
    conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff} veces',
    conversationHighlightTypingDurationTitle: 'Escritura',
    conversationHighlightTypingDurationDescription: 'Tantas horas solo para escribirnos.',
    conversationHighlightUnitDays: '{count, plural, one {día} other {días}}',
    conversationHighlightUnitMessages: '{count, plural, one {mensaje} other {mensajes}}',
    conversationHighlightUnitHours: '{count, plural, one {hora} other {horas}}',
    conversationHighlightUnitTimes: 'veces',

    conversationHighlightBadge: 'En unas cifras',
    conversationHighlightStoryKicker: 'Tu historia',
    conversationHighlightsMomentsCount: '{count, plural, one {# imagen para descargar} other {# imágenes para descargar}}',
    conversationHighlightShareFormat: 'Formato story',
    conversationHighlightsCardFooter: 'Algunas historias merecen un libro',
    conversationHighlightShareButton: 'Descargar',
    conversationHighlightShareButtonAlt: 'Ver las estadísticas de la conversación',
    conversationHighlightSubtitle: 'Las cifras de lo que os habéis dicho.',
    conversationHighlightTitle1: 'Tus mensajes',
    conversationHighlightTitle2: 'en unas cifras',
    conversationHighlightOpenStoryButton: 'Abrir esta story',
    conversationHighlightsAtGlanceEyebrow: 'De un vistazo',
    conversationHighlightsAtGlanceTitle: 'La dimensión de vuestra historia',
    conversationHighlightsNoAiNote: 'Estas estadísticas se calculan automáticamente, sin IA.',
    conversationHighlightsKpiMessages: 'mensajes',
    conversationHighlightsKpiWords: 'palabras escritas',
    conversationHighlightsKpiActiveDays: 'días activos',
    conversationHighlightsKpiStreak: 'días seguidos',
    conversationHighlightsRhythmEyebrow: 'Vuestro ritmo',
    conversationHighlightsRhythmTitle: 'Cuándo cobran vida vuestros mensajes',
    conversationHighlightsTopHour: 'Vuestra hora',
    conversationHighlightsTopWeekday: 'Vuestro día',
    conversationHighlightsNightMessages: 'Mensajes nocturnos',
    conversationHighlightsChartMonths: 'Todos los meses, del primer al último mensaje',
    conversationHighlightsChartYears: 'Todos los años, del primer al último mensaje',
    conversationHighlightsLessThanOneMinute: 'menos de 1 min',
    conversationHighlightsSpanLessThanMonth: 'Menos de un mes',
    conversationHighlightsSpanYears: '{count, plural, one {# año} other {# años}}',
    conversationHighlightsSpanMonths: '{count, plural, one {# mes} other {# meses}}',
    conversationHighlightsSpanYearsMonths: '{years, plural, one {# año} other {# años}} y {months, plural, one {# mes} other {# meses}}',
    conversationHighlightsSpanLabel: 'Del primer al último mensaje',
    conversationHighlightsBusiestDayLabel: 'Día más hablador',
    conversationHighlightsPhotosLabel: 'Fotos',
    conversationHighlightsMediasLabel: 'Vídeos y notas de voz',
    conversationHighlightsBookPagesLabel: 'Su libro',
    conversationHighlightsBookPagesPrefix: 'alrededor de',
    conversationHighlightsBookPagesUnit: '{count, plural, one {página} other {páginas}}',
    conversationHighlightsBookPagesNote: 'Estimación a partir de sus mensajes y fotos.',
    conversationHighlightsWritingHours: 'Cerca de {count, plural, one {# hora escribiéndoos} other {# horas escribiéndoos}}.',
    conversationHighlightsRomeo: 'Tanto texto como {count} veces Romeo y Julieta.',
    conversationHighlightsDayClockPeak: 'Casi siempre entre las {start} h y las {end} h',
    conversationHighlightsLessThanOnePercent: '< 1 %',
    conversationHighlightsWritesLonger: '{name} escribe los mensajes más largos.',
    conversationHighlightsStartsMore: '{name} abre la conversación más a menudo.',
    conversationHighlightsWordsPerMessage: '{count} palabras / mensaje',
    conversationHighlightsStartsShare: '{percent} % de los inicios',
    conversationHighlightsMedianReply: 'Tiempo medio de respuesta',
    conversationHighlightsBalanceEyebrow: 'Vuestro equilibrio',
    conversationHighlightsBalanceTitle: 'Cada uno tiene su forma de estar presente',
    conversationHighlightsWordsShort: 'palabras',
    conversationHighlightsStartsShort: 'inicios',
    conversationHighlightsBalanceNote: 'Un porcentaje describe un ritmo, nunca la importancia de una persona.',
    conversationHighlightsRecordsEyebrow: 'Vuestros récords',
    conversationHighlightsRecordsTitle: 'Los momentos que destacan',
    conversationHighlightsLongestSession: 'Conversación más larga',
    conversationHighlightsIntenseQuarter: 'Los 15 minutos más intensos',
    conversationHighlightsQuestions: 'Mensajes cariñosos',
    conversationHighlightsSignsOfInterest: 'corazones, besos o «te quiero»',
    conversationHighlightsLaughs: 'Mensajes con risas',
    conversationHighlightsSharedSmiles: 'sonrisas compartidas',
    conversationHighlightsFavoriteEmojis: 'Vuestros emojis favoritos',
    conversationHighlightsStoriesEyebrow: 'Para guardar',
    conversationHighlightsStoriesTitle: 'Vuestras tarjetas de recuerdos',
    conversationHighlightsStoriesText: 'Abre una tarjeta y descárgala en formato story.',
    conversationHighlightsDeepEyebrow: '¿Y después de las cifras?',
    conversationHighlightsDeepTitle: '¿Os gustaría descubrir vuestra historia más a fondo?',
    conversationHighlightsDeepText: 'Dinos si te gustaría que algún día fuéramos más allá. De momento, no se analizará nada más.',
    conversationHighlightsDeepThanks: 'Gracias, hemos registrado tu interés',
    conversationHighlightsDeepButton: 'Sí, me interesaría',
    conversationHighlightsDeepNotice: 'Te avisaremos en cuanto esté previsto.',
    conversationHighlightsDeepNoticeClose: 'De acuerdo',
    conversationHighlightsPrintBook: 'Quiero imprimir mi libro',
    conversationHighlightsPrintNow: 'Lo imprimo ahora',

    conversationImagesCount: `{count} {count, plural,
      =0 {foto}
      =1 {foto}
      other {fotos}
    }`,

    conversationImportFileNotSupportedError: '¡Tu archivo no es válido! Por favor, selecciona un archivo comprimido válido (.zip)',
    conversationImportFileSummary: 'Tu nombre es {name} y tienes {count} chats en este archivo.',
    conversationImportFileTooBigError: '¡Tu archivo es demasiado pesado! (más de 4GB). Por favor, contáctanos para resolver este problema.',
    conversationImportProviderNext: 'Transferir mi chat',
    conversationImportTutorialGoNext: 'Ver lo siguiente',
    conversationImportTutorialStep: 'Paso n°{step}',
    conversationImportDetailToggle: 'Ver la guía detallada con capturas',
    conversationImportDetailCardTitle: '¿Es tu primera vez?',
    conversationImportDetailCardSubtitle: 'Guía ilustrada paso a paso ({count} pasos con capturas)',
    conversationImportDetailCardAction: 'Abrir la guía',
    conversationImportDetailTitle: 'Guía detallada paso a paso',
    conversationImportDetailStepOf: 'Paso {current} de {total}',
    conversationImportDetailPrev: 'Anterior',
    conversationImportDetailNext: 'Siguiente',
    conversationImportDetailClose: 'Cerrar',
    conversationImportSelectionSummary: `Chat seleccionado: {name} (contiene {count} {count, plural,
        =0 {mensaje}
        =1 {mensaje}
        other {mensajes}
      })`,
    conversationImportSelectionSummary2: 'Chat seleccionado: {name}',
    conversationImportSelectionText: 'Escribe el nombre de tu amigo...',
    conversationImportSelectionTitle: 'Selecciona el chat',
    conversationImportStepCreation: 'Creación de la conversación',
    conversationImportStepExtraction: 'Recuperando los datos',
    conversationImportStepFinal: 'Finalizando los últimos detalles...',
    conversationImportStepImages: 'Guardando tus imágenes',
    conversationImportStepMessages: 'Guardando tus mensajes',
    conversationImportSuccess: '¡Enhorabuena! <br></br>¡Tu chat ha sido importado con éxito!',
    conversationImportValidationWaiting: 'Validación en curso...',
    conversationMediaAudioOpusWarning: 'Si no puedes reproducir este archivo de audio, utiliza otro navegador compatible (como Google Chrome)',
    conversationMediasCount: `{count} {count, plural,
      =0 {archivo multimedia}
      =1 {archivo multimedia}
      other {archivos multimedia}
    }`,
    conversationMerge: 'Fusionar los chats',
    conversationMergeInfo: 'Selecciona los chats que deseas fusionar y luego haz clic en el botón situado debajo de la lista:',
    conversationMergeRequestSuccess: '¡Los chats se fusionarán pronto! Recibirás un correo electrónico cuando la fusión haya terminado.',
    conversationMergeHintEyebrow: 'A saber',
    conversationMergeHintTitle: 'Agrupar en una sola conversación',
    conversationMergeHintSingle: '¿Varios hilos de chat? Importa cada conversación con + y luego fusiónalas en una sola conversación.',
    conversationMergeHintReady: 'Puedes fusionar tus conversaciones en una sola conversación cronológica.',
    conversationMessages: 'Mensajes',
    conversationMessagesCount: `{count} {count, plural,
      =0 {mensaje}
      =1 {mensaje}
      other {mensajes}
    }`,
    conversationMessagesCount2: `{count, plural,
      =0 {mensaje}
      =1 {mensaje}
      other {mensajes}
    }`,
    conversationMessagesImagesCount: `{count} {count, plural,
      =0 {imagen}
      =1 {imagen}
      other {imágenes}
    }`,
    conversationMessagesImagesCount2: `{count, plural,
      =0 {imagen}
      =1 {imagen}
      other {imágenes}
    }`,
    conversationMessagesLoadingAlert: 'Recuperando la magia de tus mensajes...',
    conversationMessagesMediasCount: `{count} {count, plural,
      =0 {archivo multimedia}
      =1 {archivo multimedia}
      other {archivos multimedia}
    }`,
    conversationMessagesMediasCount2: `{count, plural,
      =0 {archivo multimedia}
      =1 {archivo multimedia}
      other {archivos multimedia}
    }`,
    conversationNoData: '¡Aún no has importado ninguna conversación!',
    conversationOptionWithImagesHelp1: 'Actualmente, tus libros se imprimirán CON tus imágenes o fotos',
    conversationOptionWithImagesHelp2: 'Actualmente, tus libros se imprimirán SIN tus imágenes o fotos',
    conversationOptionWithImagesHelp3: 'Dependiendo de la cantidad de fotos, la transferencia del chat puede ralentizarse. Por favor, permanece en esta página durante la carga, puede tardar hasta 10 minutos. Si sigues teniendo dificultades, envíanos tu archivo a través de www.fromsmash.com a la dirección hello@monlivresms.com indicando el nombre del contacto o del grupo, y te encontraremos una solución.',
    conversationOptionWithImagesLabel: '¿Deseas incluir las imágenes del chat?',
    conversationOptionWithMediaHelp: 'Podrás redescubrir tus vídeos, audios y GIFs gracias a los códigos QR impresos en tu libro. Te regalamos el almacenamiento seguro de tus datos durante 10 años.',
    conversationOptionWithMediasLabel: '¿Deseas incluir los vídeos, audios y GIFs del chat?',
    conversationOrder: 'Pedido',
    conversationOrderButton: 'Comprar ahora',
    conversationOrderButtonWithPrice: 'Comprar · {price}',
    conversationOrderButtonWithPriceVolumes: 'Comprar mis {count} libros · {price}',
    conversationOrderDiscountLabel: '¡-{discount}% de descuento en este chat al pedir {threshold} ejemplares o más!',
    conversationOrderQuantity: 'Número de ejemplares',
    conversationOrderSummaryBook: `{bookCount} {bookCount, plural,
			=1 {tomo}
			other {tomos}
		} · {bookTotal} {discount, plural,
			=0 {}
			other {: {discount} % de descuento incluido}
		}`,
    conversationOrderSummary2: `Tu pedido incluye {bookCount} {bookCount, plural,
          =0 {libro}
          =1 {libro}
          other {libros}
        } y {pdfCount} {pdfCount, plural,
          =0 {eBook}
          =1 {eBook}
          other {eBooks}
        } {freeCount, plural,
          =0 {}
          =1 {+1 eBook gratis}
          other {+{freeCount} eBooks gratis}
        } por {pdfTotal}`,
        conversationOrderSummaryBestof: '1 libro Best Of · {bestofTotal}',
        conversationOrderSummaryPdf: '1 eBook completo · {pdfTotal}',
    conversationParticipantColorHelp: 'Haz clic aquí para cambiar el color de la burbuja',
    conversationParticipantNameHelp: 'Haz clic aquí para modificar el nombre del participante',
    conversationParticipantPositionHelp: 'Haz clic para modificar la posición del participante (a la derecha o a la izquierda)',
    conversationParticipants: 'Participantes',
    conversationParticipantsEditTitle: 'Edición de los participantes',
    conversationPauseButton: 'Pausar mi pedido',
    conversationPauseConfirmText: 'La generación de tus libros se pausará. Podrás reanudarla en cualquier momento.',
    conversationPreviewBookNumber: `{index}{index, plural,
          =0 {}
          =1 {er}
          =2 {do}
          =3 {er}
          other {º}
      } volumen`,
    conversationPreviewBestofHelpButton: '¿Cómo funciona la selección?',
    conversationPreviewBestofHelpText: 'Nuestra fórmula analiza cada momento de tu conversación: la frecuencia de los mensajes, la calidad del diálogo (¿un verdadero intercambio o un monólogo?), la riqueza del contenido (fotos, texto, emojis). Los primeros y últimos mensajes siempre se conservan. Solo los momentos que realmente importaron entran en el libro. Tus mensajes son privados: nuestra fórmula nunca lee su contenido, solo analiza la estructura de tus intercambios.',
    conversationPreviewBookSelection: 'Selección de los volúmenes',
    conversationPreviewBooksSelectAllBooks: 'Seleccionar todos los libros físicos',
    conversationPreviewBooksSelectAllEBooks: 'Seleccionar todos los eBooks',
    conversationPreviewBooksUnselectAll: 'Deseleccionar todo',
        conversationPreviewBrowserWarning: 'Tu navegador puede ralentizar la visualización. Para una mejor experiencia, te recomendamos Google Chrome.',
    conversationPreviewFormatSelection: 'Selección del formato',
    conversationPreviewPagesDivideEquallyLabel: '¿Deseas dividir las páginas de forma equitativa entre los volúmenes?',
    conversationPreviewPagesSetMaxBookPagesLabel: '¿Prefieres que tus libros tengan un máximo de {max} páginas?',
        conversationPreviewTitle: 'Tu historia, convertida en libro.',
        conversationPreviewSubtitle: 'Personaliza portada, nombres, fechas y mensajes antes de elegir tu edición.',
        conversationPreviewHeroTitle: 'Tus palabras, encuadernadas para siempre.',
        conversationPreviewBookCaption: 'Pasa las páginas para descubrir tu libro.',
        conversationPreviewCustomizeEyebrow: 'A tu aire',
        conversationPreviewEditionEyebrow: 'Tu edición',
        conversationPreviewPricePerVolume: '{price}/tomo',
    conversationPreviewCollectionPriceNote: '{count} tomos · {price}/tomo',
    conversationPreviewCollectionUntilLabel: 'Qué tomos',
    conversationPreviewCollectionUntilAll: 'Del primer tomo al último',
    conversationPreviewCollectionUntilOpen: 'Elegir',
    conversationPreviewCollectionUntilClose: 'Cerrar',
    conversationPreviewCollectionUntilPartial: '{count, plural, one {El primer tomo} other {Los primeros {count} tomos}}',
    conversationPreviewCollectionUntilSuffix: '{count, plural, one {El último tomo} other {Los últimos {count} tomos}}',
    conversationPreviewCollectionUntilSingle: 'El tomo {number}',
    conversationPreviewCollectionUntilWindow: 'Del tomo {from} al tomo {to}',
    conversationPreviewCollectionUntilPeriod: 'Del {start} al {end}',
    conversationPreviewCollectionUntilHint: 'Los otros tomos siguen en la conversación, para otro pedido.',
    conversationPreviewCollectionUntilAriaStart: 'Primer tomo a imprimir',
    conversationPreviewCollectionUntilAriaEnd: 'Último tomo a imprimir',
    conversationPreviewTypeBookTaglinePartial: '{count, plural, one {El primer tomo de tu conversación.} other {Los primeros {count} tomos de tu conversación.}}',
    conversationPreviewTypeBookTaglineSuffix: '{count, plural, one {El último tomo de tu conversación.} other {Los últimos {count} tomos de tu conversación.}}',
    conversationPreviewTypeBookTaglineWindowSingle: 'El tomo {number} de tu conversación.',
    conversationPreviewTypeBookTaglineWindow: 'Los tomos {from} a {to} de tu conversación.',
    conversationPreviewStickyCollectionVolumes: 'Colección · {count} tomos',
        conversationPreviewSocialProofCount: '{count}+ opiniones',
        conversationPreviewSocialProofAria: 'Valorado con {rating} sobre 5 en Trustpilot, con más de {count} opiniones',
        conversationPreviewCustomizeTitle: 'Personalizar mi libro',
        conversationPreviewCustomizeHint: 'Toca una tarjeta para editar.',
        conversationPreviewCardsHintTitle: 'Nombres, fechas, mensajes',
        conversationPreviewCardsHintText: 'Aquí cambias los nombres, el periodo y los mensajes.',
        conversationPreviewCustomizeTopics: 'Portada · nombres · fechas · mensajes',
        conversationPreviewEditionTitle: 'Elige tu edición',
        conversationPreviewEditionHint: 'Compara las opciones y elige la que más te convenga.',
        conversationPreviewPausedEyebrow: 'Pedido en pausa',
        conversationPreviewPausedTitle: '¿Listos tus cambios?',
        conversationPreviewPausedHint: 'Tu pedido está en pausa. Edita tu libro y confirma para retomar la fabricación.',
        conversationPreviewPausedScrollHint: 'Validar mis cambios',
        conversationPreviewMissingMediasBanner: 'Faltan algunos archivos multimedia (fotos, archivos) de tu conversación o no se pudieron recuperar. Comprueba tus mensajes antes de validar.',
        conversationPreviewMissingMediasCta: 'Completar los medios',
        bookMissingPhotoLabel: 'Foto no disponible',
        conversationMissingMediasBadge: 'Medios faltantes',
        conversationMissingMediasCta: 'Completar los medios',
        conversationResumeWithoutMediasButton: 'Continuar sin estas fotos',
        conversationResumeMissingMediasConfirmText: 'Todavía faltan algunas fotos. Tu libro se imprimirá sin ellas. Completa los medios si puedes.',
        orderMissingMediasAlert: 'Faltan fotos en una conversación de este pedido. Complétalas para que la fabricación pueda reanudarse.',
        missingMediasRecoveryAddPhoto: 'Añadir una foto',
        missingMediasRecoveryArchiveCta: 'Dejar el archivo de exportación',
        missingMediasRecoveryArchiveError: 'No se pudo leer este archivo. Comprueba que sea la exportación de tu mensajería.',
        missingMediasRecoveryArchiveHelp: 'Vuelve a subir la exportación de {provider} (zip). Solo se añadirán las fotos faltantes: tus mensajes y modificaciones no cambian.',
        missingMediasRecoveryArchiveTitle: 'Completar con una nueva exportación',
        missingMediasRecoveryArchiveWorking: 'Buscando las fotos faltantes en tu archivo…',
        missingMediasRecoveryContact: 'Escríbenos',
        missingMediasRecoveryEmpty: 'No se detectan medios faltantes por ahora.',
        missingMediasRecoveryError: 'Ha ocurrido un error. Inténtalo de nuevo o contáctanos.',
        missingMediasRecoveryFirstDate: 'Primer medio faltante: {date}.',
        missingMediasRecoveryIgnore: 'Ignorar',
        missingMediasRecoveryIntro: '{count, plural, one {Falta # foto} other {Faltan # fotos}} en tu libro. Puedes volver a subir tu exportación o tratar cada medio abajo.',
        missingMediasRecoveryListTitle: 'Tratar medio por medio',
        missingMediasRecoveryNoMatch: 'No se encontró ningún archivo correspondiente a los medios faltantes.',
        missingMediasRecoveryRecommended: 'Recomendado',
        missingMediasRecoveryRescan: 'Volver a comprobar',
        missingMediasRecoveryResolved: 'Todos los medios faltantes han sido tratados. Tu libro vuelve a fabricación.',
        missingMediasRecoverySuccessEyebrow: 'Todo listo',
        missingMediasRecoverySuccessTitle: 'Bravo, tus fotos están completas',
        missingMediasRecoverySuccessText: 'Todos los medios faltantes han sido tratados. Tu libro vuelve a fabricación.',
        missingMediasRecoverySuccessCta: 'Volver a mi vista previa',
        conversationMissingMediasFixedSuccess: 'Bravo: todos los medios faltantes están completos. Tu libro vuelve a fabricación.',
        conversationMissingMediasFixedHint: 'No tienes que hacer nada más: la fabricación se reanuda automáticamente.',
        missingMediasRecoverySmsStepAndroid: 'En Android: vuelve a abrir la app MonLivreSMS y reenvía la conversación.',
        missingMediasRecoverySmsStepBackup: 'Haz una nueva copia de seguridad local sin cifrar (Mac/PC) y vuelve a lanzar nuestro software para reenviar los medios de esta conversación.',
        missingMediasRecoverySmsStepIcloud: 'En iPhone: abre la conversación en Mensajes, toca el contacto, baja y descarga las fotos de iCloud.',
        missingMediasRecoverySmsTitle: 'Transferencia SMS / iPhone',
        missingMediasRecoveryTitle: 'Medios faltantes ({count})',
        conversationPreviewEditionMetaLabel: 'Detalles de la edición',
        conversationPreviewBestofLearnMore: 'Cómo funciona la selección Best-Of',
        conversationPreviewBestofHint: 'Vista previa ilustrativa del Best Of: la selección de tus mejores mensajes se hace tras el pedido, al generar el PDF.',
        conversationPreviewBestofHintDismiss: 'Cerrar',
        conversationPreviewBestofHintLearnMore: 'Saber más',
        conversationPreviewBestofPriceNote: 'Selección tras el pedido',
        conversationPreviewTypeBestofTaglineCompare: 'Alternativa más ligera: tus mejores momentos en 1 tomo.',
        conversationPreviewMetaEbook: 'eBook incluido',
        conversationPreviewMetaVolume: '{count} tomo',
        conversationPreviewMetaVolumes: '{count} tomos',
        conversationPreviewMetaPages: '{pages} páginas',
        conversationPreviewMetaMessages: '{count} mensajes',
        conversationPreviewMetaBestofPages: '~400 páginas',
        conversationPreviewMetaBestofSelection: 'Selección inteligente',
        conversationPreviewMetaPdfInstant: 'PDF al instante',
        conversationPreviewMetaPdfCredit: 'Crédito para el libro',
        conversationPreviewPdfPriceNote: 'Se deduce si pasas al libro',
        conversationPreviewPdfLearnMore: '¿Cómo funciona?',
        conversationPreviewPdfHelpText: 'Pagas {ebookPrice} y recibes tu PDF. Si más adelante pides el libro impreso a {bookPrice}, esos {ebookPrice} se descuentan: quedan {remainingPrice}. El crédito queda en tu cuenta.',
        conversationPreviewReassurancePdfCredit: 'Estos {price} se deducen si pasas al libro',
        conversationPreviewStickyPdfCredit: 'Crédito de {price} si pasas al libro',
        conversationPreviewEbookCreditBanner: 'Tienes {amount} de crédito en esta conversación. Se deducirán automáticamente si pides el libro impreso.',
        conversationPreviewEbookCreditOrderHint: '{credit} de crédito descontados · precio de catálogo {fullPrice}',
        conversationPreviewStickyEbookCredit: '{credit} de crédito aplicados',
        paymentMethodEbookCreditHint: 'Crédito ebook hacia el libro impreso',
        cartTotalsEbookCredit: 'Crédito ebook',
        cartTotalsCredit: 'Crédito',
        conversationOrderButtonEbook: 'Recibir mi PDF',
        conversationOrderButtonEbookWithPrice: 'Recibir mi PDF · {price}',
        conversationPreviewTypeBookTaglineSingle: 'Tu historia completa, página a página.',
        conversationPreviewTypeBookTaglineMulti: 'Tu conversación completa en {count} libros impresos.',
        conversationPreviewHeroHeading: 'Vista previa del libro',
        conversationPreviewHelpTourButton: 'Mostrar ayuda de la página',
        conversationPreviewCardLabelCover: 'Portada',
        conversationPreviewCardLabelParticipants: 'Participantes',
        conversationPreviewCardLabelDates: 'Fechas',
        conversationPreviewCardLabelMessages: 'Mensajes',
	conversationPreviewZoneDone: 'Ya explorado',
	conversationPreviewZoneHintCover: 'Color, foto, título, prefacio',
	conversationPreviewZoneHintParticipants: 'Nombres y colores de los globos',
	conversationPreviewZoneHintDates: 'Periodo que cubre el libro',
	conversationPreviewZoneHintMessages: 'Ocultar o corregir mensajes',
        conversationHelpPreviewCustomizeTitle: 'Nombres, fechas y mensajes',
        conversationHelpPreviewCustomizeText: 'Toca una tarjeta para editar nombres, fechas o mensajes.',
        conversationBookNavPrev: 'Página anterior',
        conversationBookNavNext: 'Página siguiente',
        conversationBookBackToCover: 'Volver a la portada',
        conversationPreviewTypeBookPagesHint: ' · {pages} páginas',
        conversationPreviewTypeBookMessagesHint: ' · {count} mensajes',
        conversationOrderTotal: 'Total',
        conversationPreviewTypeBestofDescription: '400 páginas, tus mejores momentos. eBook incluido.',
        conversationPreviewTypeBestofTitle: 'Best Of',
        conversationPreviewTypeBookDescription: '{count} tomo · Historia completa. eBook incluido.',
        conversationPreviewTypeBookDescriptionWithPrice: '{count} tomos · {unitBreakdown} · Colección integral. eBook incluido.',
        conversationPreviewReassuranceShipping: 'Envío gratuito en todo el mundo',
        conversationPreviewExpressDeliveryLead: 'Entrega express {where} a partir del',
        conversationPreviewExpressDeliveryDate: '{date}',
        conversationPreviewTypeBookTitle: 'Colección completa',
        conversationPreviewTypeHighlight: 'Recomendado',
        conversationPreviewTypePdfDescription: 'Guarda tu conversación en PDF. Este importe cuenta para el libro, si lo quieres más adelante.',
        conversationPreviewTypePdfTitle: 'Digital',
        conversationPreviewTypeSelectionTitle: 'Elige tu formato',
    conversationProgress: 'Progreso',
    conversationProviderButton: 'Acceder a los ajustes',
    conversationProviderType: 'Tipo',
    conversationRemoveButton: 'Eliminar el chat',
    conversationRemoveConfirmText: 'Al eliminar tu chat, tus archivos multimedia se borrarán de nuestros servidores y no podrán ser recuperados. ¿Seguro?',
    conversationRemoveConfirmTitle: 'Eliminar el chat',
    conversationRemoveFlagConfirmMessage: '¿Quieres quitar esta marca del chat?',
    conversationRemoveSuccess: '¡Chat eliminado correctamente!',
    conversationRestartProcess: 'Reiniciar',
    conversationResumeButton: 'Validar e imprimir',
    conversationResumeConfirmText: 'Tu chat será marcado como "verificado" y pasará pronto a la fase de generación e impresión.',
    conversationValidateModificationsButton: 'Validar mis cambios',
    conversationValidateModificationsConfirmTitle: '¿Validar tus cambios?',
    conversationValidateModificationsConfirmBook: 'Tu libro volverá a fabricación con tus cambios.',
    conversationValidateModificationsConfirmEbook: 'Tu eBook se regenerará con tus cambios y se te enviará de nuevo por correo electrónico.',
    conversationValidateModificationsConfirmMissingMedias: 'Faltan algunos archivos multimedia de tu conversación. Compruébalos antes de validar: tu libro pasará a fabricación con tus cambios actuales.',
    conversationValidateModificationsSuccessBook: 'Tus cambios se han guardado. Tu libro vuelve a fabricación.',
    conversationValidateModificationsSuccessEbook: 'Tus cambios se han guardado. Tu eBook regenerado te será enviado por correo electrónico.',
    conversationValidateModificationsBackToList: 'Volver a mis conversaciones',
    conversationSelectThread: 'Seleccionar un chat',
    conversationShareCancelButton: 'Ahora no',
    conversationShareConfirmButton: 'Ver mis momentos',
    conversationShareConfirmTitle: 'Mira lo que hemos encontrado...',
    conversationShareConfirmText: 'Tu conversación esconde cifras que dan ganas de compartir. Las hemos puesto en imágenes.',
    conversationStatusConfigured: 'Pendiente de generación',
    conversationStatusDone: 'Terminado',
    conversationStatusOngeneration: 'Generación en curso',
    conversationStatusOnproduction: 'En producción',
    conversationStatusOnvalidation: 'Pendiente de impresión',
    conversationStatusPending: 'En espera',
    conversationTypeAndroidDownloadAlt: 'O copia y pega el enlace en tu navegador preferido',
    conversationTypeAndroidDownloadButton: 'Descarga la aplicación',
    conversationTypeAndroidIntroText1: 'Para imprimir tu Libro SMS desde un teléfono Android, es necesario utilizar tu smartphone (Samsung, Xiaomi, Pixel, etc.).',
    conversationTypeAndroidIntroText2: 'Instala la aplicación MonLivreSMS en tu móvil Android haciendo clic en el siguiente enlace (la app no está disponible en Google Play):',
    conversationTypeAndroidIntroText3: 'Elige al coautor de tu libro SMS de recuerdos, así como las fechas de inicio y fin de vuestra historia.',
    conversationTypeAndroidIntroText4: 'Elige los nombres de los protagonistas de tu historia, escribe tu dedicatoria y personaliza tu portada.',
    conversationTypeAndroidIntroText5: 'Para finalizar la creación de tu libro, crea una cuenta y completa tu compra a través de nuestro servidor de pago seguro.',
    conversationTypeInstagramFileText1: 'Instagram te enviará un email para que puedas descargar el archivo.',
    conversationTypeInstagramFileText2: 'Descárgalo en tu dispositivo.',
    conversationTypeInstagramFileText3: 'Haz clic en el botón de abajo y selecciona el archivo en tus descargas sin abrirlo, dejándolo en formato .zip (ejemplo: *tunombre*_*fecha*.zip). Solo la conversación que elijas se enviará a nuestros servicios de impresión.',
    conversationTypeInstagramProviderText1: 'Recupera una copia de tus datos de Instagram accediendo a la configuración general de tu cuenta.',
    conversationTypeInstagramProviderText2: 'Introduce el correo electrónico asociado a tu cuenta de Instagram y elige el formato JSON.',
    conversationTypeInstagramProviderText3: 'Luego introduce tu contraseña y haz clic en <strong>Solicitar descarga</strong> para iniciar la generación de tu copia de seguridad en Instagram.',
    conversationTypeIosIntroText1: 'Conecta tu iPhone a tu ORDENADOR y realiza una copia de seguridad en iTunes sin cifrar. (marca "Este ordenador", DESMARCA "Cifrar copia de seguridad local" y haz clic en "Realizar copia de seguridad ahora").',
    conversationTypeIosIntroText2: 'Descarga el software MonLivreSMS haciendo clic en el enlace correspondiente al sistema operativo de tu ordenador:',
    conversationTypeIosIntroText3: '<strong>ATENCIÓN, si el software no detecta ninguna copia de seguridad:</strong><br></br> - Para MAC:<br></br>Ve a Preferencias del sistema > Seguridad y privacidad > Acceso total al disco y añade la aplicación MonLivreSMS desbloqueando el candado abajo a la izquierda.<br></br> - Para PC:<br></br>Por tu seguridad, Apple impide la lectura de tu copia de seguridad sin tu autorización.',
    conversationTypeMessengerFileText1: 'Facebook te enviará un email para descargar el archivo de tus chats.',
    conversationTypeMessengerFileText2: 'Descárgalo en tu dispositivo.',
    conversationTypeMessengerFileText3: 'Haz clic en el botón de abajo y selecciona el archivo en tus descargas dejándolo en formato .zip (ejemplo: facebook-*tunombre*.zip). Solo la conversación que elijas se procesará.',
    conversationTypeMessengerProviderText1: 'Recupera una copia de tus datos de Facebook accediendo a la configuración de tu cuenta.',
    conversationTypeMessengerProviderText2: 'Haz clic en "Descargar tu información".',
    conversationTypeMessengerProviderText3: `Luego, define las siguientes opciones:<br></br>
              <strong>Intervalo de fechas</strong>: (el que prefieras)<br></br>
              <strong>Formato</strong>: JSON<br></br>
              <strong>Calidad del contenido multimedia</strong>: Baja (es suficiente para la impresión y mucho más rápido de transferir)<br></br>
              <strong>Tu información</strong>: Selecciona solo "Mensajes" (desmarca el resto).`,
    'conversationTypeMessengerProviderText4': 'Atención: ¡Asegúrate de seleccionar el formato de datos en JSON (y no en HTML)!',
    'conversationTypeSnapchatProviderText1.1': 'Abre la aplicación Snapchat en tu dispositivo.',
    'conversationTypeSnapchatProviderText1.2': 'Toca tu avatar (o Bitmoji) arriba a la izquierda para acceder a tu perfil.',
    'conversationTypeSnapchatProviderText1.3': 'Toca el icono del engranaje arriba a la derecha para abrir los Ajustes.',
    'conversationTypeSnapchatProviderText2.1': 'Desplázate hacia abajo hasta la sección "Controles de privacidad".',
    'conversationTypeSnapchatProviderText2.2': 'Selecciona "Mis datos".',
    'conversationTypeSnapchatProviderText3.1': 'Es posible que te pidan iniciar sesión para verificar tu identidad.',
    'conversationTypeSnapchatProviderText4.1': 'En la página "Mis datos", encontrarás una lista con los datos que puedes descargar, incluidos tus mensajes.',
    'conversationTypeSnapchatProviderText4.2': 'Haz clic en "Enviar solicitud" en la parte inferior de la página.',
    'conversationTypeSnapchatProviderText5.1': 'Una vez enviada tu solicitud, Snapchat preparará la descarga de tus datos.',
    'conversationTypeSnapchatProviderText5.2': 'Esto puede tardar un tiempo, generalmente desde unas horas hasta un día.',
    'conversationTypeSnapchatProviderText5.3': 'Recibirás un email de Snapchat con un enlace para descargar tus datos cuando el archivo esté listo.',
    'conversationTypeSnapchatProviderText6.1': 'Haz clic en el enlace del email para acceder a la página de descarga.',
    'conversationTypeSnapchatProviderText6.2': 'Descarga el archivo ZIP que contiene tus datos.',
    'conversationTypeSnapchatProviderText7.1': 'Una vez descargado el archivo ZIP, no lo abras.',
    'conversationTypeSnapchatProviderText7.2': 'Sube el archivo ZIP completo, tal cual, en la sección indicada de nuestra web.',
    'conversationTypeSnapchatProviderText7.3': 'A continuación podrás elegir el chat que prefieras para crear tu libro.',
    conversationTypeSnapchatProviderTitle1: '1. Accede a los Ajustes de Snapchat:',
    conversationTypeSnapchatProviderTitle2: '2. Solicitar tus Datos:',
    conversationTypeSnapchatProviderTitle3: '3. Autenticación:',
    conversationTypeSnapchatProviderTitle4: '4. Descarga de tus Datos:',
    conversationTypeSnapchatProviderTitle5: '5. Esperar el Email:',
    conversationTypeSnapchatProviderTitle6: '6. Descargar el Archivo:',
    conversationTypeSnapchatProviderTitle7: '7. Subida a MonLivreSMS:',
    'conversationTypeTelegramProviderText1.1': 'Instala la aplicación Telegram de escritorio en tu PC o Mac desde https://desktop.telegram.org/.',
    'conversationTypeTelegramProviderText1.2': 'Abre la aplicación Telegram en tu ordenador.',
    'conversationTypeTelegramProviderText2.1': 'En la aplicación, abre el chat que deseas transformar en libro haciendo clic en el nombre de tu contacto.',
    'conversationTypeTelegramProviderText3.1': 'Haz clic en los tres puntos en la esquina superior derecha del chat.',
    'conversationTypeTelegramProviderText3.2': 'Elige "Exportar historial de chat".',
    'conversationTypeTelegramProviderText4.1': 'En la ventana de ajustes, selecciona todos los tipos de archivos que desees incluir (fotos, vídeos, mensajes de voz, etc.).',
    'conversationTypeTelegramProviderText4.2': 'Ajusta el límite de tamaño al máximo permitido para la exportación.',
    'conversationTypeTelegramProviderText4.3': 'Haz clic en "Exportar" en la parte inferior de la ventana.',
    'conversationTypeTelegramProviderText5.1': 'Localiza la carpeta con los datos exportados y comprímela en un archivo ZIP (Clic derecho > Enviar a > Carpeta comprimida (en zip)).',
    'conversationTypeTelegramProviderText6.1': 'Sube el archivo ZIP completo a nuestra web.',
    conversationTypeTelegramProviderTitle1: '1. Instalar Telegram de Escritorio:',
    conversationTypeTelegramProviderTitle2: '2. Seleccionar el Chat:',
    conversationTypeTelegramProviderTitle3: '3. Exportar el Historial:',
    conversationTypeTelegramProviderTitle4: '4. Ajustes de Exportación:',
    conversationTypeTelegramProviderTitle5: '5. Comprimir en un Archivo ZIP:',
    conversationTypeTelegramProviderTitle6: '6. Subir el archivo a MonLivreSMS:',
    conversationTypeTitle: 'Crear un libro a partir del chat con {name}',
    conversationTypeWhatsappFileText1: 'Recuperar tu chat de WhatsApp',
    conversationTypeWhatsappFileText2: 'Haz clic en "Adjuntar un archivo"',
    conversationTypeWhatsappFileText3: 'Sube tu conversación',
    conversationTypeWhatsappFileText4: 'Si el archivo no está en formato ".zip", comprímelo primero.',
    conversationTypeWhatsappFileText5: 'Si solo quieres el texto de tu conversación (sin fotos), sube únicamente el archivo .txt',
    conversationTypeWhatsappProviderText1: 'Exportar una copia de tu chat de WhatsApp',
    conversationTypeWhatsappProviderText2: '<strong>Desde un Android:</strong><br></br>Abre la aplicación de WhatsApp<br></br>Entra en el chat deseado<br></br>Toca en "Opciones" (los tres puntos arriba a la derecha)',
    conversationTypeWhatsappProviderText3: '<strong>Desde iOS (iPhone):</strong><br></br>Abre la aplicación de WhatsApp<br></br>Entra en el chat deseado<br></br>Toca el nombre del contacto o del grupo en la parte superior<br></br>Desplázate hasta abajo y selecciona "Exportar chat"',
    conversations: 'Chats',
    conversationsMy: 'Mis chats',
    conversationsLuxEyebrow: 'Tus historias',
    conversationsLuxHint: 'Encuentra tus conversaciones y conviértelas en un hermoso libro.',
    ordersLuxEyebrow: 'El taller',
    ordersLuxHint: 'Sigue tus libros, del taller a casa.',
    ordersLuxDetailTitle: 'Tu libro',
    ordersLuxDetailHint: 'Sigue tu libro, del taller a tu puerta.',
    ordersLuxViewFollow: 'Seguir mi libro',
    ordersLuxEmptyTitle: 'Tu primera historia te está esperando.',
    ordersLuxEmptyHint: 'Convierte una conversación en un libro que querrás abrir una y otra vez.',
    ordersLuxStepReceived: 'Recibido',
    ordersLuxStepAtelier: 'Taller',
    ordersLuxStepPrint: 'Impresión',
    ordersLuxStepShipped: 'En camino',
    ordersLuxStepHome: 'Contigo',
    ordersLuxStoryPendingpayment: 'En cuanto pagues, el libro entra en el taller.',
    ordersLuxStoryPending: 'Hemos recibido tu pedido. El taller ya está en ello.',
    ordersLuxStoryOnpreparation: 'Tu libro toma forma. Cada página se prepara con cuidado.',
    ordersLuxStoryOnfabrication: 'Tu libro se está imprimiendo. Pronto saldrá del taller.',
    ordersLuxStoryShipped: 'Tu libro está en camino. Viaja hasta tu casa.',
    ordersLuxStoryComplete: 'Tu libro ha llegado. Solo espera tus manos.',
    ordersLuxStoryCanceled: 'Este pedido fue anulado. Tus recuerdos siguen a salvo con nosotros.',
    userProfileLuxEyebrow: 'Tu espacio',
    userProfileLuxHint: 'Gestiona tus datos, tus conexiones y tus preferencias.',
    userProfileValueEmpty: 'No indicado',
    userProfileNotLinked: 'No vinculado',
    userProfileNewsletterOn: 'Ya recibes nuestras novedades y ofertas.',
    userProfilePasswordOn: 'Definida',
    addressesLuxEyebrow: 'Tu espacio',
    addressesLuxHint: 'Encuentra tus direcciones de entrega y facturación.',
    addressesLuxEditHint: 'Esta dirección puede servir para la entrega o la facturación.',
    conversationsNewApp: 'Nuevos chats en la aplicación',
    conversationsOldApp: 'Chats antiguos en la aplicación',
    dashboardTitle: 'Panel de control',
    date: 'Fecha',
    dateActivated: 'Fecha de activación',
    dateCreated: 'Fecha de creación',
    dateLastCguAccept: 'Fecha de última aceptación de los TyC',
    dateLastEdit: 'Fecha de última modificación',
    dateLastLogin: 'Fecha de última conexión',
    dateSelect: 'Seleccionar una fecha',
    dateSelectPlaceholder: 'Haz clic aquí para seleccionar una fecha...',
    days: 'Día(s)',
    daysCount: `{count} {count, plural,
        =0 {día}
        =1 {día}
        other {días}
    }`,
    delete: 'Eliminar',
    deleteRequestError: '¡Error al eliminar!',
    deleteRequestSuccess: '¡Eliminado con éxito!',
    description: 'Descripción',
    detailsInformation: 'Detalles',
    domain: 'Dominio',
    download: 'Descargar',
    edit: 'Modificar',
    editViewAdvanced: 'Edición avanzada',
    editViewSimplified: 'Edición simplificada',
    elementNoItems: 'Ningún elemento',
    elementsCount: `{count} {count, plural,
              =0 {elemento}
              =1 {elemento}
              other {elementos}
          }`,
    example: 'Ejemplo',
    examples: 'Ejemplos',
    file: 'Archivo',
    fileDeleteError: 'Imposible eliminar este archivo',
    fileDeleteSuccess: '¡Archivo eliminado!',
    fileSelected: 'Archivo seleccionado: {file}',
    fileSwitch: 'Cambiar de archivo',
    fileUploadError: '¡Imposible cargar este archivo!',
    fileUploadProcessStartOnSave: 'La carga del archivo comenzará al guardar.',
    fileUploadRestrictionTypeError: '¡Formato de archivo no válido! Permitidos: {types}',
    fileUploadSuccess: '¡Archivo subido correctamente!',
    files: 'Archivos',
    filtersTitle: 'Filtros',
    finish: 'Terminar',
    flags: 'Banderas',
    free: 'Gratis',
    generalInformation: 'Información general',
    help: 'Ayuda',
    hours: 'Horas',
    hoursCount: `{count} {count, plural,
        =0 {hora}
        =1 {hora}
        other {horas}
    }`,
    imageDeleteError: '¡Imposible eliminar esta imagen!',
    imageDeleteSuccess: '¡Imagen eliminada!',
    imageUploadError: 'Imposible cargar esta imagen',
    imageUploadRestrictionSize: 'La imagen debe tener un tamaño máximo de {format}',
    imageUploadRestrictionType: 'La imagen debe estar en formato {types}',
    imageUploadRestrictionTypeError: '¡Formato de imagen no aceptado! Permitidos: {types}',
    import: 'Importar',
    importModelDownloadButton: 'Descargar la plantilla',
    importRequestError: '¡Ha ocurrido un error durante la importación!',
    importRequestSomeFailAlert: '¡Uno o varios elementos no han podido ser importados!',
    importRequestSuccess: '¡Datos importados con éxito!',
    importerFileButton: 'Importar los datos',
    importerFileHelp: 'Puedes generar un archivo CSV utilizando tu programa de hojas de cálculo (Excel, OpenOffice, ...)',
    importerFileInfo: 'Seleccionar un archivo CSV (Valores separados por comas)',
    importerNoItemsAlert: 'No hay elementos para importar',
    importerTitle: 'Importación de datos',
    information: 'Información',
    informationsDetails: 'Detalles',
    informationsGeneral: 'Información general',
    invoicePrint: 'Imprimir la factura',
    invoicesPrint: 'Imprimir las facturas',
    isActive: '¿Activo?',
    isPublic: '¿Es público?',
    isUnlimited: '¿Ilimitado?',
    label: 'Nombre/Etiqueta',
    language: 'Idioma',
    languageAR: 'Árabe',
    languageBN: 'Bengalí',
    languageDE: 'Alemán',
    languageEN: 'Inglés',
    languageES: 'Español',
    languageFR: 'Francés',
    languageHI: 'Hindi',
    languageIT: 'Italiano',
    languageJA: 'Japonés',
    languagePT: 'Portugués',
    languageRU: 'Ruso',
    languageZH: 'Chino',
    learnMoreButton: 'Saber más',
    limitLabel: 'Tipo de límite',
    limitTextForm1: 'debe tener un',
    listTitle: 'Lista',
    loading: 'Cargando...',
    logo: 'Logo',
    minutes: 'Minuto(s)',
    name: 'Nombre',
    next: 'Siguiente',
    no: 'No',
    of: 'de',
    options: 'Opciones',
    order: 'Pedido',
    orderAdd: 'Añadir un pedido',
    orderAddTitle: 'Crear un pedido',
    orderAddressPrivacyInfo: ' ¡Tu dirección no será pública! Solo los demás participantes de este pedido podrán verla.',
    orderAddressShippingValid: 'Confirmar la dirección de envío',
    orderBilling: 'Facturación',
    orderConfirmationPaymentError: 'Se ha producido un error... ¡Por favor, contáctanos!',
    orderConfirmationPaymentWaiting: 'Por favor, espera... Estamos procesando tu pago para confirmar tu pedido.',
    orderConfirmationPendingText: '¡Tu pedido está pendiente de pago para poder ser completado! Haz clic en el enlace de abajo para finalizar tu compra realizando el pago.',
    orderConfirmationPendingText2: 'ATENCIÓN: Si pagas con tarjeta bancaria, la validación del pago puede tardar unos minutos. Por favor, espera mientras realizamos las comprobaciones de seguridad.',
    orderConfirmationPendingTitle: '¡Pedido pendiente de pago!',
    orderConfirmationSocialText: 'Síguenos en tus redes sociales favoritas para no perderte nuestras novedades, nuevos productos y promociones exclusivas...',
    orderConfirmationSocialTitle: '¡Sigamos en contacto!',
    orderConfirmationText: ' Tu pedido ha sido registrado correctamente y pasará a preparación. Recibirás un email en cuanto sea enviado.',
    orderConfirmationTitle: '¡Pedido recibido!',
    orderContent: 'Contenido del pedido',
    orderDetails: 'Detalles',
    orderId: 'Identificador',
    orderInfoCommentAlertTitle: 'Mensaje importante',
    orderInvoice: 'Factura',
    orderInvoicePrintButton: 'Imprimir la factura',
    orderItemsEmpty: 'No hay ningún artículo en tu pedido',
    orderItemViewBook: 'Ver mi libro',
    orderItemsTotal: 'Total de artículos:',
    orderMassStatusConfirmMessage: '¿Actualizar el estado de {count} pedido(s)?',
    orderNoItems: '¡Aún no has realizado ningún pedido!',
    orderNoteCustomer: 'Nota del cliente',
    orderPaymentChooseMethodLabel: 'Elige un método de pago',
    orderPaymentFinishTitle: 'Finalizar tu pago',
    orderPaymentValidButton: 'Confirmar el pago',
    orderPayments: 'Pagos',
    orderProcessInvitationText: 'Invita a tus amigos a rellenar la casilla',
    orderProcessInvitationTextBefore1: 'Directos.eu es un servicio de compra en grupo entre particulares que te permite comprar productos directamente a los fabricantes. ¡Ahorrarás tanto en el precio de los productos COMO en los gastos de envío!',
    orderProcessInvitationTextBefore2: '¡No te preocupes! Tenemos la solución:',
    orderProductAdd: 'Añadir un producto ',
    orderRefunds: 'Reembolsos',
    orderShipping: 'Envío',
    orderShippingAdd: 'Añadir el envío',
    orderShippingFee: 'Gastos de envío',
    orderShippingRemoveConfirmMessage: '¿Seguro que quieres quitar este envío del pedido?',
    orderShippingTrackingTitle: 'Sigue tu pedido',
    orderShippingTrackingButton: 'Seguir mi paquete',
    orderShippingTrackingHint: 'El seguimiento puede tardar unas horas en aparecer en el transportista.',
    orderShippings: 'Envíos',
    orderStatus: 'Estado',
    orderStatusCanceled: 'Cancelado',
    orderStatusComplete: 'Completado',
    orderStatusOnpreparation: 'En preparación',
    orderStatusOnprogress: 'En curso',
    orderStatusPending: 'En espera',
    orderStatusPendingpayment: 'Pendiente de pago',
    orderStatusShipped: 'Enviado',
    orderSubtotalDiscount: 'Descuento',
    orderSubtotalExclTax: 'Subtotal (sin IVA)',
    orderSubtotalInclTax: 'Subtotal (IVA incl.)',
    orderTax: 'IVA',
    orderThanks: 'Gracias por tu pedido',
    attributionPaidLine: 'El pago está hecho',
    attributionSkip: 'Ver mi pedido',
    attributionSourceTitle: '¿Qué te dio ganas de este libro?',
    attributionSourceLead: 'Tu pedido ya está hecho. Una respuesta nos dice qué te hizo ilusión.',
    attributionSearchTitle: 'Antes de buscar, ¿ya conocías MonLivreSMS?',
    attributionSearchLead: 'Un nombre que ya te sonaba, o algo completamente nuevo.',
    attributionOccasionTitle: '¿Para qué ocasión es este libro?',
    attributionOccasionLead: 'La que tienes pensada.',
    attributionOtherPlaceholder: 'Unas palabras, si quieres',
    attributionOtherContinue: 'Continuar',
    attributionSaveError: 'No pudimos guardar esta respuesta. Inténtalo de nuevo.',
    attributionOpt_bouche_a_oreille: 'Un cercano me habló de ello',
    attributionOpt_vu_objet: 'Vi el libro en casa de alguien',
    attributionOpt_receveur_devenu_client: 'Me regalaron uno, ahora me toca',
    attributionOpt_recherche: 'Buscando en Google',
    attributionOpt_instagram: 'Instagram',
    attributionOpt_tiktok: 'TikTok',
    attributionOpt_facebook: 'Facebook',
    attributionOpt_pinterest: 'Pinterest',
    attributionOpt_qvema: 'Qui veut être mon associé',
    attributionOpt_medias: 'Un artículo, un programa o un pódcast',
    attributionOpt_client_existant: 'Ya había pedido aquí',
    attributionOpt_autre: 'Otra cosa',
    attributionOpt_decouverte_pure: 'Más bien una casualidad',
    attributionOpt_pre_bao: 'Un cercano me lo había contado',
    attributionOpt_pre_tv: 'Lo había visto en la tele',
    attributionOpt_pre_social: 'Lo había visto en redes',
    attributionOpt_pre_inconnu: 'Ya no lo sé',
    attributionOpt_anniv_couple: 'El aniversario de cuando nos conocimos',
    attributionOpt_noel: 'Navidad',
    attributionOpt_saint_valentin: 'San Valentín',
    attributionOpt_anniversaire: 'Un cumpleaños',
    attributionOpt_deuil: 'Los mensajes de alguien que perdí',
    attributionOpt_naissance: 'Un nacimiento',
    attributionOpt_distance: 'Alguien que se va, o que vive lejos',
    attributionOpt_pour_soi: 'Para mí, no para regalarlo',
    attributionOpt_autre_occasion: 'Otro momento',
    bookIntentTitle: 'Este libro es para...',
    bookIntentLead: 'Una respuesta, y empezamos.',
    bookIntentSkip: 'Ahora no',
    bookIntentOpt_anniv_couple: 'El aniversario de cuando nos conocimos',
    bookIntentOpt_anniversaire: 'El cumpleaños de alguien',
    bookIntentOpt_noel: 'Navidad',
    bookIntentOpt_saint_valentin: 'San Valentín',
    bookIntentOpt_souvenir: 'Alguien que ya no está',
    bookIntentOpt_plus_tard: 'Más adelante',
    bookIntentOpt_autre: 'Otra cosa',
    bookIntentDate_anniv_couple: '¿Cuál es la fecha?',
    bookIntentDateLead_anniv_couple: 'El día en que os conocisteis, o el que celebráis juntos.',
    bookIntentDate_anniversaire: '¿Qué día es su cumpleaños?',
    bookIntentDateLead_anniversaire: 'El cumpleaños de la persona a la que se lo regalas.',
    bookIntentDate_plus_tard: '¿Hacia qué fecha?',
    bookIntentDateLead_plus_tard: 'El día que tienes en mente.',
    bookIntentDateDefer: 'La fecha, más tarde',
    bookIntentDateBack: 'Volver',
    bookIntentDateContinue: 'Continuar',
    bookIntentSaveError: 'No hemos podido guardar la respuesta. Inténtalo de nuevo.',
    inboxPromptTitle: 'Para tu libro',
    inboxPromptSignup: 'Acabamos de enviarte un correo, « {subject} ». Es el comienzo de tu libro, no un anuncio. {provider} a veces lo aparta. Márcalo como « {mark} ». Con ese gesto, lo que sigue te llegará bien, con lo que hace falta para hacerlo de verdad.',
    inboxPromptTransfer: 'Acabamos de enviarte un correo, « {subject} ». Es el enlace a tu conversación, no un anuncio. {provider} a veces lo aparta. Márcalo como « {mark} ». Con ese gesto, lo tendrás todo a mano para hacer el libro que quieres.',
    inboxPromptMarkGmail: 'No es spam',
    inboxPromptMarkYahoo: 'No es spam',
    inboxPromptButton: 'Lo valido en {provider}',
    inboxPromptClose: 'Cerrar',
    inboxPromptConfirm: 'Acabamos de enviarte un correo, « {subject} ». Abre tu cuenta. {provider} a veces lo aparta. Márcalo como « {mark} ». Con ese gesto, lo que sigue te llegará.',
    emailConfirmPageTitle: 'Confirma tu dirección',
    emailConfirmTitle: 'Mira tu correo',
    emailConfirmLead: 'Acabamos de enviarte un correo para abrir tu cuenta. El botón de dentro confirma tu dirección.',
    emailConfirmResend: 'Volver a enviar el correo',
    emailConfirmResent: 'El correo vuelve a salir.',
    emailConfirmExpired: 'Este enlace ha caducado. Pide uno nuevo desde tu cuenta.',
    emailConfirmInvalid: 'Este enlace no corresponde a ninguna cuenta.',
    emailConfirmWorking: 'Abriendo la cuenta…',
    orderTotal: 'TOTAL',
    orderTotalTTC: 'Total (IVA incl.)',
    orderTotalTax: 'I.V.A. {rate}%',
    orderTotalToPay: 'Importe total a pagar: {total}€',
    orderTotals: 'Totales',
    orderUserRegisterAlert: 'Debes facilitarnos tu email para que podamos contactarte en caso de que haya algún problema con tu pedido.',
    orderView: 'Ver el pedido',
    orderWeight: 'Peso',
    orderitemAddProductTitle: 'Modificar los datos del artículo',
    orders: 'Pedidos',
    ordersContactTitle: 'Contactar sobre un pedido',
    ordersMy: 'Mis pedidos',
    ordersMyViewButton: 'Ver mis pedidos',
    packingInformation: 'Información de embalaje',
    parcelGroupInfo: ' Agrupar el envío por número de paquetes',
    parcelGroupLabel: 'Grupo de paquetes',
    parcelGroupWeightInfo: 'Kg por paquete',
    parcelGroupWeightLabel: 'Agrupar el envío por peso',
    paymentCardInputLabel: 'Por favor, introduce los datos de tu tarjeta para confirmar tu pedido.',
    paymentMethodCreditbalanceDescription1: 'Se descuenta automáticamente del total',
    paymentMethodCreditbalanceDescription2: 'Resta por pagar',
    paymentMethodCreditbalancePay: 'Validar con mi crédito',
    paymentMethodCreditbalanceTitle: 'Crédito ya aplicado',
    paymentFailError: '¡Tu pago ha fallado! Por favor, inténtalo de nuevo.',
    paymentMethod: 'Método de pago',
    paymentMethodBancontactLabel: 'Bancontact',
    paymentMethodBankcheckLabel: 'Cheque bancario',
    paymentMethodBanktransferLabel: 'Transferencia bancaria',
    paymentMethodCardLabel: 'Tarjeta bancaria',
    paymentMethodCreditcardLabel: 'Tarjeta bancaria',
    paymentMethodCreditDescription1: 'Este importe se descontará automáticamente del importe pendiente de tu carrito.',
    paymentMethodGiropayLabel: 'Giropay',
    paymentMethodIdealLabel: 'iDEAL',
    paymentMethodPhoneLabel: 'Teléfono',
    paymentMethodCreditPay: 'Pagar con mis créditos',
    paymentMethodCreditTitle: 'Ya has pagado una parte de tu pedido:',
    paymentValidButton: 'Confirmar mi pago',
    previous: 'Anterior',
    priceInformation: 'Información sobre precios',
    priceRoundAlertTooltip: 'Este precio puede sufrir un ligero redondeo debido a la conversión de divisas.',
    printButton: 'Imprimir',
    process: 'Proceso',
    productAnnexes: 'Anexos',
    productAnnexesNewProductError: '¡Por favor, guarda tu nuevo producto antes de añadirle anexos!',
    productAttributes: 'Atributos',
    productConversationTypeMissingAlert: 'No hay ningún producto asociado al tipo seleccionado. ¡Por favor, contáctanos para resolverlo!',
    productCostHT: 'Coste (sin IVA)',
    productDescription: 'Descripción',
    productEdit: 'Modificar el producto',
    productImages: 'Imágenes',
    productImagesNewProductError: '¡Por favor, guarda tu nuevo producto antes de añadirle imágenes!',
    productIsActive: '¿Activo?',
    productName: ' Nombre',
    productPictureDelete: 'Eliminar la imagen',
    productPriceHT: 'Precio (sin IVA)',
    productPriceTTC: 'Precio (IVA incl.)',
    productReference: 'Referencia',
    productSlug: 'Slug',
    productSpecialPriceQuantityDiscountInfo: '¡Ahorra un {percent}% en tu compra añadiendo {quantity} copias!',
    productTaxCalculate: 'Calcular',
    productTaxRate: 'Tipo de IVA',
    productTaxRateFormHelp: 'Para un IVA del 21%, introduce 0.21',
    productUseForConversationBook: '¿Disponible para libros en papel?',
    productUseForConversationEBook: '¿Disponible para eBooks (digital)?',
    productUseForCredit: '¿Utilizar para los créditos de usuario?',
    products: 'Productos',
    productsView: 'Ver los productos',
    quantity: 'Cantidad',
    refresh: 'Actualizar',
    refundCreateTitle: 'Crear un reembolso',
    refundCreateConfirmMessage: '¿Confirmas la creación de este reembolso?',
    remove: 'Eliminar',
    retry: 'Reintentar',
    save: 'Guardar',
    saveBeforeAlert: 'Por favor, guarda los cambios primero...',
    saveRequestError: '¡Error al guardar!',
    saveRequestSuccess: '¡Guardado correctamente!',
    saving: 'Guardando...',
    searchFor: 'Buscar',
    seconds: 'Segundo(s)',
    select: 'Seleccionar',
    selectAll: 'Seleccionar todo',
    selectFile: 'Seleccionar un archivo',
    selectImage: 'Selecciona una imagen',
    selectOptions: 'Seleccionar una opción',
    selectUnAll: 'Deseleccionar todo',
    seoTitle: 'Imprimir tus SMS y chats de WhatsApp en un libro',
    shippingAddressEdit: 'Modificar la dirección de envío',
    shippingAddressMissingError: 'No has introducido ninguna dirección de envío.',
    shippingCalculation: 'Cálculo',
    shippingCalculationInfo: 'Si el cálculo entra en bucle, es preferible utilizar el límite máximo inclusivo.',
    shippingCarrier: 'Transportista',
    shippingChronopostPickupError: '¡No hemos podido cargar los Puntos Pack! Por favor, revisa el país y el código postal antes de volver a intentarlo.',
    shippingChronopostPickupNoResult: 'No hemos encontrado ningún punto de recogida cercano. Por favor, busca con otra dirección o código postal.',
    shippingChronopostPickupOpeningHours: 'Horarios de apertura',
    shippingChronopostPickupOpeningHoursView: 'Ver los horarios',
    shippingChronopostPickupViewList: 'Ver en formato lista',
    shippingChronopostPickupViewMap: 'Ver en el mapa',
	shippingPickupError: 'No se pudo abrir el selector de puntos de recogida. Inténtalo de nuevo más tarde.',
	shippingPickupChange: 'Cambiar de punto de recogida',
	shippingPickupChoose: 'Elegir un punto de recogida',
    shippingCountrySelect: 'País de envío',
    shippingDeleteConfirmMessage: '¿Seguro que quieres eliminar este método de envío?',
    shippingDeliveryEstimationDate1: 'Fecha de entrega estimada: {date}',
    shippingDeliveryEstimationDate2: 'Fecha de entrega estimada: entre el {date1} y el {date2}',
    shippingDeliveryEstimationText: 'Esto es solo una estimación de los gastos de envío. Podrás elegir tu punto de entrega exacto en el siguiente paso.',
    shippingSurchargeCorsica: 'Esta tarifa incluye un suplemento de {price} para Córcega.',
    shippingSurchargeOverseas: 'Esta tarifa incluye un suplemento de {price} para territorios de ultramar.',
    shippingSurchargeRemote: 'Esta tarifa incluye un suplemento de {price} para zonas de difícil acceso.',
    shippingDeliveryTime: 'Plazo de entrega (en días)',
    shippingDeliveryTimeInfo: 'Entrega en {days} días laborables',
    shippingDescription: 'Descripción',
    shippingExcludeDepartmentInfo: 'Separa los códigos postales a excluir con una coma (,). Puedes usar "*" como comodín.',
    shippingExcludeDepartmentLabel: 'Excluir códigos postales',
    shippingExtraFeeCalculation: 'Cálculo de los gastos de envío adicionales',
    shippingExtraFeeLabel: 'Etiqueta de gastos de envío adicionales',
    shippingExtraFees: 'Gastos adicionales',
    shippingFeeCalculatorTitle: 'Calcula tus gastos de envío',
    shippingFeeFreeDelivery: '¡Envío gratuito!',
    shippingFeeNotFoundError: '',
    shippingFeeWithBookResult: 'Haz tu pedido ahora y recibe tu eBook al instante, y tus libros impresos en {countryName} entre el {deliveryDateFrom} y el {deliveryDateTo}.',
    shippingFeeWithoutBookResult: 'Haz tu pedido ahora y recibe tu eBook al instante en tu email.',
    shippingFreeStep: 'Umbral para envío gratuito',
    shippingFreeTreshold: 'Importe para envío gratuito',
    shippingFreeInfo: 'Envío gratuito a partir de {value}',
    shippingIdentifier: 'Identificador de envío',
    shippingIsPriceTTC: '¿El precio del envío incluye el IVA?',
    shippingLabelGenerateButton: 'Generar la etiqueta',
    shippingLabelGenerateButton2: 'Volver a generar la etiqueta',
    packingCheckTitle: 'Los libros de este pedido',
    packingCheckHint: 'Enseña un libro cada vez, con el dorso hacia la cámara. Cuando el contador avance, déjalo fuera del encuadre y pasa al siguiente.',
    packingCheckProgress: '{seen} / {expected}',
    packingCheckForeign: 'Este libro es del pedido {code}. Sácalo del paquete.',
    packingCheckReady: 'Bien, son los libros de este pedido. Ya puedes imprimir la etiqueta.',
    packingCheckOverflow: 'Se han leído demasiados libros. Vuelve a empezar.',
    packingCheckRestart: 'Empezar de nuevo',
    packingCheckCameraStart: 'Abrir la cámara',
    packingCheckCameraDenied: 'La cámara está bloqueada. Autorízala, o escanea con el lector.',
    packingCheckLocked: 'Escanea todos los libros antes de imprimir la etiqueta.',
    packingCheckWedgeLabel: 'O escanea el QR con el lector',
    packingCheckLoading: 'Cargando los libros de este pedido.',
    prepBooksCardTitle: 'Libros',
    prepBooksCount: '{count, plural, one {# libro} other {# libros}}',
    prepBooksPageEyebrow: 'Preparación',
    prepBooksPageTitle: 'Pedido {code}',
    prepBooksPageHint: 'Los libros que van en este paquete.',
    prepModeClient: 'Vista del cliente',
    prepModePreparation: 'Vista de preparación',
    shippingLegacyChronopostPaused: 'Este pedido sigue en el Chronopost anterior. Cambia el método de envío a una oferta Sendcloud con Editar y luego genera la etiqueta.',
    shippingMethodCalculating: 'Calculando las opciones de envío...',
    shippingMethodConditions: 'Condiciones de envío',
    shippingMethodMissingAlert: 'No encontramos ningún transportista disponible para tu carrito. Por favor, modifica la dirección o elige otro transportista.',
    shippingMethodNotAvailable: 'No hay opciones de entrega disponibles para tu dirección...',
    shippingRatesError: 'El cálculo de los gastos de envío se ha interrumpido. Vuelve a intentarlo en un momento y, si se repite, escríbenos: lo revisamos contigo.',
    shippingMethodPricing: 'Tarifa',
    shippingMethodPricingSystem: 'Sistema de tarificación',
    shippingMethodSearch: 'Buscando opciones de envío...',
    shippingMethodSelectTitle: 'Selecciona tu método de envío',
    shippingGroupRelay: 'Punto de recogida',
    shippingGroupHome: 'A domicilio',
    shippingTierClassic: 'Entrega estándar',
    shippingTierExpress: 'Entrega express',
    shippingTierClassicDesc: 'Plazo estándar',
    shippingTierExpressDesc: 'La opción más rápida',
    shippingTierPriceRelayFree: 'Gratis en punto de recogida',
    shippingTierPriceRelayFrom: 'Desde {price} en punto de recogida',
    shippingTierPriceHomeFrom: '{price} a domicilio',
    shippingChangeTier: 'Cambiar velocidad de entrega',
    shippingTierModeTitle: 'Elige tu modo de entrega',
    shippingStepOf: 'Paso {current} de {total}',
    shippingStepSpeedTitle: '¿Cuándo quieres recibir tu pedido?',
    shippingStepModeTitle: '¿Dónde quieres recibir tu pedido?',
    shippingMethodTrackingInfo: 'Información de seguimiento',
    shippingMethods: 'Métodos de envío',
    shippingOrder: 'Orden de envío',
    shippingProvider: 'Proveedor logístico',
    shippingStep: 'Paso',
    shippingStepInfo: '¡Este paso DEBE ser el parámetro de la izquierda! El parámetro superior es el código postal por defecto.',
    shippingStepLimitInfo: '¿La condición de la izquierda es el mínimo/máximo?',
    shippingTaxRate: 'Tipo de IVA del envío',
    shippingTitle: 'Entrega',
    shippingTrackingNumber: 'Número de seguimiento',
    shippingTrackingParcelUrl: 'URL de seguimiento del paquete',
    status: 'Estado',
    stepTitle: 'Paso {step}',
    submit: 'Enviar',
    suborderitemAddProductTitle: 'Añadir un producto',
    switchLanguage: 'Cambiar de idioma',
    tableMassActions: 'Acciones en lote',
    tableRefreshSuccessAlert: '¡Sincronizado correctamente!',
    tableRefreshSuccessError: '¡Error de sincronización!',
    tableSelection: `{count} {count, plural,
			  =0 {seleccionado}
			  =1 {seleccionado}
			  other {seleccionados}
		  }`,
    tag: 'Etiqueta',
    tagFillPlaceholder: 'Introduce una palabra clave...',
    tags: 'Etiquetas',
    taskDescription: 'Descripción',
    taskEditTitle: 'Modificar la tarea',
    taskPriority: 'Prioridad',
    taxRate: 'IVA',
    the: 'el/la',
    time: 'Hora',
    timezone: 'Zona horaria',
    title: 'Título',
    toleranceLabel: 'Tolerancia',
    total: 'Total',
    type: 'Tipo',
    unit: 'Unidad',
    user: 'Usuario',
    userAccountCreditsTitle: 'Mi saldo de créditos',
    userAccountDataProtection: 'Protección de datos',
    userAccountDataProtectionText1: 'Nos tomamos muy en serio la protección de tus datos personales. Por eso nos comprometemos a mantenerlos seguros y solo los conservamos durante el tiempo estrictamente necesario para prestarte nuestro servicio.',
    userAccountDataProtectionText2: 'Solo te pedimos la información estrictamente necesaria. Jamás compartiremos tus datos con terceros ni los utilizaremos con fines comerciales sin tu consentimiento explícito.',
    userAccountDataProtectionText3: 'Si deseas descargar tus datos o ejercer tu derecho al olvido, por favor contáctanos en {email}.',
    userAccountDelete: 'Eliminar mi cuenta',
    userAccountDeleteActiveSuborder: '¡No puedes eliminar tu cuenta mientras tengas pedidos en curso!',
    userAccountDeleteBlockText: '¡No puedes eliminar tu cuenta en este momento!',
    userAccountDeleteButton: 'Eliminar mi cuenta definitivamente',
    userAccountDeleteConfirmMessage: '¿Seguro que quieres eliminar tu cuenta para siempre?',
    userAccountDeleteConfirmTitle: 'Eliminar mi cuenta',
    userAccountDeleteError: '¡No hemos podido eliminar tu cuenta!',
    userAccountDeleteSuccess: '¡Tu cuenta ha sido eliminada! ¡Esperamos volver a verte pronto!',
    userAccountDeleteText: 'Al eliminar tu cuenta, perderás el acceso a todo tu historial y a tus libros guardados. Borraremos todos tus datos personales de nuestros servidores de forma segura. ¡Esta acción es irreversible!',
    userAccountEdit: 'Modificar mis datos',
    userAccountEditSuccess: 'Perfil actualizado correctamente',
    userAccountExistError: '¡No existe ninguna cuenta asociada a este correo electrónico!',
    userAccountExistTitle: '¿Ya tienes una cuenta con nosotros?',
    userAccountGeneral: 'General',
    userAccountHistory: 'Historial',
    userAccountInfo: 'Tus datos están protegidos y permanecerán estrictamente confidenciales.',
    userAccountInfoMyTitle: 'Mis datos personales',
    userAccountMy: 'Mi cuenta',
    userAccountPersonnalInformation: 'Mi información personal',
    userAccountPreferencesInformation: 'Mis preferencias',
    userAccountResetError: '¡Error al intentar restablecer la cuenta!',
    userAccountResetSuccess: '¡Cuenta restablecida con éxito!',
    userActivityOnLine: 'En línea',
    userAdd: 'Añadir un usuario',
    userAddNew: 'Añadir un nuevo usuario',
    userBridgeError: 'No se ha podido iniciar sesión desde la aplicación. Inténtalo de nuevo.',
    userBridgeInvalid: 'Este enlace de conexión ya no es válido. Vuelve a iniciar la conexión desde la aplicación.',
    userBridgePending: 'Iniciando sesión…',
    userBridgeSuccess: '¡Has iniciado sesión! Ya puedes volver a la aplicación.',
    userChangePasswordSuccess: '¡Contraseña actualizada!',
    userConfirmationCode: 'Código de confirmación recibido por email',
    userConfirmationCodeCheckButton: 'Ya tengo el código para restablecer mi contraseña',
    userConfirmationCodeError: '¡Por favor, introduce el código de confirmación que te hemos enviado al email!',
    userConnectionInfo: '¡Inicia sesión para confirmar tu pedido y guardar tu libro!',
    userCredits: 'Créditos',
        userCreditsBalancePositive: 'Tienes {amount} de crédito disponible: se aplicará automáticamente en el siguiente paso.',
    userCreditsPrepaymentInviteTitle: 'Pago anticipado de tu libro',
    userDeleteConfirmTitle: 'Eliminar el usuario',
    userDeleteConfirmMessage: '¿Seguro que quieres eliminar este usuario?',
    userDeleteConfirmation: '¡El usuario {user} ha sido eliminado!',
    userEdit: 'Modificar a {user}',
    userEdit2: 'Modificar el usuario',
    userEditPassword: 'Cambiar mi contraseña',
    userEmail: 'Correo electrónico',
    userEmailError: '¡La dirección de correo electrónico no es válida!',
    userEmailFillInfo: 'Introduce tu email',
    userEmailFormInfo: 'Escribe tu email para continuar',
    userEmailFormInfo2: 'Utilizaremos tu email para crear tu cuenta de forma segura y enviarte el seguimiento de tu pedido.',
    userLoginCodeTitle: 'Ya tienes una cuenta',
    userLoginCodeIntro: 'Te acabamos de enviar un código de 6 cifras a {email}. Introdúcelo aquí para continuar.',
    userLoginCodeLabel: 'Código recibido por email',
    userLoginCodeSubmit: 'Validar',
    userLoginCodeInvalid: 'Este código no coincide. Revisa el último email que has recibido.',
    userLoginCodeExpired: 'Este código ya no es válido. Pide uno nuevo justo debajo.',
    userLoginCodeError: 'Vaya, algo ha fallado. Inténtalo de nuevo en un momento.',
    userLoginCodeLinkHint: 'El mismo email también incluye un enlace de acceso.',
    userLoginCodeResend: 'Enviar un código nuevo',
    userLoginCodeResendIn: 'Enviar un código nuevo en {seconds} s',
    userLoginCodeResent: 'Enviado de nuevo. Echa un vistazo a la carpeta de spam.',
    userLoginCodeChangeEmail: 'Usar otro email',
    userLoginCodeCartSuccess: 'Ya has iniciado sesión. Puedes finalizar tu pedido.',
    userEnvironmentTestNoTest: '¡Este usuario no ha realizado ninguna prueba de entorno!',
    userFillPlaceholder: 'Introduce el nombre de un usuario...',
    userFirstName: 'Nombre',
    userForgotPassword: '¿Has olvidado tu contraseña?',
    userForgotPasswordRetryDateError: 'Aún no puedes solicitar un nuevo código. Por favor, revisa tu bandeja de entrada (y la carpeta de spam) para encontrarlo.',
    userFormInfo: 'Completa tu perfil',
    userGenderLabel: 'Género',
    userIsActive: '¿Activo?',
    userLastName: 'Apellidos',
    userLogin: 'Iniciar sesión',
    userLoginAction: 'Entrar',
    userLoginEmailSelected: 'Iniciando sesión con el email: {email}',
    userLoginError: '¡Datos incorrectos! Por favor, inténtalo de nuevo...',
    userLoginFirstButton: '¿Es tu primera vez aquí?',
    userLoginFirstText: 'Revisa tu bandeja de entrada: te hemos enviado una contraseña temporal. Utilízala para tu primer inicio de sesión. Podrás cambiarla fácilmente desde tu perfil.',
    userLoginBenefit1: 'Tu libro de fotos SMS en pocos clics',
    userLoginBenefit2: 'Entrega rápida a domicilio',
    userLoginBenefit3: 'Pago 100% seguro',
    userLoginIntro: 'Por favor, identifícate para acceder a tus libros y a tu espacio personal.',
    userLoginWelcomeSubtitle: 'Transforma tus SMS en un hermoso libro de fotos impreso.',
    userLoginWelcomeTitle: '¡Bienvenido!',
    userLoginNoConnexion: 'Sin conexión',
    userLoginTitle: 'Iniciar sesión',
    userLogout: 'Cerrar sesión',
    userName: 'Nombre',
    userNewPassword: 'Nueva contraseña',
    userNewsletterSubscribeButton: 'Suscribirme a la newsletter',
    userNewsletterText1: 'Recibe ideas de regalo, descuentos exclusivos y nuestras últimas novedades directamente en tu email.',
    userOldPassword: 'Tu contraseña actual',
    userOptions: 'Opciones de usuario',
    userPassword: 'Contraseña',
    userPasswordConfirmation: 'Confirma tu contraseña',
    userPasswordConfirmationError: '¡Las contraseñas no coinciden! Vuelve a intentarlo.',
    userPasswordConfirmationRestriction: 'Ambas contraseñas deben ser exactamente iguales.',
    userPasswordEdit: 'Modificar mi contraseña',
    userPasswordSet: 'Definir una contraseña',
    userPasswordSetSuccess: 'Contraseña guardada.',
    userSocialConnectionsTitle: 'Conexiones',
    userSocialContinueApple: 'Continuar con Apple',
    userSocialContinueGoogle: 'Continuar con Google',
    userSocialDivider: 'o',
    userSocialError: 'No se ha podido iniciar sesión. Inténtalo de nuevo.',
    userSocialErrorNoEmail: 'Tu cuenta de Apple no ha proporcionado un correo. Usa otro método de conexión.',
    userSocialErrorUnavailable: 'Esta conexión aún no está disponible.',
    userSocialLinkApple: 'Vincular Apple',
    userSocialLinkGoogle: 'Vincular Google',
    userSocialLinkSuccess: 'Cuenta vinculada.',
    userSocialLinked: 'Vinculado',
    userSocialUnlinkApple: 'Desvincular Apple',
    userSocialUnlinkConfirm: '¿Desvincular esta conexión de tu cuenta?',
    userSocialUnlinkGoogle: 'Desvincular Google',
    userSocialUnlinkLastError: 'Añade una contraseña antes de desvincular tu última conexión.',
    userSocialUnlinkSuccess: 'Cuenta desvinculada.',
    userPasswordError: '¡Por favor, introduce una contraseña correcta!',
    userPasswordResetText: 'Introduce tu nueva contraseña. Confírmala y haz clic en el botón de abajo para guardarla.',
    userPasswordRestriction: '¡Tu contraseña debe tener al menos 6 caracteres y contener 1 número y 1 carácter especial (@&!()$*€%) por seguridad!',
    userPasswordRestrictionAlt: '¡Tu contraseña debe tener al menos 6 caracteres!',
    userPasswordTemporaryCheckButton: 'Ya he recibido mi contraseña temporal',
    userPhone: 'Teléfono móvil',
    userPhoneError: '¡El número de teléfono no es válido!',
    userProfileMy: 'Mi perfil',
    userReInitPassword: 'Restablecer mi contraseña',
    userRecoverFromOldAppCheckButton: 'He recibido el email para recuperar mi contraseña',
    userRecoverFromOldAppText: '¡Acabamos de migrar tu cuenta a nuestra nueva plataforma! Revisa tu email para recuperar tu contraseña y activar tu nuevo espacio personal.',
    userRegister: 'Crear mi cuenta',
    userRegisterError: '¡No hemos podido crear tu cuenta! Por favor, revisa tu email e inténtalo de nuevo...',
    userRegisterSuccess: '¡Enhorabuena! Hemos creado tu cuenta de forma segura. ¡Acabas de recibir un email con tu contraseña temporal!',
    userRegisterSuccessEmailNotice: 'Acabamos de enviarte un email de confirmación a {email}.',
    userRegisterSuccessEyebrow: 'Bienvenido',
    userRegisterSuccessPageTitle: '¡Bienvenido!',
    userRegisterSuccessSourcesHint: 'Elige la aplicación donde están tus mensajes.',
    userRegisterSuccessSourcesTitle: '¿Por dónde empezamos?',
    userRegisterSuccessStep1Desc: 'Allí encontrarás el resumen de tu registro.',
    userRegisterSuccessStep1Title: 'Revisa tu bandeja de entrada',
    userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS o Android: elige tu fuente.',
    userRegisterSuccessStep2Title: 'Importa tus mensajes',
    userRegisterSuccessStep3Desc: 'Portada, colores, fotos: personaliza cada detalle.',
    userRegisterSuccessStep3Title: 'Crea tu libro',
    userRegisterSuccessStepsEyebrow: 'Tu recorrido',
    userRegisterSuccessText: 'Tu cuenta está lista. En unos pocos pasos, transforma tus mensajes en un libro para atesorar.',
    userRegisterSuccessTitle: 'Tu historia empieza aquí',
    userRegisterSuccessTitleNamed: '¡Bienvenido, {firstName}!',
    userResetPasswordAccountButton: 'Restablecer la contraseña de la cuenta',
    userResetPasswordAskSuccess: '¡Revisa tu bandeja de entrada! Te hemos enviado un enlace para crear tu nueva contraseña.',
    userResetPasswordButton: 'Restablecer mi contraseña',
    userResetPasswordError: '¡No hemos podido restablecer tu contraseña! Por favor, inténtalo más tarde...',
    userResetPasswordInfo: 'Vas a recibir un enlace seguro en tu email para restablecer tu contraseña.',
    userResetPasswordInfo2: 'Crea tu nueva contraseña rellenando los campos de abajo:',
    userResetPasswordSuccess: '¡Tu contraseña ha sido actualizada con éxito!',
    userRole: 'Rol',
    userRoleAdmin: 'Administrador',
    userRoleCustomer: 'Cliente',
    userSearchLabel: 'Escribe un email o el nombre de un usuario',
    userSendNewAccountEmail: 'Enviar email de "Nueva cuenta" a este usuario',
    userSendNewAccountEmailSuccess: '¡Se ha notificado al usuario!',
    userSwitch: 'Cambiar de usuario',
    userValidForgotPasswordError: '¡No hemos podido enviarte el código de recuperación!',
    userValidForgotPasswordSuccess: '¡Revisa tu email! Utiliza el código de confirmación que te hemos enviado para crear tu nueva contraseña.',
    users: 'Usuarios',
    usersList: 'Lista de usuarios',
    valid: 'Validar',
    view: 'Ver',
    voucher: 'Cupón de descuento',
    voucherApplyButton: 'Aplicar descuento',
    voucherApplyComplete: '¡No puedes acumular más cupones de descuento en este pedido!',
    voucherApplyFormLabel: 'Código promocional',
    voucherApplyValidError: '¡Vaya! Este cupón no es válido para tu pedido actual.',
    voucherCode: 'Código',
    voucherCodePlaceholder: 'Escribe aquí tu código promocional',
    voucherDeleteConfirmMessage: '¿Seguro que quieres eliminar este vale?',
    voucherEdit: 'Modificar el cupón',
    voucherIsAuto: '¿Automático?',
    voucherIsCumulative: '¿Es acumulable?',
    voucherIsPublic: '¿Es público?',
    voucherNotExistsError: '¡Este código de descuento no existe o ha caducado!',
    voucherPriority: 'Prioridad',
    voucherProductOffer: 'Ofrecidos',
    voucherRemoveAllButton: 'Eliminar todos los descuentos',
    vouchers: 'Cupones de descuento',
    weight: 'Peso',
    yes: 'Sí',
    you: 'Tú',
    yourself: 'Tú',
    userNewsletterTitle: 'Newsletter',
    userNewsletterSubscribeText: 'Te enviaremos nuestras novedades, promociones exclusivas y nuestros libros favoritos.',
    userNewsletterUnSubscribeButton: 'Darme de baja de la newsletter',
    'userOrdersView': 'Ver los pedidos de este usuario',
    'userCanCustomizeMessages': '¿Puede personalizar los mensajes?',
    'userLogAsUser': 'Iniciar sesión como este usuario',
    'shippingMethodProviderData': 'Información de la empresa de transporte',
    'productUseForCustomization': '¿Utilizar para la personalización?',
    'conversationBookFormat': 'Formato del libro',
    'conversationMessageSelect': 'Seleccionar este mensaje',
    'conversationMessagesEditTitle': 'El taller: Personaliza tus mensajes',
    'conversationMessageSelectorDateFrom': 'Seleccionar los mensajes enviados después de',
    'conversationMessageSelectorDateTo': 'Seleccionar los mensajes enviados antes de',
    'conversationTextSearch': 'Buscar una palabra en el chat',
    'conversationOnlyMedias': 'Mostrar únicamente las fotos/vídeos',
    'conversationMessagesSelectVisible': 'Seleccionar esta página',
    'conversationMessagesSelectAllFiltered': 'Seleccionar todo ({count, number})',
    'unselect': 'Deseleccionar',
    'conversationMessagesEditHideSelected': 'Ocultar los mensajes seleccionados del libro',
    'conversationMessagesEditShowSelected': 'Volver a mostrar los mensajes seleccionados',
    'conversationMessagesEditTooManySelected': '¡Has seleccionado demasiados mensajes a la vez!',
    'conversationNoMessages': 'Ningún mensaje',
    'conversationMessageEdit': 'Editar el texto del mensaje',
    'conversationMessageAdd': 'Añadir un mensaje',
    'conversationMessageInsert': 'Insertar un mensaje aquí',
    'conversationMessageEditSelect': 'Seleccionar este mensaje',
    'conversationMessageEditUnselect': 'Deseleccionar este mensaje',
    'conversationMessageSetUnVisibleButton': 'Ocultar este mensaje del libro impreso',
    'conversationMessageHiddenAlert': 'Este mensaje ha sido ocultado y no aparecerá en tu libro impreso.',
    'conversationMessageSetVisibleButton': 'Volver a mostrar el mensaje',
    'conversationMessagesEditEnableButton': 'Activar la personalización de mensajes',
    'conversationMessagesEditEnableButton2': 'Desbloquear la personalización por {price}',
    'conversationMessagesEditDisableAlert': 'Para poder modificar, ocultar o editar el contenido exacto de tus mensajes, necesitas activar esta opción premium (pago único).',
    'conversationMessageDateHint': 'Cambia la fecha y la hora para colocar este mensaje donde quieras en la conversación.',
    'conversationMessageSender': 'Remitente',
    'conversationMessageSenderPlaceholder': 'Elegir remitente',
    'conversationMessageSenderRequiredHint': 'Elige quién envía este mensaje para poder guardarlo.',
    'conversationMessageAnnotation': 'Anotación',
    'conversationMessageAnnotationNoMedia': 'Una anotación no puede incluir foto, vídeo ni audio.',
    'conversationMessageText': 'Texto',
    'conversationMessageTextPlaceholder': 'Escribe tu texto',
    'conversationMessageAttachments': 'Archivos adjuntos (Fotos/Vídeos)',
    'conversationMessageMediaLabel': 'Foto, vídeo o audio',
    'conversationMessageMediaDragDrop': 'Arrastra aquí una foto, un vídeo o un audio',
    'conversationMessageMediaTapSelect': 'Toca para elegir una foto, un vídeo o un audio',
    'conversationMessageMediaOpenFinder': 'Elegir un archivo',
    'conversationMessageMediaPickSenderFirst': 'Elige primero un remitente para añadir una foto, un vídeo o un audio.',
    'conversationMessageHiddenLabel': '¿Ocultar este mensaje del libro?',
    'conversationGenerate': 'Generar las maquetas de los libros',
    'conversationVerify': 'Forzar la verificación',
    'conversationLaunchButton': 'Enviar a imprenta',
    'conversationViewButton': 'Ver mi chat',
    'reset': 'Restablecer',
    'cms': 'CMS',
    'cmsLinkColor': 'Color del botón',
    'cmsLinkNeedObfuscate': '¿Necesita ofuscación?',
    'cmsImageUseForMobile': '¿Utilizado para la versión móvil?',
    'contentEditPage': 'Editar la página',
    'cmsRedirectionAdd': 'Añadir una redirección',
    'cmsContentEdit': 'Modificar el contenido',
    'cmsPageIsActive': '¿Página activa?',
    'cmsContentTypeLabel': 'Tipo de contenido',
    'cmsContentModelLabel': 'Modelo de diseño',
    'cmsContentTitle': 'Título de la página',
    'cmsContentSlug': 'Slug (URL)',
    'cmsPanelIsTemplate': '¿Incluido en la plantilla global?',
    'cmsPageSeoTitle': 'Título SEO (Google)',
    'cmsPageSeoDescription': 'Meta Descripción SEO',
    'cmsPageSeoKeywords': 'Palabras clave SEO',
    'cmsPageSeoHideOnSitemap': 'Ocultar de los motores de búsqueda (Sitemap)',
    'cmsPageSeoUseCustomTitleSuffix': 'Utilizar un sufijo de título personalizado',
    'cmsPageSeoTitleSuffix': 'Sufijo del título',
    'affiliation': 'Programa de afiliados',
    'affiliationInvoiceTotalAdminTitle': 'Total a pagar (IVA incl.)',

    conversationImportLuxEyebrow: 'Tu historia',
    conversationImportLuxTagline: 'Un regalo único, pensado por ti: que nadie más podrá ofrecer.',
    conversationImportLuxPrivacy: 'Tus mensajes son confidenciales: solo se usa la conversación que elijas.',
    conversationImportProgressExport: 'Exportar',
    conversationImportProgressUpload: 'Subir',
    conversationImportProgressCustomize: 'Personalizar',
    conversationImportUploadSuccess: 'Archivo recibido: elige tu conversación en el siguiente paso',
    conversationImportUploadSuccessSingle: 'Archivo recibido: continúa para personalizar tu libro',
    conversationImportContinueSingle: 'Continuar',
    conversationImportSelectionTitleSingle: 'Tu conversación',
    conversationImportSelectionHintSingle: 'Una sola conversación encontrada en tu archivo.',
    conversationImportSelectionHintMultiple: 'Elige la conversación para tu libro: usa la búsqueda para filtrar la lista.',
    conversationImportSelectionListCount: '{shown} de {total} conversaciones',
    conversationImportSelectionNoMatch: 'Ninguna conversación coincide con tu búsqueda.',
    conversationImportStepPickThread: 'Elegir conversación',
    conversationImportStepMedia: 'Opciones de fotos',
    conversationImportStepTerms: 'Aceptar condiciones',
    conversationImportExtrasLockedHint: 'Elige una conversación arriba para desbloquear estas opciones.',
    conversationImportPickThreadBeforeTerms: 'Aún debes elegir una conversación arriba antes de continuar.',
    conversationImportChangeThread: 'Cambiar conversación',
    conversationImportSelectionConfirmedHint: 'Perfecto: ya puedes personalizar tu libro abajo.',

    conversationImportOptionsTitle: 'Fotos y recuerdos',
    conversationImportOptionsHint: 'Todo está marcado por defecto: desmarca solo lo que no quieras incluir.',
    conversationImportOptionsImagesLabel: 'Fotos e imágenes',
    conversationImportOptionsImagesDesc: 'Las fotos de tu conversación se imprimirán en el libro.',
    conversationImportOptionsMediasLabel: 'Vídeos, audio y GIFs',
    conversationImportOptionsMediasDesc: 'Accesibles mediante códigos QR impresos en el libro (almacenamiento de 10 años incluido).',
    conversationImportOptionsTransferNote: 'La transferencia puede tardar unos minutos según el número de fotos: permanece en esta página.',
    conversationImportOptionsNoMedia: 'Tu archivo no contiene fotos ni medios: tu libro incluirá solo los mensajes.',
    conversationImportAgreementRead: 'Consulta las condiciones generales de venta',
    conversationImportCreateBook: 'Crear mi libro',
    conversationImportSelectToContinue: 'Selecciona una conversación para continuar.',
    conversationImportAcceptTermsToContinue: 'Marca la casilla de condiciones generales para continuar.',
    conversationImportTransferEyebrow: 'Casi listo',
    conversationImportTransferTitle: 'Estamos preparando tu libro',
    conversationImportTransferSubtitle: 'Un momento: tu historia está tomando forma.',
    conversationImportTransferStay: 'Permanece en esta página hasta que termine la transferencia.',
    conversationImportStepMedias: 'Transferencia de vídeos y audio',
    conversationImportTransferStatMessages: 'Mensajes',
    conversationImportTransferStatPhotos: 'Fotos',
    conversationImportTransferStatMedias: 'Vídeos y audio',
    conversationImportTransferEyebrow: 'Casi listo',
    conversationImportTransferTitle: 'Estamos preparando tu libro',
    conversationImportTransferSubtitle: 'Un momento: tu historia está tomando forma.',
    conversationImportTransferStay: 'Permanece en esta página hasta que termine la transferencia.',
    conversationImportResumeTitle: 'Una transferencia anterior se interrumpió.',
    conversationImportResumeTextFile: 'Vuelve a seleccionar el mismo archivo ({name}) para reanudar donde se detuvo.',
    conversationImportResumeText: 'Vuelve a seleccionar el mismo archivo para reanudar donde se detuvo.',
    conversationImportResumeButton: 'Reanudar la transferencia',
    conversationImportResumeDiscard: 'Empezar de nuevo',
    conversationImportDuplicateTitle: 'Esta conversación ya está en tu cuenta',
    conversationImportDuplicateEyebrow: 'Conversación idéntica',
    conversationImportDuplicateLead: 'Hemos encontrado una conversación idéntica. Puedes abrir la existente para evitar un traslado duplicado.',
    conversationImportDuplicateQuestion: '¿Qué quieres hacer?',
    conversationImportDuplicateUseExisting: 'Usar la conversación existente',
    conversationImportDuplicateImportAnyway: 'Importar de nuevo',
    conversationImportDropHint: 'Deposita tu archivo .zip aquí, o',
    conversationImportDropFormats: '.zip completo recomendado: no lo abras (fotos y medios incluidos)',
    conversationImportJsonOnlyHint: 'Solo archivo .json: las fotos y medios no se incluirán. Para un libro ilustrado, sube el .zip completo sin abrirlo. Si tu navegador ya extrajo el archivo, comprime la carpeta « messages » en .zip.',

    conversationInstagramImportIntro: 'Exporta tus mensajes de Instagram en 3 pasos:',
    conversationInstagramImportDemoTitle: 'Exporta tus mensajes de Instagram',
    conversationInstagramImportDemoExportMeta: 'Exportar a dispositivo · JSON',
    conversationInstagramImportDemoDownloadsAvailable: 'Descargas disponibles',
    conversationInstagramImportDemoStartExport: 'Iniciar exportación',
    conversationInstagramImportDemoCustomizeMessages: 'Solo mensajes',
    conversationInstagramImportDemoCustomize: 'Personalizar información',
    conversationInstagramImportDemoConfirmTitle: 'Confirmar tu exportación',
    conversationInstagramImportDemoSave: 'Guardar',
    conversationInstagramImportDemoMessagesTip: 'Opcional pero más rápido: borrar todo, luego solo Mensajes.',
    conversationInstagramImportDemoDataPayments: 'Pagos',
    conversationInstagramImportDemoDataComments: 'Comentarios',
    conversationInstagramImportDemoClearAll: 'Borrar todo',
    conversationInstagramImportDemoActivitySection: 'Tu actividad en Instagram',
    conversationInstagramImportDemoPickSpecific: 'Elige información específica para exportar',
    conversationInstagramImportDemoExportExternal: 'Exportar a un servicio externo',
    conversationInstagramImportDemoExportDevice: 'Exportar a mi dispositivo',
    conversationInstagramImportDemoChooseDestination: 'Elige dónde exportar',
    conversationInstagramImportDemoProfileAccount: 'Tu cuenta · Instagram',
    conversationInstagramImportDemoProfileName: 'El nombre de tu cuenta',
    conversationInstagramImportDemoAccountShort: 'Tu cuenta',
    conversationInstagramImportDemoProfiles: 'Perfiles',
    conversationInstagramImportDemoChooseProfile: 'Elige un perfil',
    conversationInstagramImportDemoPastActivity: 'Actividad pasada',
    conversationInstagramImportDemoCurrentActivity: 'Actividad en curso',
    conversationInstagramImportDemoCreateExport: 'Crear exportación',
    conversationInstagramImportDemoExportIntro: 'Crea una copia de tu información para descargarla en tu dispositivo.',
    conversationInstagramImportDemoExportTitle: 'Exportar tu información',
    conversationInstagramImportDemoCaptionStart: 'Pulsa Iniciar exportación',
    conversationInstagramImportDemoCaptionDevice: 'Pulsa Exportar a mi dispositivo',
    conversationInstagramImportDemoCaptionProfile: 'Elige tu perfil de Instagram',
    conversationInstagramImportDemoCaptionCreate: 'Pulsa Crear exportación',
    conversationInstagramImportDemoCaptionMessages: 'Consejo: Borrar todo, luego solo Mensajes (más rápido)',
    conversationInstagramImportDemoCaptionJson: 'Elige formato JSON, luego Guardar',
    conversationInstagramImportDemoCaptionDrop: 'Descarga el .zip cuando esté listo y súbelo aquí abajo',
    conversationInstagramImportDemoPlatform: 'Instagram',
    conversationInstagramImportDemoDataMessages: 'Mensajes',
    conversationInstagramImportDemoFormat: 'Formato',
    conversationInstagramImportDemoMediaQuality: 'Calidad multimedia',
    conversationInstagramImportDemoQualityLow: 'Baja',
    conversationInstagramImportDemoJsonNotice: 'JSON obligatorio para tu libro. HTML no funcionará.',
    conversationInstagramImportDemoReadyHint: 'Sube el .zip completo abajo sin abrirlo. Elegirás la conversación después.',
    conversationInstagramImportCta: 'Abrir los ajustes de Instagram',
    conversationInstagramImportStep1: 'Pulsa <b>Crear exportación</b>, elige tu perfil de <b>Instagram</b>, luego <b>Exportar a mi dispositivo</b>.',
    conversationInstagramImportStep2: 'Consejo para ir más rápido: <b>Borrar todo</b>, marca solo <b>Mensajes</b>. Elige formato <b>JSON</b> y calidad <b>Baja</b>.',
    conversationInstagramImportStep3: 'Pulsa <b>Iniciar exportación</b>, espera el email (10 min a 24 h), descarga el <b>.zip</b> y súbelo aquí abajo <b>sin abrirlo</b>: elegirás la conversación <b>después</b>.',
    conversationInstagramImportAlert: 'Formato <b>JSON</b> obligatorio (no HTML). Consejo: exportar solo <b>Mensajes</b> es más rápido, pero no es obligatorio.',
    conversationInstagramImportDetailTitle: 'Exportación de Instagram: guía detallada',
    conversationInstagramImportDetailIntro: 'Sigue cada paso con las capturas de abajo. El botón de arriba abre directamente la página de exportación.',
    conversationInstagramImportDetailSkipApp: 'Ya abrí la página con el botón: pasar al paso 5',
    conversationInstagramImportDetailStep1: 'Abre la aplicación de <b>Instagram</b> y accede a <b>Ajustes</b> mediante los tres puntos arriba a la derecha.',
    conversationInstagramImportDetailStep2: 'Selecciona <b>Centro de cuentas</b>.',
    conversationInstagramImportDetailStep3: 'Pulsa en <b>Tu información y permisos</b>.',
    conversationInstagramImportDetailStep4: 'Elige <b>Exportar tu información</b>.',
    conversationInstagramImportDetailStep5: 'Ve a <b>Descargar o transferir información</b>. Si usaste el botón de arriba, ya estás en esta página.',
    conversationInstagramImportDetailStep6: 'Selecciona <b>Instagram</b>. Este paso puede no aparecer en algunas cuentas.',
    conversationInstagramImportDetailStep7: 'Elige <b>Parte de tu información</b>.',
    conversationInstagramImportDetailStep8: 'Desplázate hasta <b>Mensajes</b>, márcalo y pulsa <b>Siguiente</b>.',
    conversationInstagramImportDetailStep9: 'Pulsa <b>Descargar en el dispositivo</b>.',
    conversationInstagramImportDetailStep10: 'Elige el periodo deseado, el formato <b>JSON</b> y una calidad multimedia <b>baja</b> para una descarga más rápida.',
    conversationInstagramImportDetailStep11: 'Tu archivo estará listo en <b>10 minutos a 24 horas</b>. Recibirás un correo cuando esté disponible: también puedes encontrarlo en el Centro de cuentas.',
    conversationInstagramImportDetailStep12: 'Descarga el archivo <b>.zip</b> completo en tu dispositivo y súbelo aquí abajo <b>sin abrirlo</b>. Solo se usará la conversación que elijas después para tu libro.',

    conversationKakaotalkImportIntro: 'Empieza en el teléfono. ¿Estás en iPhone o Android?',
    conversationKakaotalkImportPlatformIphone: 'iPhone',
    conversationKakaotalkImportPlatformAndroid: 'Android',
    conversationKakaotalkImportIphoneStep1: 'En tu iPhone, abre <b>KakaoTalk</b> y la conversación que quieres en tu libro.',
    conversationKakaotalkImportIphoneStep2: 'Pulsa el <b>menú</b> (☰) arriba a la derecha y luego el icono de <b>ajustes</b> al final del panel.',
    conversationKakaotalkImportIphoneStep3: 'Pulsa <b>Exportar la conversación</b> y elige <b>Enviar solo los mensajes de texto</b>.',
    conversationKakaotalkImportIphoneStep4: 'Guarda el archivo <b>.txt</b> (Archivos, email, AirDrop) y suéltalo abajo <b>sin editarlo</b>.',
    conversationKakaotalkImportAndroidStep1: 'En tu teléfono, abre <b>KakaoTalk</b> y la conversación que quieres en tu libro.',
    conversationKakaotalkImportAndroidStep2: 'Pulsa el <b>menú</b> (☰) arriba a la derecha y luego el icono de <b>ajustes</b> al final del panel.',
    conversationKakaotalkImportAndroidStep3: 'Pulsa <b>Exportar la conversación</b> y elige <b>Enviar solo el texto</b>.',
    conversationKakaotalkImportAndroidStep4: 'Guarda el archivo <b>.txt</b> (Archivos, Google Drive, email) y suéltalo abajo <b>sin editarlo</b>.',
    conversationKakaotalkImportAlert: 'Una conversación por exportación. La otra opción también copia tus fotos, pero KakaoTalk no las vincula a los mensajes: elige solo el texto, las fotos aparecerán como una simple palabra.',
    conversationKakaotalkImportDesktopNote: 'En el ordenador (Windows o Mac): abre el menú de la conversación y pulsa <b>Guardar la conversación</b>. El archivo <b>.txt</b> que obtienes también funciona aquí.',
    conversationLineImportIntro: 'Empieza en el teléfono. ¿Estás en iPhone o Android?',
    conversationLineImportPlatformIphone: 'iPhone',
    conversationLineImportPlatformAndroid: 'Android',
    conversationLineImportIphoneStep1: 'En tu iPhone, abre <b>LINE</b> y la conversación que quieres en tu libro.',
    conversationLineImportIphoneStep2: 'Arriba del chat, pulsa el <b>menú</b> (☰) → <b>Ajustes</b>.',
    conversationLineImportIphoneStep3: 'Pulsa <b>Exportar historial del chat</b> y elige cómo enviar el archivo (Archivos, email, AirDrop).',
    conversationLineImportIphoneStep4: 'Guarda el archivo <b>.txt</b> y suéltalo abajo <b>sin editarlo</b>.',
    conversationLineImportAndroidStep1: 'En tu teléfono, abre <b>LINE</b> y la conversación que quieres en tu libro.',
    conversationLineImportAndroidStep2: 'Arriba del chat, pulsa el <b>menú</b> (☰) → <b>Ajustes</b>.',
    conversationLineImportAndroidStep3: 'Pulsa <b>Exportar historial del chat</b> y elige cómo enviar el archivo (Archivos, Google Drive, email).',
    conversationLineImportAndroidStep4: 'Guarda el archivo <b>.txt</b> y suéltalo abajo <b>sin editarlo</b>.',
    conversationLineImportAlert: 'Una conversación por exportación. Solo se guardan los mensajes visibles en el chat, y LINE no exporta fotos ni stickers como imágenes.',
    conversationLineImportDesktopNote: 'En el ordenador (Windows o Mac): abre <b>Chats</b>, haz doble clic en la conversación y usa el <b>menú</b> de arriba → <b>Guardar chat</b>. Esta exportación no existe en LINE para Chrome.',

    conversationLinkedinImportIntro: '3 pasos para exportar tus conversaciones de LinkedIn:',
    conversationLinkedinImportCta: 'Abrir la página de exportación de LinkedIn',
    conversationLinkedinImportStep1: 'Desde un <b>navegador web</b> (ordenador o móvil), abre la página de arriba. Si no: <b>Tú</b> → <b>Preferencias y privacidad</b> → <b>Privacidad de los datos</b> → <b>Obtener una copia de tus datos</b>.',
    conversationLinkedinImportStep2: 'Pide un archivo que incluya tus <b>Mensajes</b>: marca el archivo <b>Mensajes</b>, o elige el archivo completo, y pulsa <b>Solicitar archivo</b>.',
    conversationLinkedinImportStep3: 'Descarga el <b>.zip</b> desde el correo de LinkedIn (de 10 min a 24 h) y suéltalo abajo <b>sin abrirlo</b>: elegirás la conversación <b>después</b> de subirlo.',
    conversationLinkedinImportAlert: 'Esta exportación no existe en la app móvil de LinkedIn: usa un navegador. El archivo debe contener el fichero <b>messages.csv</b> (LinkedIn no exporta fotos ni archivos adjuntos).',

    conversationSnapchatImportIntro: '3 pasos para exportar tus conversaciones de Snapchat:',
    conversationSnapchatImportCta: 'Abrir Mis Datos de Snapchat',
    conversationSnapchatImportStep1: 'En la app: avatar → ajustes (engranaje) → <b>Privacidad</b> → <b>Mis Datos</b>. También puedes usar el enlace de arriba.',
    conversationSnapchatImportStep2: 'Inicia sesión si te lo piden, luego pulsa <b>Enviar una solicitud</b> al final: Snapchat te enviará un email cuando la archivo esté lista (unas horas a 1 día).',
    conversationSnapchatImportStep3: 'Descarga el <b>.zip</b> del email, luego súbelo aquí abajo <b>sin abrirlo</b>: elegirás la conversación <b>después</b> de subirlo.',
    conversationSnapchatImportAlert: 'Archivo <b>.zip</b> completo obligatorio: no lo abras. Tus mensajes se imprimirán en el libro (la exportación de Snapchat no incluye fotos imprimibles).',
    conversationSnapchatPlaceholderMedia: '[Media]',
    conversationSnapchatPlaceholderNote: '[Nota de voz]',
    conversationSnapchatPlaceholderSticker: '[Sticker]',
    conversationSnapchatPlaceholderSnap: '[Snap]',
    conversationSnapchatPlaceholderAudio: '[Audio]',
    conversationSnapchatStatusParticipantAdded: 'Se ha añadido un miembro al grupo',
    conversationSnapchatStatusNameChanged: 'El nombre del grupo ha cambiado',
    conversationSnapchatStatusConversationCreated: 'Conversación creada',
    conversationSnapchatStatusGeneric: 'Notificación de Snapchat',
    conversationSnapchatImportPartialContent: '{withText} mensajes con texto de {total}. Snapchat no exporta el contenido de los mensajes no guardados.',
    conversationSnapchatImportDetailTitle: 'Exportación de Snapchat: guía detallada',
    conversationSnapchatImportDetailIntro: 'Sigue cada paso con las capturas de abajo. También puedes usar el botón de arriba para abrir Mis Datos directamente e ir al paso 4.',
    conversationSnapchatImportDetailSkipApp: 'Ya abrí la página con el botón: pasar al paso 4',
    conversationSnapchatImportDetailStep1: 'Abre <b>Snapchat</b> y pulsa tu foto de perfil.',
    conversationSnapchatImportDetailStep2: 'Pulsa el icono del <b>engranaje</b> para abrir los ajustes.',
    conversationSnapchatImportDetailStep3: 'Desplázate hasta <b>Acciones de la cuenta</b> y pulsa <b>Mis Datos</b>. También puedes usar el botón de arriba.',
    conversationSnapchatImportDetailStep4: 'Marca <b>Historial de chats</b>, elige los formatos <b>JSON</b> y <b>HTML</b>, luego pulsa <b>Siguiente</b>.',
    conversationSnapchatImportDetailStep5: 'Elige el periodo deseado, confirma tu correo electrónico y pulsa <b>Enviar</b>.',
    conversationSnapchatImportDetailStep6: 'Snapchat te enviará un correo cuando la exportación esté lista: puede tardar desde unas horas hasta varios días.',
    conversationSnapchatImportDetailStep7: 'Cuando recibas el correo, haz clic en el enlace para acceder a tus datos.',
    conversationSnapchatImportDetailStep8: 'En Snapchat, pulsa <b>Ver exportación</b>, luego <b>Descargar</b>.',
    conversationSnapchatImportDetailStep9: 'Descarga el archivo <b>.zip</b> completo en tu dispositivo y súbelo aquí abajo <b>sin abrirlo</b>. Solo se usará la conversación que elijas después para tu libro.',

    conversationTelegramImportIntro: '4 pasos para exportar una conversación de Telegram:',
    conversationTelegramImportCta: 'Descargar Telegram Desktop',
    conversationTelegramImportStep1: 'En PC, instala <b>Telegram Desktop</b>. En Mac, no uses la app « Telegram » de la App Store: descarga <b>Telegram Desktop</b> con el enlace de arriba (en la App Store se llama Telegram Lite). Luego abre la conversación que quieres convertir en libro.',
    conversationTelegramImportStep2: 'Haz clic en los <b>tres puntos</b> arriba a la derecha → <b>Exportar historial del chat</b>.',
    conversationTelegramImportStep3: 'Marca <b>fotos, vídeos y archivos</b>, elige el formato <b>JSON</b> (el HTML también vale), luego pulsa <b>Exportar</b> y espera a que termine la descarga.',
    conversationTelegramImportStep4: 'Comprime la carpeta exportada en <b>.zip</b> (clic derecho → comprimir), luego súbela aquí abajo <b>sin abrirla</b>: confirmarás las opciones <b>después</b> de subirla.',
    conversationTelegramImportAlert: 'Una conversación a la vez. Incluye los <b>medios</b> en la exportación para un libro ilustrado: sube el <b>.zip</b> completo, tal cual.',
    conversationTelegramImportDetailTitle: 'Exportación de Telegram: guía detallada',
    conversationTelegramImportDetailIntro: 'Sigue cada paso con las capturas de abajo. Usa el botón de arriba para descargar Telegram Desktop, o ve al paso 2 si ya lo tienes instalado.',
    conversationTelegramImportDetailSkipApp: 'Ya tengo Telegram Desktop: pasar al paso 2',
    conversationTelegramImportDetailStep1: 'En PC, <b>Telegram Desktop</b> es la aplicación correcta. En Mac, descarga <b>Telegram Desktop</b> con el enlace de arriba: la app « Telegram » de la App Store no puede exportar. En la App Store, el programa correcto se llama <b>Telegram Lite</b>.',
    conversationTelegramImportDetailStep2: 'Abre la <b>conversación</b> que quieres convertir en libro.',
    conversationTelegramImportDetailStep3: 'Haz clic en los <b>tres puntos</b> arriba a la derecha, luego en <b>Exportar historial del chat</b>.',
    conversationTelegramImportDetailStep4: 'Marca <b>todos los tipos de archivo</b> (fotos, vídeos, mensajes de voz, etc.), sube el tamaño máximo a <b>1500 MB</b> y elige el formato <b>JSON</b>. Si no aparece la elección de formato, el HTML también funciona.',
    conversationTelegramImportDetailStep5: 'Haz clic en <b>Exportar</b> abajo a la derecha para iniciar la exportación.',
    conversationTelegramImportDetailStep6: 'En tu teléfono, pulsa <b>Permitir</b> si se te pide. Comprime la carpeta exportada en <b>.zip</b> y súbela aquí abajo <b>sin abrirla</b>: confirmarás las opciones después de subirla.',

    conversationImportDetectedPlatform: 'Estos pasos son para {platform}. Las otras opciones siguen disponibles.',
    conversationWhatsappImportIntro: 'Empieza en el teléfono. ¿Estás en iPhone o Android?',
    conversationWhatsappImportPlatformIphone: 'iPhone',
    conversationWhatsappImportPlatformAndroid: 'Android',
    conversationWhatsappImportIphoneStep1: 'Abre la conversación, toca el <b>nombre arriba</b> y luego <b>Exportar chat</b>.',
    conversationWhatsappImportIphoneStep2: 'Elige <b>Adjuntar archivos</b> para fotos en el libro (o <b>Sin archivos</b> solo texto).',
    conversationWhatsappImportIphoneStep3: 'Guarda en <b>Archivos</b> y suelta el <b>.zip</b> abajo <b>sin abrirlo</b>.',
    conversationWhatsappImportIphoneStep4: '<b>Con medios</b> para un libro con fotos, <b>sin medios</b> solo mensajes: guarda el archivo en el ordenador o móvil y súbelo aquí abajo <b>sin abrirlo</b>.',
    conversationWhatsappImportAndroidStep1: 'Abre el chat, pulsa <b>⋮</b> → <b>Más</b> → <b>Exportar chat</b>.',
    conversationWhatsappImportAndroidStep2: 'Elige <b>Incluir archivos</b> para fotos en el libro (o <b>Sin medios</b> solo texto).',
    conversationWhatsappImportAndroidStep3: 'Guarda o comparte el archivo y sube el <b>.zip</b> abajo <b>sin abrirlo</b>.',
    conversationWhatsappImportAndroidStep4: 'Guarda el archivo (Archivos, Google Drive o email), llévalo a tu ordenador o móvil y súbelo aquí abajo <b>sin abrirlo</b>.',
    conversationWhatsappImportAlert: 'Una conversación por exportación. Prefiere <b>Adjuntar archivos</b> para un libro ilustrado. Quédate en esta página hasta el final.',
    conversationWhatsappImportAlertAndroid: 'Una conversación por exportación. Prefiere <b>Incluir archivos</b>. En algunos móviles solo funciona el email: usa entonces <b>Sin medios</b>. Quédate en esta página hasta el final.',
    conversationWhatsappImportIphoneDetailTitle: 'Exportación WhatsApp en iPhone: guía detallada',
    conversationWhatsappImportIphoneDetailIntro: 'Sigue cada paso en tu iPhone con las capturas de abajo, luego transfiere el archivo a tu ordenador o móvil antes de subirlo aquí.',
    conversationWhatsappImportIphoneDetailStep1: 'Abre <b>WhatsApp</b> y la conversación que quieres convertir en libro.',
    conversationWhatsappImportIphoneDetailStep2: 'Pulsa el <b>nombre del contacto</b> o del grupo en la parte superior.',
    conversationWhatsappImportIphoneDetailStep3: 'Desplázate hasta el final de la página hasta ver <b>Exportar chat</b>.',
    conversationWhatsappImportIphoneDetailStep4: 'Pulsa <b>Exportar chat</b>.',
    conversationWhatsappImportIphoneDetailStep5: 'Elige <b>Incluir archivos</b> para un libro ilustrado, o <b>Sin archivos</b> solo para mensajes.',
    conversationWhatsappImportIphoneDetailStep6: 'Guarda el archivo en tu ordenador o móvil (p. ej. en Archivos), luego súbelo aquí abajo <b>sin abrirlo</b>.',
    conversationWhatsappImportAndroidDetailTitle: 'Exportación WhatsApp en Android: guía detallada',
    conversationWhatsappImportAndroidDetailIntro: 'Sigue cada paso en tu Android con las capturas de abajo, luego transfiere el archivo a tu ordenador o móvil antes de subirlo aquí.',
    conversationWhatsappImportAndroidDetailStep1: 'Abre <b>WhatsApp</b> y la conversación que quieres convertir en libro.',
    conversationWhatsappImportAndroidDetailStep2: 'Pulsa <b>⋮</b> (arriba a la derecha) → <b>Más</b> → <b>Exportar chat</b>.',
    conversationWhatsappImportAndroidDetailStep3: 'Elige <b>Incluir archivos</b> para incluir fotos, o <b>Sin medios</b> solo para mensajes.',
    conversationWhatsappImportAndroidDetailStep4: 'Guarda el archivo (Archivos, Google Drive o email), llévalo a tu ordenador o móvil y súbelo aquí abajo <b>sin abrirlo</b>.',
    conversationWhatsappImportDemoTitle: 'Exporta tu conversación de WhatsApp',
    conversationWhatsappImportDemoIndividual: 'Chat individual',
    conversationWhatsappImportDemoGroup: 'Chat de grupo',
    conversationWhatsappImportDemoCaptionOpen: 'Abre el chat en WhatsApp',
    conversationWhatsappImportDemoCaptionTapName: 'Toca el nombre arriba',
    conversationWhatsappImportDemoCaptionExport: 'Desplázate y toca Exportar chat',
    conversationWhatsappImportDemoCaptionMedia: 'Elige Adjuntar archivos para fotos en el libro',
    conversationWhatsappImportDemoCaptionSave: 'Guarda en Archivos y suéltalo abajo',
    conversationWhatsappImportDemoExportLabel: 'Exportar chat',
    conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
    conversationWhatsappImportDemoAttachMedia: 'Adjuntar archivos',
    conversationWhatsappImportDemoWithoutMedia: 'Sin archivos',
    conversationWhatsappImportDemoSaveFiles: 'Guardar en Archivos',
    conversationWhatsappImportDemoA11y: 'Guía animada: abre el chat, toca el nombre, exporta, elige Adjuntar archivos y guarda en Archivos.',
    conversationWhatsappImportDemoCaptionExportGroup: 'Abre el menú ⋯ y toca Exportar chat',
    conversationWhatsappImportDemoContactName: 'Léa',
    conversationWhatsappImportDemoContactMom: 'Mamá',
    conversationWhatsappImportDemoGroupName: 'Fin de semana',
    conversationWhatsappImportDemoGroupWork: 'Work: design',
    conversationWhatsappImportDemoChats: 'Chats',
    conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
    conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
    conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
    conversationWhatsappImportDemoSeeAll: 'See all ›',
    conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
    conversationWhatsappImportDemoAddList: 'Add to a list',
    conversationWhatsappImportDemoClearChat: 'Vaciar el chat',
    conversationWhatsappImportDemoBlock: 'Block',
    conversationWhatsappImportDemoParticipants: '{count} participants',
    conversationWhatsappImportDemoAudio: 'Audio',
    conversationWhatsappImportDemoVideo: 'Video',
    conversationWhatsappImportDemoAdd: 'Add',
    conversationWhatsappImportDemoSearch: 'Search',
    conversationWhatsappImportDemoMemberYou: 'You',
    conversationWhatsappImportDemoMemberAlex: 'Alex',
    conversationWhatsappImportDemoMemberCamille: 'Camille',
    conversationWhatsappImportDemoEditGroup: 'Edit group info',
    conversationWhatsappImportDemoEditDescription: 'Edit description',
    conversationWhatsappImportAndroidDemoIncludeMedia: 'Incluir archivos',
    conversationWhatsappImportAndroidDemoWithoutMedia: 'Sin medios',
    conversationWhatsappImportAndroidDemoMediaNotice: 'Incluir archivos para un libro ilustrado. Sin medios es más ligero.',
    conversationWhatsappImportAndroidDemoClear: 'Vaciar chat',
    conversationWhatsappImportAndroidDemoExport: 'Exportar chat',
    conversationWhatsappImportAndroidDemoReport: 'Denunciar',
    conversationWhatsappImportAndroidDemoMore: 'Más',
    conversationWhatsappImportAndroidDemoWallpaper: 'Fondo de pantalla',
    conversationWhatsappImportAndroidDemoMute: 'Silenciar notificaciones',
    conversationWhatsappImportAndroidDemoOnline: 'en línea',
    conversationWhatsappImportAndroidDemoCaptionSave: 'Guarda o comparte el archivo y súbelo aquí abajo',
    conversationWhatsappImportAndroidDemoCaptionMedia: 'Elige Incluir archivos para fotos en el libro',
    conversationWhatsappImportAndroidDemoCaptionExport: 'Pulsa Más, luego Exportar chat',
    conversationWhatsappImportAndroidDemoCaptionMenu: 'Pulsa el menú arriba a la derecha',
    conversationWhatsappImportAndroidDemoCaptionOpen: 'Abre el chat en WhatsApp',
    conversationWhatsappImportAndroidDemoTitle: 'Exporta tu conversación de WhatsApp en Android',
    conversationWhatsappImportAndroidDemoShareHint: 'Luego sube el .zip abajo sin abrirlo.',
    conversationWhatsappImportAndroidDemoFiles: 'Archivos',
    conversationWhatsappImportAndroidDemoShareVia: 'Enviar a…',

    conversationMessengerImportIntro: 'Empieza por <b>Después de 2023</b>: chats cifrados, en Messenger.com. Pasa a <b>Antes de 2023</b> si el tuyo no está.',
    conversationMessengerImportContext: 'Un chat que empezó antes de 2023 puede seguir después de activar el cifrado. Messenger lo parte entonces en dos archivos. Importa los dos y fusiónalos desde tu lista de conversaciones.',
    conversationMessengerImportPlatformClassic: 'Antes de 2023',
    conversationMessengerImportPlatformEncrypted: 'Después de 2023',
    conversationMessengerImportClassicCta: 'Abrir Meta para exportar',
    conversationMessengerClassicImportDemoReadyHint: 'Sube el .zip completo abajo sin abrirlo. Elegirás la conversación después.',
    conversationMessengerClassicImportDemoExportMeta: 'Exportar a dispositivo · JSON',
    conversationMessengerClassicImportDemoDownloadsAvailable: 'Descargas disponibles',
    conversationMessengerClassicImportDemoStartExport: 'Iniciar exportación',
    conversationMessengerClassicImportDemoQualityLow: 'Baja',
    conversationMessengerClassicImportDemoMediaQuality: 'Calidad multimedia',
    conversationMessengerClassicImportDemoCustomizeMessages: 'Solo mensajes',
    conversationMessengerClassicImportDemoCustomize: 'Personalizar información',
    conversationMessengerClassicImportDemoConfirmTitle: 'Confirmar tu exportación',
    conversationMessengerClassicImportDemoJsonNotice: 'JSON obligatorio para tu libro. HTML no funcionará.',
    conversationMessengerClassicImportDemoFormat: 'Formato',
    conversationMessengerClassicImportDemoSave: 'Guardar',
    conversationMessengerClassicImportDemoMessagesTip: 'Opcional pero más rápido: borrar todo, luego solo Mensajes.',
    conversationMessengerClassicImportDemoDataMessages: 'Mensajes',
    conversationMessengerClassicImportDemoDataPayments: 'Pagos',
    conversationMessengerClassicImportDemoDataComments: 'Comentarios',
    conversationMessengerClassicImportDemoClearAll: 'Borrar todo',
    conversationMessengerClassicImportDemoPickSpecific: 'Elige información específica para exportar',
    conversationMessengerClassicImportDemoExportExternal: 'Exportar a un servicio externo',
    conversationMessengerClassicImportDemoExportDevice: 'Exportar a mi dispositivo',
    conversationMessengerClassicImportDemoChooseDestination: 'Elige dónde exportar',
    conversationMessengerClassicImportDemoAccountShort: 'Tu cuenta',
    conversationMessengerClassicImportDemoProfileName: 'El nombre de tu cuenta',
    conversationMessengerClassicImportDemoProfiles: 'Perfiles',
    conversationMessengerClassicImportDemoChooseProfile: 'Elige un perfil',
    conversationMessengerClassicImportDemoPastActivity: 'Actividad pasada',
    conversationMessengerClassicImportDemoCurrentActivity: 'Actividad en curso',
    conversationMessengerClassicImportDemoCreateExport: 'Crear exportación',
    conversationMessengerClassicImportDemoExportIntro: 'Crea una copia de tu información para descargarla en tu dispositivo.',
    conversationMessengerClassicImportDemoExportTitle: 'Exportar tu información',
    conversationMessengerClassicImportDemoCaptionDrop: 'Descarga el .zip cuando esté listo y súbelo aquí abajo',
    conversationMessengerClassicImportDemoCaptionStart: 'Pulsa Iniciar exportación',
    conversationMessengerClassicImportDemoCaptionJson: 'Elige formato JSON, luego Guardar',
    conversationMessengerClassicImportDemoCaptionMessages: 'Consejo: Borrar todo, luego solo Mensajes (más rápido)',
    conversationMessengerClassicImportDemoCaptionDevice: 'Pulsa Exportar a mi dispositivo',
    conversationMessengerClassicImportDemoCaptionCreate: 'Pulsa Crear exportación',
    conversationMessengerClassicImportDemoActivitySection: 'Tu actividad en Facebook',
    conversationMessengerClassicImportDemoProfileAccount: 'Tu cuenta · Facebook',
    conversationMessengerClassicImportDemoPlatform: 'Facebook',
    conversationMessengerClassicImportDemoCaptionProfile: 'Elige tu perfil de Facebook',
    conversationMessengerClassicImportDemoTitle: 'Exporta tus conversaciones de Messenger de antes de 2023',
    conversationMessengerEncryptedImportDemoTitle: 'Exporta tus conversaciones de Messenger de después de 2023',
    conversationImportDemoBadgeMeta: 'Ejemplo: hazlo en Meta, con el botón de arriba',
    conversationMessengerEncryptedImportDemoBadge: 'Ejemplo: hazlo en Messenger.com, con el botón de arriba',
    conversationMessengerEncryptedImportDemoCaptionLogin: 'En un ordenador, abre Messenger.com e inicia sesión',
    conversationMessengerEncryptedImportDemoCaptionSettings: 'Haz clic en el engranaje de abajo a la izquierda',
    conversationMessengerEncryptedImportDemoCaptionPrivacy: 'Abre Privacidad y seguridad',
    conversationMessengerEncryptedImportDemoCaptionEncrypted: 'Elige Chats cifrados de extremo a extremo',
    conversationMessengerEncryptedImportDemoCaptionStorage: 'Abre Almacenamiento de mensajes',
    conversationMessengerEncryptedImportDemoCaptionDownloadData: 'Haz clic en Descargar los datos del almacenamiento de mensajes',
    conversationMessengerEncryptedImportDemoCaptionRange: 'Deja Media marcado y elige el periodo All time',
    conversationMessengerEncryptedImportDemoCaptionDrop: 'Haz clic en Descargar archivo y suelta el .zip abajo',
    conversationMessengerEncryptedImportDemoLandingTitle: 'Un espacio para conversaciones interesantes',
    conversationMessengerEncryptedImportDemoLandingText: 'Messenger te permite comunicarte con las personas que te importan.',
    conversationMessengerEncryptedImportDemoContinueAs: 'Continuar como Tu nombre',
    conversationMessengerEncryptedImportDemoSwitchAccount: 'Cambiar de cuenta',
    conversationMessengerEncryptedImportDemoChats: 'Chats',
    conversationMessengerEncryptedImportDemoSearch: 'Buscar en Messenger',
    conversationMessengerEncryptedImportDemoContactName: 'Tu contacto',
    conversationMessengerEncryptedImportDemoContactStatus: 'Activo ahora',
    conversationMessengerEncryptedImportDemoLockBadge: 'Cifrado de extremo a extremo',
    conversationMessengerEncryptedImportDemoMenuPreferences: 'Preferencias',
    conversationMessengerEncryptedImportDemoMenuProfileName: 'Editar el nombre del perfil',
    conversationMessengerEncryptedImportDemoMenuRestricted: 'Cuentas restringidas',
    conversationMessengerEncryptedImportDemoMenuAccessibility: 'Accesibilidad',
    conversationMessengerEncryptedImportDemoMenuHelp: 'Ayuda',
    conversationMessengerEncryptedImportDemoPrivacyTitle: 'Privacidad y seguridad',
    conversationMessengerEncryptedImportDemoPrivacyReceipts: 'Confirmaciones de lectura',
    conversationMessengerEncryptedImportDemoPrivacyReported: 'Chats denunciados',
    conversationMessengerEncryptedImportDemoPrivacyKeys: 'Verificar las claves del chat',
    conversationMessengerEncryptedImportDemoEncryptedTitle: 'Chats cifrados de extremo a extremo',
    conversationMessengerEncryptedImportDemoEncryptedHint: 'Gestiona los ajustes de tus chats cifrados de extremo a extremo',
    conversationMessengerEncryptedImportDemoEncryptedAlerts: 'Alertas de seguridad',
    conversationMessengerEncryptedImportDemoEncryptedPreviews: 'Vistas previas',
    conversationMessengerEncryptedImportDemoStorageTitle: 'Almacenamiento de mensajes',
    conversationMessengerEncryptedImportDemoStorageHint: 'Gestiona cómo guardas y accedes al historial de tus chats',
    conversationMessengerEncryptedImportDemoStorageIntro: 'Tus mensajes cifrados de extremo a extremo se guardan de forma segura en tu copia de seguridad.',
    conversationMessengerEncryptedImportDemoStoragePin: 'Restablecer el código PIN',
    conversationMessengerEncryptedImportDemoStorageMethods: 'Gestionar los métodos de seguridad',
    conversationMessengerEncryptedImportDemoStorageRemember: 'Recordar este navegador',
    conversationMessengerEncryptedImportDemoStorageDownload: 'Descargar los datos del almacenamiento de mensajes',
    conversationMessengerEncryptedImportDemoStorageDownloadHint: 'Descarga todos tus mensajes y archivos adjuntos cifrados de extremo a extremo.',
    conversationMessengerEncryptedImportDemoStorageAutoImport: 'Desactivar las importaciones automáticas',
    conversationMessengerEncryptedImportDemoDownloadTitle: 'Descargar tus datos',
    conversationMessengerEncryptedImportDemoDownloadIntro: 'Puedes descargar en cualquier momento una copia de todos tus mensajes y archivos adjuntos cifrados de extremo a extremo.',
    conversationMessengerEncryptedImportDemoMediaTip: 'Deja Media marcado; si no, tu libro no tendrá ninguna foto.',
    conversationMessengerEncryptedImportDemoFileNotice: 'La preparación del archivo puede tardar varios minutos.',
    conversationMessengerEncryptedImportDemoDownloadFile: 'Descargar archivo',
    conversationMessengerEncryptedImportDemoReadyHint: 'Suelta el .zip completo abajo sin abrirlo. Después elegirás la conversación.',
    conversationMessengerImportEncryptedCta: 'Abrir Messenger.com para exportar',
    conversationMessengerImportClassicStep1: 'Pulsa <b>Crear exportación</b>, elige tu perfil de <b>Facebook</b>, luego <b>Exportar a mi dispositivo</b>.',
    conversationMessengerImportClassicStep2: 'Consejo para ir más rápido: <b>Borrar todo</b>, marca solo <b>Mensajes</b>. Elige formato <b>JSON</b> y calidad <b>Baja</b>.',
    conversationMessengerImportClassicStep3: 'Pulsa <b>Iniciar exportación</b>, espera el email (10 min a 24 h), descarga el <b>.zip</b> y súbelo aquí abajo <b>sin abrirlo</b>: elegirás la conversación <b>después</b>.',
    conversationMessengerImportClassicAlert: '¿Conversación ausente? Pasa a <b>Después de 2023</b>. Formato <b>JSON</b> obligatorio (no HTML). Consejo: exportar solo <b>Mensajes</b> es más rápido, pero no es obligatorio.',
    conversationMessengerImportEncryptedStep1: 'En un ordenador, abre <b>Messenger.com</b>, inicia sesión y haz clic en el <b>engranaje</b> de abajo a la izquierda.',
    conversationMessengerImportEncryptedStep2: 'Ve a <b>Privacidad y seguridad</b>, luego <b>Chats cifrados de extremo a extremo</b> y luego <b>Almacenamiento de mensajes</b>.',
    conversationMessengerImportEncryptedStep3: 'Haz clic en <b>Descargar los datos del almacenamiento de mensajes</b>. Deja <b>Media</b> marcado y elige el periodo <b>All time</b>.',
    conversationMessengerImportEncryptedStep4: 'Haz clic en <b>Descargar archivo</b> y suelta el <b>.zip</b> abajo <b>sin abrirlo</b>: elegirás la conversación <b>después</b> de subirlo.',
    conversationMessengerImportEncryptedAlert: 'Deja <b>Media</b> marcado; si no, tu libro no tendrá ninguna foto. ¿Falta la conversación? Cambia a <b>Antes de 2023</b>.',
    conversationMessengerImportClassicDetailTitle: 'Exportación antes de 2023: guía detallada',
    conversationMessengerImportClassicDetailIntro: 'Sigue cada paso con las capturas de abajo. El botón de arriba abre directamente la página de exportación.',
    conversationMessengerImportClassicDetailSkipApp: 'Ya abrí la página con el botón: pasar al paso 5',
    conversationMessengerImportClassicDetailStep1: 'Abre la aplicación de <b>Messenger</b> y accede a <b>Ajustes</b> mediante los tres puntos.',
    conversationMessengerImportClassicDetailStep2: 'Pulsa el icono del <b>engranaje</b>.',
    conversationMessengerImportClassicDetailStep3: 'Selecciona <b>Centro de cuentas</b>.',
    conversationMessengerImportClassicDetailStep4: 'Pulsa en <b>Tu información y permisos</b>.',
    conversationMessengerImportClassicDetailStep5: 'Elige <b>Descargar tu información</b>.',
    conversationMessengerImportClassicDetailStep6: 'Ve a <b>Descargar o transferir información</b>. Si usaste el botón de arriba, ya estás en esta página.',
    conversationMessengerImportClassicDetailStep7: 'Selecciona <b>Facebook</b>. Este paso puede no aparecer en algunas cuentas.',
    conversationMessengerImportClassicDetailStep8: 'Elige <b>Parte de tu información</b>.',
    conversationMessengerImportClassicDetailStep9: 'Marca solo <b>Mensajes</b>, luego pulsa <b>Siguiente</b>.',
    conversationMessengerImportClassicDetailStep10: 'Pulsa <b>Descargar en el dispositivo</b>.',
    conversationMessengerImportClassicDetailStep11: 'Elige el periodo deseado, el formato <b>JSON</b> y una calidad <b>baja</b>. Tu archivo estará listo en <b>10 minutos a 24 horas</b>: recibirás un correo.',
    conversationMessengerImportClassicDetailStep12: 'Descarga el archivo <b>.zip</b> completo en tu dispositivo y súbelo aquí abajo <b>sin abrirlo</b>. Solo se usará la conversación que elijas después para tu libro.',
    conversationMessengerImportEncryptedDetailTitle: 'Exportación después de 2023: guía detallada',
    conversationMessengerImportEncryptedDetailIntro: 'Sigue cada paso con las capturas de abajo. También puedes usar el botón de arriba para abrir Messenger.com e ir al paso 2.',
    conversationMessengerImportEncryptedDetailSkipApp: 'Ya estoy en Messenger.com: pasar al paso 2',
    conversationMessengerImportEncryptedDetailStep1: 'En un ordenador, abre <b>Messenger.com</b> y haz clic en tu foto de perfil abajo a la izquierda.',
    conversationMessengerImportEncryptedDetailStep2: 'Haz clic en <b>Privacidad y seguridad</b>.',
    conversationMessengerImportEncryptedDetailStep3: 'Haz clic en <b>Chats cifrados de extremo a extremo</b>.',
    conversationMessengerImportEncryptedDetailStep4: 'Haz clic en <b>Almacenamiento seguro</b>.',
    conversationMessengerImportEncryptedDetailStep5: 'Haz clic en <b>Descargar datos del almacenamiento seguro</b>.',
    conversationMessengerImportEncryptedDetailStep6: 'Haz clic en <b>Descargar archivo</b>.',
    conversationMessengerImportEncryptedDetailStep7: 'Introduce tu contraseña de Facebook y haz clic en <b>Confirmar</b>.',
    conversationMessengerImportEncryptedDetailStep8: 'Haz clic en <b>Descargar</b>. Preparar el archivo puede tardar unos minutos.',
    conversationMessengerImportEncryptedDetailStep9: 'Descarga el archivo <b>.zip</b> completo en tu ordenador y súbelo aquí abajo <b>sin abrirlo</b>. Solo se usará la conversación que elijas después para tu libro.',
    conversationMessengerImportMissingTip: '¿Chat ausente de la lista? Vuelve atrás y prueba la exportación <b>Después de 2023</b>.',
    conversationMessengerImportEmptyTitle: 'Ninguna conversación encontrada en este archivo',

    conversationSmsImportTagline: 'No subas ningún archivo aquí: todo se hace desde nuestro software o aplicación.',
    conversationSmsImportIntro: 'Sin subida de archivo en esta página. Todo se hace desde nuestro software (iPhone) o nuestra app (Android). Indica tu configuración:',
    conversationSmsImportContext: 'Nuestra app Android <b>no está en Google Play</b>: el acceso a SMS está restringido allí. Para abrirla, Android y Play Protect piden una confirmación.',
    conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
    conversationSmsImportPlatformIphonePc: 'iPhone + PC',
    conversationSmsImportPlatformAndroid: 'Android',
    conversationSmsImportMacCta: 'Descargar software Mac',
    conversationSmsImportPcCta: 'Descargar software PC',
    conversationSmsImportAndroidCta: 'Descargar app Android',
    conversationSmsImportMacStep1: 'Descarga el software Mac.',
    conversationSmsImportMacStep2: 'Instálalo y <b>déjate guiar</b>: el software te indica los pasos a seguir.',
    conversationSmsImportMacStep3: 'Elige la <b>conversación</b> para enviarla a tu cuenta y permanece en pantalla hasta el final de la transferencia.',
    conversationSmsImportMacStep4: 'Instala el software de abajo, concede <b>acceso completo al disco</b> en Ajustes del sistema → Privacidad, luego elige la conversación para enviarla a tu cuenta.',
    conversationSmsImportMacHelp: 'Si el software no encuentra la copia: Ajustes del sistema → Privacidad y seguridad → <b>Acceso total al disco</b> → añade MonLivreSMS (desbloquea el candado abajo a la izquierda).',
    conversationSmsImportMacAlert: 'Sin subida aquí: la transferencia sale del software, que te guía en pantalla.',
    conversationSmsImportPcStep1: 'Descarga el software PC.',
    conversationSmsImportPcHelp: 'En iTunes, comprueba que <b>Cifrar copia de seguridad local</b> esté desmarcada antes de pulsar <b>Copia de seguridad ahora</b>. Guía visual arriba.',
    conversationSmsImportHelpToggle: '¿Necesitas ayuda más detallada?',
    conversationSmsImportPcStep2: 'Instálalo y <b>déjate guiar</b>: el software te indica los pasos a seguir.',
    conversationSmsImportPcStep3: 'Elige la <b>conversación</b> para enviarla a tu cuenta y permanece en pantalla hasta el final de la transferencia.',
    conversationSmsImportPcStep4: 'Instala el software de abajo, ejecútalo (autoriza si Windows avisa), luego elige la conversación para enviarla a tu cuenta.',
    conversationSmsImportPcAlert: 'Sin subida aquí: la transferencia sale del software, que te guía en pantalla.',
    conversationSmsImportAndroidStep1: 'En tu Android, descarga nuestra <b>app fuera de la tienda</b> abajo: el acceso a SMS no está permitido en Google Play.',
    conversationSmsImportAndroidStep2: 'Abre el archivo descargado. Si Android no deja instalar, pulsa <b>Ajustes</b>, activa <b>Permitir desde esta fuente</b> y vuelve atrás.',
    conversationSmsImportAndroidStep3: 'Si aparece <b>Play Protect</b>, pulsa <b>Más detalles</b> y luego <b>Instalar de todas formas</b>. Después pulsa <b>Instalar</b> y <b>Abrir</b>.',
    conversationSmsImportAndroidStep4: 'En la app, acepta el acceso a los <b>SMS</b> y a los <b>contactos</b>.',
    conversationSmsImportAndroidStep5: 'Elige la <b>conversación</b> y confirma. Quédate en la pantalla hasta el final: los mensajes van directo a tu cuenta.',
    conversationSmsImportAndroidAlert: 'Sin archivo que subir aquí. Quédate en la pantalla de transferencia de la app para incluir todas las fotos.',
    conversationSmsImportFooter: 'Cuando termine la transferencia, personaliza tu libro en este sitio: la app te redirigirá automáticamente.',
	conversationSmsImportAndroidDetailIntro: 'Sigue cada paso en tu teléfono Android. La app <b>no está en Google Play</b>. Android y luego Play Protect piden una confirmación antes de abrirla: es normal.',
	conversationSmsImportAndroidDetailSkipApp: 'Ya descargué la app: pasar al paso 2',
	conversationSmsImportAndroidDetailStep1: 'Descargue nuestra app de exportación SMS fuera de Google Play (botón abajo): el acceso a SMS no está permitido en Play Store.',
	conversationSmsImportAndroidDetailStep2: 'Tras la descarga, pulsa <b>Abrir</b>.',
	conversationSmsImportAndroidDetailStep3: 'Pulsa <b>Ajustes</b> para autorizar la instalación.',
	conversationSmsImportAndroidDetailStep4: 'Activa <b>Permitir desde esta fuente</b> y vuelve atrás para encontrar la instalación.',
	conversationSmsImportAndroidDetailStep5: 'Si aparece <b>Play Protect</b>, pulsa <b>Más detalles</b> y luego <b>Instalar de todas formas</b>. Instala, abre la app y acepta el acceso a los SMS y a los contactos.',
	conversationSmsImportAndroidDetailStep6: 'Selecciona la <b>conversación</b> deseada.',
	conversationSmsImportAndroidDetailStep7: 'Confirma y valida: permanece en la pantalla de transferencia hasta el final para incluir todas las fotos. Serás redirigido automáticamente para personalizar tu libro.',
	conversationSmsImportAndroidDetailTitle: 'Exportación SMS Android: guía detallada',
	conversationSmsImportMacDetailIntro: 'Descarga el software y déjate guiar en pantalla. Las capturas de abajo ayudan sobre todo con la instalación.',
	conversationSmsImportMacDetailSkipSoftware: 'Ya descargué el programa: pasar al paso 8',
	conversationSmsImportMacDetailStep1: 'Conecta tu iPhone al Mac con un cable USB.',
	conversationSmsImportMacDetailStep10: 'Abre <b>Ajustes del sistema</b> → <b>Privacidad y seguridad</b>.',
	conversationSmsImportMacDetailStep11: 'Baje al final y pulsa <b>Abrir de todos modos</b>.',
	conversationSmsImportMacDetailStep12: 'En el aviso de seguridad, pulsa <b>Permitir</b>.',
	conversationSmsImportMacDetailStep13: 'Pulsa <b>Abrir</b>.',
	conversationSmsImportMacDetailStep14: 'Pulsa <b>Continuar</b>.',
	conversationSmsImportMacDetailStep15: 'Pulsa <b>Continuar</b> de nuevo.',
	conversationSmsImportMacDetailStep16: 'Pulsa <b>Instalar</b>.',
	conversationSmsImportMacDetailStep17: 'En el aviso de seguridad, pulsa <b>Permitir</b> de nuevo.',
	conversationSmsImportMacDetailStep18: 'Pulsa <b>Cerrar</b> para salir del asistente.',
	conversationSmsImportMacDetailStep19: 'Abre <b>Finder</b> → <b>Aplicaciones</b> y ejecute <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep2: 'Para fotos en el libro: abra <b>Mensajes</b>, seleccione la conversación y pulsa el <b>nombre del contacto</b>.',
	conversationSmsImportMacDetailStep20: 'Pulsa el <b>menú Manzana</b> arriba a la izquierda → <b>Ajustes del sistema</b>.',
	conversationSmsImportMacDetailStep21: 'Abre <b>Privacidad y seguridad</b> → <b>Acceso completo al disco</b>.',
	conversationSmsImportMacDetailStep22: 'Arrastre el icono MonLivreSMS a la lista (clic prolongado) y marque <b>Acceso completo al disco</b>.',
	conversationSmsImportMacDetailStep23: 'Pulsa <b>Abrir</b> para confirmar.',
	conversationSmsImportMacDetailStep24: 'Pulsa <b>Abrir</b> de nuevo si aparece una segunda confirmación.',
	conversationSmsImportMacDetailStep25: 'Elige la <b>conversación</b> a exportar: textos y fotos se enviarán a tu cuenta. Permanece en la pantalla de transferencia hasta el final, con conexión estable.',
	conversationSmsImportMacDetailStep3: 'Desplácese hasta el final de la ficha del contacto.',
	conversationSmsImportMacDetailStep4: 'Pulsa <b>Descargar</b> para importar todas las fotos de iCloud al iPhone.',
	conversationSmsImportMacDetailStep5: 'Abre el <b>Finder</b>, selecciona tu iPhone en la barra lateral, desmarque <b>Cifrar copia de seguridad local</b> y active <b>Hacer copia de seguridad de todos los datos en este Mac</b>.',
	conversationSmsImportMacDetailStep6: 'Pulsa <b>Hacer copia de seguridad ahora</b> y espere a que termine.',
	conversationSmsImportMacDetailStep7: 'Descargue el software MonLivreSMS para Mac (botón abajo en esta página).',
	conversationSmsImportMacDetailStep8: 'Haz doble clic en la carpeta <b>MonLivreSMS</b> descargada.',
	conversationSmsImportMacDetailStep9: 'Pulsa <b>OK</b> para iniciar la instalación.',
	conversationSmsImportMacDetailTitle: 'Exportación SMS iPhone + Mac: guía detallada',
	conversationSmsImportPcDetailIntro: 'Descarga el software y déjate guiar en pantalla. Las capturas de abajo ayudan sobre todo con la instalación.',
	conversationSmsImportPcDetailSkipSoftware: 'Ya descargué el programa: pasar al paso 3',
	conversationSmsImportPcDetailStep1: 'Conecta tu iPhone al PC con un cable USB.',
	conversationSmsImportPcDetailStep2: 'Descargue el software MonLivreSMS para PC (botón abajo en esta página).',
	conversationSmsImportPcDetailStep3: 'Instale <link>iTunes</link> si aún no lo tiene.',
	conversationSmsImportPcDetailStep4: 'Abre iTunes.',
	conversationSmsImportPcDetailStep5: 'Inicie sesión con su <b>ID de Apple</b> y valide en el iPhone si se solicita.',
	conversationSmsImportPcDetailStep6: 'Cuando el iPhone sea reconocido, pulsa <b>Continuar</b>.',
	conversationSmsImportPcDetailStep7: 'En <b>Resumen</b>, desmarque <b>Cifrar copia de seguridad local</b> y pulsa <b>Hacer copia de seguridad ahora</b> (en este ordenador, no iCloud).',
	conversationSmsImportPcDetailStep8: 'Cuando termine la copia, abre la carpeta MonLivreSMS. Si Windows muestra una advertencia, pulsa <b>Más información</b> y luego <b>Ejecutar de todos modos</b>. Elige la conversación para enviar a tu cuenta.',
	conversationSmsImportPcDetailTitle: 'Exportación SMS iPhone + PC: guía detallada',
    /* --- sync 2026-06-29 --- */
    autocompleteSearch: 'Escribe para buscar…',
    cmsAdminListHint: 'Edita páginas, paneles y traducciones. Las banderas indican el estado de traducción por idioma.',
    cmsContentDuplicateSuccess: '¡Contenido CMS duplicado!',
    cmsPageAdd: 'Añadir una página',
    code: 'Código',
    configAdminHint: 'Ajustes de la aplicación, afiliaciones, procesos en segundo plano y claves de configuración.',
    console: 'Consola',
    conversationAdminListHint: 'Explora, filtra y gestiona todas las conversaciones. Usa las pestañas de estado para cada etapa.',
    conversationBackToList: 'Volver a mis conversaciones',
    conversationCreationDate: 'Fecha de creación',
    conversationCustomImportUpload: 'Importar archivo generado',
    conversationDownloadBackPreview: 'Volver a la vista previa',
    conversationDownloadEyebrow: 'Tu libro está listo',
    conversationDownloadHint: 'Descarga tu PDF y conserva una copia digital de tu conversación.',
    conversationDownloadLoading: 'Preparando tus archivos…',
    conversationFlags: 'Banderas',
    conversationHighlightShareImageButton: 'Enviar la imagen',
    conversationHighlightsEmpty: 'Hacen falta unos mensajes más para sacar las cifras.',
    conversationHighlightsLoading: 'Reuniendo tus cifras.',
    conversationImages: 'Imágenes',
    conversationMedias: 'Medios',
    conversationMergeSelect: 'Seleccionar esta conversación',
    conversationMergeUnselect: 'Deseleccionar esta conversación',
    conversationOrders: 'Pedidos',
    conversationPreviewCoverEditButton: 'Editar portada',
    conversationPreviewCoverOpenLabel: 'Abrir el libro',
    conversationPreviewCustomizeClose: 'Cerrar personalización',
    conversationPreviewCustomizeDone: 'Terminar personalización',
    conversationPreviewEditionBelowHint: 'Elige tu edición más abajo',
    conversationPreviewEditionScrollLabel: 'Ir a la sección edición',
    conversationPrinterMode: 'Modo impresor',
    copiedToClipboard: '¡Copiado!',
    country: 'País',
    dateStatus: 'Fecha de estado',
    dateValidation: 'Fecha de validación',
    dates: 'Fechas',
    identifier: 'Identificador',
    loadMore: 'Cargar más…',
    orderAdminListHint: 'Gestiona pedidos por estado. Filtra por país, producto o fecha de validación.',
    orderConfirmationGuestTitle: 'Mantente informado',
    orderConfirmationHomeCta: 'Volver al inicio',
    orderConfirmationNextStepsTitle: '¿Qué sigue?',
    orderConfirmationOrderNumber: 'Pedido n.º {code}',
    orderConfirmationPaymentWaitingHint: 'Suele tardar solo unos segundos.',
    orderConfirmationStepEmail: 'Confirmación por email',
    orderConfirmationStepEmailDesc: 'Se ha enviado un resumen a {email}',
    orderConfirmationStepEmailDescNoEmail: 'Recibirás un resumen por email',
    orderConfirmationStepPreparation: 'Preparación de tu libro',
    orderConfirmationStepPreparationDesc: 'Imprimimos y encuadernamos tu libro con cuidado',
    orderConfirmationStepShipping: 'Envío',
    orderConfirmationStepShippingDesc: 'Recibirás un email en cuanto se envíe tu paquete',
    orderConfirmationSummaryTitle: 'Tu pedido',
    orderConfirmationViewOrderCta: 'Seguir mi pedido',
    orderFlags: 'Banderas',
    orderMassExportInvoiceDetails: 'Exportar detalle de facturas',
    orderMassSendEmail: 'Enviar email',
    orderMassUpdateStatus: 'Actualizar estado',
    orderNote: 'Nota',
    orderNoteAdmin: 'Nota interna (admin)',
    orderNoteAdminAdd: 'Añadir una nota',
    orderNoteAdminEmpty: 'Sin notas internas para este pedido.',
    orderNoteAdminPlaceholder: 'Nota interna solo visible para el equipo (envío, soporte…)',
    orderPaymentMethod: 'Método de pago',
    orderPublicAccess: 'Acceso público',
    orderSendStatusNotificationEmail: 'Enviar email de notificación',
    orderViewShort: 'Pedido',
    ordersEditSuccess: '¡Pedidos actualizados!',
    product: 'Producto',
    productAdd: 'Añadir un producto',
    productAdminListHint: 'Gestiona el catálogo, precios y disponibilidad de la tienda.',
    seoOrderViewTitle: 'Pedido n.º {code}',
    shippingAdd: 'Añadir un método',
    shippingAdminListHint: 'Configura transportistas, países y tarifas de envío.',
    shippingMethod: 'Método de envío',
    tableDownloadNoElementError: '¡Nada que descargar!',
    tablePageSize: 'Por página',
    taskAddTitle: 'Añadir una tarea',
    taskAssignSelf: 'Asignarme',
    taskCountdownDate: 'Fecha de recordatorio',
    userAccountNote: 'Nota de cuenta de usuario',
    userAdminListHint: 'Busca cuentas, consulta actividad y abre un perfil o pedidos de un usuario.',
    vatExempt: 'EXENTO DE IVA',
    voucherAdd: 'Añadir un cupón',
    voucherAdminListHint: 'Crea y gestiona códigos promo, condiciones y límites de uso.',

	offerErrorRequired: 'Rellena los campos obligatorios, por favor.',
	offerErrorEmail: 'Revisa tu dirección de email.',
	offerErrorGiftEmail: 'Revisa el email de la persona a la que se lo regalas.',
	offerErrorGiftSameEmail: 'El email de la persona que recibe el regalo tiene que ser distinto del tuyo.',
	offerErrorGeneric: 'Vaya, algo ha fallado. Inténtalo de nuevo en un momento.',
	offerStepWhoEyebrow: 'Empezamos',
	offerStepWhoTitle: '¿Quién va a crear el libro?',
	offerStepWhoHint: 'Lo compones tú, para ti o para regalarlo. La tarjeta regalo es si lo crea la otra persona.',
	offerWhoSelf: 'Lo voy a crear',
	offerWhoSelfHint: 'Para mí, o para regalarlo una vez impreso',
	offerWhoGift: 'Ofrezco una tarjeta regalo',
	offerWhoGiftHint: 'La persona recibe un enlace y crea su libro',
	offerStepOccasionEyebrow: 'La ocasión',
	offerStepOccasionHint: 'El momento que tienes en mente.',
	offerStepGiftEyebrow: 'Tu regalo',
	offerStepGiftTitle: '¿A quién se lo regalas?',
	offerStepGiftHint: 'Enviamos el regalo por email, con un enlace para crear el libro. Nada que imprimir, nada que envolver.',
	offerGiftName: 'Su nombre',
	offerGiftEmail: 'Su email',
	offerGiftEmailHelp: 'El regalo llega a este correo justo después del pago.',
	offerGiftFromName: 'Tu nombre',
	offerGiftFromNameHelp: 'Para que sepa de quién es el regalo.',
	offerGiftMessage: 'Unas palabras (opcional)',
	offerGiftMessagePlaceholder: 'Para que estos mensajes estén siempre cerca de ti.',
	offerContinue: 'Continuar',
	offerStepMessengerEyebrow: 'Tus mensajes',
	offerStepMessengerTitleGift: '¿Dónde están los mensajes del libro de {name}?',
	offerStepMessengerTitle: '¿Dónde están tus mensajes más bonitos?',
	offerStepMessengerHint: 'Elige una. Podrás cambiarla más adelante.',
	offerStepMessengerHintGift: 'Tu conversación con {name}, o la suya con un ser querido. ¿Dudas sobre la app? {name} podrá elegir otra.',
	offerStepEmailEyebrow: 'Ya casi está',
	offerStepEmailTitle: 'Tu cuenta',
	offerStepEmailHintGift: 'Google, Apple o tu correo. Enviamos una confirmación y luego pagas la tarjeta regalo.',
	offerStepEmailHint: 'Google, Apple o tu correo. Enviamos una confirmación y luego importas la conversación.',
	offerStepEmailHintPay: 'Google, Apple o tu correo. Enviamos una confirmación y luego pagas el libro.',
	offerEmailLabel: 'Email',
	offerEmailPlaceholder: 'tu@ejemplo.com',
	offerEmailSubmit: 'Ir al pago',
	offerEmailSubmitAccount: 'Crear mi cuenta',
	offerEmailPrivacy: 'Solo tu libro. Mira también en la carpeta de spam.',
	offerStepSentEyebrow: 'Qué alegría verte de nuevo',
	offerStepSentTitle: 'Ya tienes una cuenta',
	offerStepSentCodeHint: 'Te acabamos de enviar un código de 6 cifras a {email}. Introdúcelo aquí: tu pedido te está esperando, listo para pagar. Mira también en la carpeta de spam.',
	offerStepSentCodeHintAccount: 'Te acabamos de enviar un código de 6 cifras a {email}. Introdúcelo aquí para abrir tu cuenta y empezar el libro. Mira también en la carpeta de spam.',
	offerStepPayEyebrow: 'Último paso',
	offerStepPayTitleGift: 'El libro para {name}',
	offerStepPayTitle: 'Tu libro impreso',
	offerLoggedAs: 'Sesión iniciada como {email}',
	offerSwitchAccount: '¿No eres tú?',
	offerTrustReviews: 'Más de {count} opiniones en Trustpilot',
	offerTrustGuarantee: 'Garantía de devolución',
	offerTrustShipping: 'Envío gratis',
	offerPageTitle: 'Tu libro de mensajes',
	offerBack: 'Atrás',
	offerItemName: 'Libro impreso para personalizar',
	offerPayBenefitBook: 'Tu libro impreso, maquetado con tus mensajes y fotos',
	offerPayBenefitBookGift: 'Un libro impreso de verdad, con los mensajes y las fotos que elija',
	offerPayBenefitMedia: 'También los audios y los vídeos, para revivirlos con los códigos QR impresos',
	offerPayBenefitCustom: 'Portada, foto, título, colores, prefacio: todo se personaliza',
	offerPayBenefitPdf: 'El PDF de regalo con el libro',
	offerPayBenefitShipping: 'Envío gratis',
	offerPayTotal: 'Total',
	offerPayNextGift: 'Justo después del pago, {name} recibe tu regalo por email.',
	offerPayNextSelf: 'Justo después del pago, importas la conversación. Unos minutos.',
	offerPayDreamSelf: 'Esos mensajes que relees en tu móvil, pronto entre tus manos. Para siempre.',
	offerPayDreamGift: 'El día que {name} lo abra, todos esos mensajes cobrarán vida entre sus manos.',
	offerPayButton: 'Pagar {price}',
	offerPaySecure: 'Pago seguro. Sin suscripción.',
	offerConfirmStepsTitle: 'Cómo funciona',
	offerConfirmGiftStep1: '{name} abre el email y pulsa el enlace',
	offerConfirmGiftStep2: '{name} importa la conversación en unos minutos',
	offerConfirmGiftStep3: 'Imprimimos el libro y lo enviamos',
	offerConfirmGiftTitle: '¡Enviado a {name}!',
	offerConfirmGiftLead: '{name} acaba de recibir tu regalo en {email}, con un enlace para crear el libro. Ya está pagado, envío incluido.',
	offerConfirmViewOrder: 'Ver mi pedido',
	offerConfirmGiftNote: '¿No le ha llegado? Pídele que mire en la carpeta de spam o escríbenos.',
	offerConfirmStep1: 'Exporta tu conversación desde {messenger}',
	offerConfirmStep1Generic: 'Exporta tu conversación desde tu app de mensajería',
	offerConfirmStep2: 'Impórtala aquí: nosotros nos encargamos de toda la maquetación',
	offerConfirmStep3: 'Valida tu libro: lo imprimimos y te lo enviamos',
	offerConfirmTitle: '¡Genial, tu libro ya está pagado!',
	offerConfirmLead: 'Solo te queda una cosa: importar tu conversación de {messenger}. Te guiamos paso a paso, son solo unos minutos.',
	offerConfirmLeadGeneric: 'Solo te queda una cosa: importar tu conversación. Te guiamos paso a paso, son solo unos minutos.',
	offerConfirmCta: 'Importar mi conversación de {messenger}',
	offerConfirmCtaGeneric: 'Importar mi conversación',
	offerConfirmChangeMessenger: 'Mis mensajes están en otra app',
	offerConfirmEmailNote: 'Te hemos enviado el recibo y el enlace de acceso a {email}.',
	userMagicTitle: 'Iniciar sesión',
	userMagicWorking: 'Iniciando sesión…',
	userMagicExpired: 'Este enlace ha caducado. Pide uno nuevo con un clic.',
	userMagicInvalid: 'Este enlace ya no es válido. Pide uno nuevo con un clic.',
	userMagicSent: 'Si hay una cuenta con esta dirección, te llegará un enlace nuevo. Echa un vistazo también a la carpeta de spam.',
	userMagicEmailLabel: 'Tu email',
	userMagicSend: 'Recibir un enlace nuevo',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'Incluido',
	conversationPreviewCollectionPrepaidNote: '{count} tomos · {paid, plural, one {# ya pagado} other {# ya pagados}}',
	conversationPreviewBookCreditBannerBestof: 'Tu libro ya está pagado: el Best Of está incluido. ¿Prefieres la colección completa? Solo pagas la diferencia.',
	conversationPreviewBookCreditBanner: 'Tu libro ya está pagado, con envío estándar incluido. Personalízalo y luego finaliza tu pedido.',
	conversationOrderButtonBookCreditRemaining: 'Finalizar mi libro · faltan {price}',
	conversationOrderButtonBookCreditIncluded: 'Finalizar mi libro · Incluido',
	conversationPreviewBookCreditOrderHint: '{credit} ya pagados · precio de catálogo {fullPrice}',
	conversationOrderButtonBookCredit: 'Finalizar mi libro',
	conversationPreviewStickyBookCredit: 'Libro ya pagado',
	paymentMethodBookCreditHint: 'Tu libro ya está pagado',
	cartTotalsBookCredit: 'Libro ya pagado',
	paymentMethodBookcredit: 'Libro pagado por adelantado',
  },
};
